
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import AlertBox from '../../Components/AlertBox';
// // 🕒 TIME FORMATTING FUNCTIONS (Same as DailyAttendance.js)
// // Format time to 12-hour format with AM/PM
// const formatTo12Hour = (time24) => {
//   if (!time24 || time24 === '-' || time24 === '--:--') return time24;

//   try {
//     const [hours, minutes] = time24.split(':').map(Number);
//     if (isNaN(hours) || isNaN(minutes)) return time24;

//     const period = hours >= 12 ? 'PM' : 'AM';
//     const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;

//     return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
//   } catch (error) {
//     return time24; // Return original if formatting fails
//   }
// };

// const formatTimeUTC = (time) => {
//   console.log("time", time);

//   if (!time) return '-';

//   try {
//     const date = new Date(time);
//     if (isNaN(date.getTime())) return '-';

//     // Use local time methods to preserve database time as-is (no UTC adjustment)
//     const hours = date.getHours();
//     const minutes = date.getMinutes();
//     const time24 = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
//     return formatTo12Hour(time24);
//   } catch (error) {
//     return '-';
//   }
// };


// // Format datetime-local input to display format
// const formatDateTimeForDisplay = (dateTimeString) => {
//   if (!dateTimeString) return 'Not recorded';

//   try {
//     const date = new Date(dateTimeString);
//     if (isNaN(date.getTime())) return 'Invalid time';

//     return date.toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     });
//   } catch (error) {
//     return 'Invalid time';
//   }
// };

// // 🕒 WORKING HOURS CALCULATION (Same as DailyAttendance.js)
// // Calculate work hours between punch in and punch out
// const calculateWorkHours = (punchIn, punchOut) => {
//   if (!punchIn || !punchOut) return '--:--';

//   try {
//     const inDate = new Date(punchIn);
//     const outDate = new Date(punchOut);

//     if (isNaN(inDate.getTime()) || isNaN(outDate.getTime())) return '--:--';

//     const diffMs = outDate - inDate;
//     if (diffMs <= 0) return '--:--';

//     const hours = Math.floor(diffMs / (1000 * 60 * 60));
//     const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

//     return `${hours}:${minutes.toString().padStart(2, '0')}`;
//   } catch (error) {
//     return '--:--';
//   }
// };

// // Calculate work hours from 24-hour time format (for compatibility)
// const calculateWorkHoursFromTime = (punchIn, punchOut) => {
//   if (!punchIn || !punchOut) return '--:--';

//   try {
//     // Handle both time strings and full datetime strings
//     let inTime, outTime;

//     if (punchIn.includes('T') || punchIn.includes(' ')) {
//       // Full datetime string
//       inTime = punchIn;
//       outTime = punchOut;
//     } else {
//       // Time only string (HH:MM format)
//       const today = new Date().toISOString().split('T')[0];
//       inTime = `${today}T${punchIn}:00`;
//       outTime = `${today}T${punchOut}:00`;
//     }

//     return calculateWorkHours(inTime, outTime);
//   } catch (error) {
//     return '--:--';
//   }
// };

// // Enhanced working time calculation with proper formatting
// const calculateEnhancedWorkingTime = (inTime, outTime) => {
//   if (!inTime || !outTime) return '--:--';

//   try {
//     const inDate = new Date(inTime);
//     const outDate = new Date(outTime);

//     if (isNaN(inDate.getTime()) || isNaN(outDate.getTime())) return '--:--';

//     const diffMs = outDate - inDate;
//     if (diffMs <= 0) return '--:--';

//     const totalMinutes = Math.floor(diffMs / (1000 * 60));
//     const hours = Math.floor(totalMinutes / 60);
//     const minutes = totalMinutes % 60;

//     // Format like DailyAttendance.js: "8:30", "7:45", etc.
//     return `${hours}:${minutes.toString().padStart(2, '0')}`;
//   } catch (error) {
//     return '--:--';
//   }
// };

// // 🔄 ENHANCED DEPARTMENTS DISPLAY COMPONENT
// // Clean department display for employees with multiple departments (no scrollbars)
// const ScrollingDepartments = ({ departments, employeeId }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);

//   useEffect(() => {
//     if (!departments || departments.length <= 1) return;

//     const interval = setInterval(() => {
//       setIsAnimating(true);

//       setTimeout(() => {
//         setCurrentIndex((prevIndex) =>
//           prevIndex === departments.length - 1 ? 0 : prevIndex + 1
//         );
//         setIsAnimating(false);
//       }, 300); // Smooth animation duration
//     }, 3000); // 3 second interval for better readability

//     return () => clearInterval(interval);
//   }, [departments]);

//   if (!departments || departments.length === 0) {
//     return (
//       <div className="font-semibold text-gray-800 py-1">
//         No Department
//       </div>
//     );
//   }

//   if (departments.length === 1) {
//     return (
//       <div className="font-semibold text-gray-800 py-1">
//         {departments[0]}
//       </div>
//     );
//   }

//   return (
//     <div className="relative min-h-[2rem] w-full">
//       {/* Current department display */}
//       <div
//         className={`transition-all duration-300 ease-in-out transform ${isAnimating ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
//           }`}
//       >
//         <div className="flex items-center justify-between w-full py-1">
//           <div className="font-semibold text-gray-800 flex-1 pr-2 leading-tight">
//             {departments[currentIndex]}
//           </div>
//           <div className="flex items-center space-x-1 flex-shrink-0">
//             {/* Department indicator dots */}
//             {departments.map((_, index) => (
//               <div
//                 key={index}
//                 className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${index === currentIndex
//                     ? 'bg-blue-500 scale-125'
//                     : 'bg-gray-300 scale-100'
//                   }`}
//               />
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Department counter badge */}
//       <div className="absolute -top-1 -right-1">
//         <span className="inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-blue-500 rounded-full">
//           {departments.length}
//         </span>
//       </div>

//       {/* Progress indicator */}
//       <div className="mt-1 w-full h-1 bg-gray-200 rounded-full overflow-hidden">
//         <div
//           className="h-full bg-gradient-to-r from-blue-400 to-blue-600 rounded-full transition-all duration-300 ease-out"
//           style={{
//             width: `${((currentIndex + 1) / departments.length) * 100}%`
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// // 📅 MONTHLY CALENDAR FUNCTIONS
// // Generate all dates for the specified month and year
// const generateMonthDates = (month = new Date().getMonth(), year = new Date().getFullYear()) => {
//   const currentDate = new Date();
//   const currentMonth = currentDate.getMonth();
//   const currentYear = currentDate.getFullYear();

//   // Get first and last day of specified month
//   const firstDay = new Date(year, month, 1);
//   const lastDay = new Date(year, month + 1, 0);

//   const dates = [];

//   // Generate all dates for the month
//   for (let date = new Date(firstDay); date <= lastDay; date.setDate(date.getDate() + 1)) {
//     const dateString = date.toISOString().split('T')[0]; // YYYY-MM-DD format
//     dates.push({
//       date: dateString,
//       dateObj: new Date(date),
//       dayName: date.toLocaleDateString('en-US', { weekday: 'short' }),
//       dayNumber: date.getDate(),
//       isToday: dateString === new Date().toISOString().split('T')[0],
//       isPast: date < new Date().setHours(0, 0, 0, 0),
//       isFuture: date > new Date().setHours(23, 59, 59, 999)
//     });
//   }

//   return dates;
// };

// // Merge attendance records with all month dates
// const mergeAttendanceWithMonthDates = (attendanceRecords = [], monthDates = [], holidays = [], selectedCompany = null) => {
//   console.log('🗓️ï MERGING ATTENDANCE WITH MONTH DATES:', {
//     attendanceRecords: attendanceRecords.length,
//     monthDates: monthDates.length,
//     holidays: holidays.length,
//     hasCompanyData: !!selectedCompany
//   });

//   // Get company weekly holidays
//   let weeklyHolidays = [];
//   if (selectedCompany && selectedCompany.weeklyHoliday) {
//     weeklyHolidays = Array.isArray(selectedCompany.weeklyHoliday)
//       ? selectedCompany.weeklyHoliday
//       : [selectedCompany.weeklyHoliday];
//   } else if (selectedCompany && selectedCompany.weeklyHolidays) {
//     weeklyHolidays = Array.isArray(selectedCompany.weeklyHolidays)
//       ? selectedCompany.weeklyHolidays
//       : [selectedCompany.weeklyHolidays];
//   }

//   // Convert day names to day numbers (0 = Sunday, 1 = Monday, etc.)
//   const dayNameToNumber = {
//     'sunday': 0, 'sun': 0,
//     'monday': 1, 'mon': 1,
//     'tuesday': 2, 'tue': 2, 'tues': 2,
//     'wednesday': 3, 'wed': 3,
//     'thursday': 4, 'thu': 4, 'thur': 4, 'thurs': 4,
//     'friday': 5, 'fri': 5,
//     'saturday': 6, 'sat': 6
//   };

//   const weeklyHolidayDayNumbers = weeklyHolidays.map(day =>
//     dayNameToNumber[day.toLowerCase()] !== undefined ? dayNameToNumber[day.toLowerCase()] : -1
//   ).filter(num => num !== -1);

//   console.log('📅 WEEKLY HOLIDAYS PROCESSED:', {
//     weeklyHolidays: weeklyHolidays,
//     weeklyHolidayDayNumbers: weeklyHolidayDayNumbers,
//     dayNames: weeklyHolidayDayNumbers.map(num => ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][num])
//   });

//   // Create a map of existing attendance records by date
//   const attendanceMap = {};
//   attendanceRecords.forEach(record => {
//     if (record.date) {
//       const recordDate = new Date(record.date).toISOString().split('T')[0];
//       attendanceMap[recordDate] = record;
//     } else if (record.inTime) {
//       // If no date field, extract from inTime
//       const recordDate = new Date(record.inTime).toISOString().split('T')[0];
//       attendanceMap[recordDate] = {
//         ...record,
//         date: recordDate
//       };
//     }
//   });

//   // Create a map of holidays by date
//   const holidayMap = {};
//   holidays.forEach(holiday => {
//     if (holiday.date) {
//       holidayMap[holiday.date] = holiday;
//     }
//   });

//   console.log('📊 ATTENDANCE MAP CREATED:', {
//     mappedDates: Object.keys(attendanceMap).length,
//     dates: Object.keys(attendanceMap)
//   });

//   console.log('🎉 HOLIDAY MAP CREATED:', {
//     mappedHolidays: Object.keys(holidayMap).length,
//     holidays: Object.keys(holidayMap)
//   });

//   // Merge month dates with attendance records, holiday information, and weekly holidays
//   const mergedData = monthDates.map(monthDate => {
//     const existingRecord = attendanceMap[monthDate.date];
//     const holidayInfo = holidayMap[monthDate.date];
//     const isCompanyHoliday = !!holidayInfo;

//     // Check if this date is a weekly holiday
//     const dateObj = new Date(monthDate.date);
//     const dayOfWeek = dateObj.getDay(); // 0 = Sunday, 1 = Monday, etc.
//     const isWeeklyHoliday = weeklyHolidayDayNumbers.includes(dayOfWeek);
//     const weeklyHolidayName = isWeeklyHoliday ? ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek] : null;

//     if (existingRecord) {
//       // Existing attendance record
//       return {
//         ...existingRecord,
//         ...monthDate,
//         hasAttendance: true,
//         status: existingRecord.status || 'Present',
//         displayInTime: existingRecord.displayInTime || (existingRecord.inTime ? formatTimeUTC(existingRecord.inTime) : null),
//         displayOutTime: existingRecord.displayOutTime || (existingRecord.outTime ? formatTimeUTC(existingRecord.outTime) : null),
//         workingTime: existingRecord.workingTime || (existingRecord.inTime && existingRecord.outTime ?
//           calculateEnhancedWorkingTime(existingRecord.inTime, existingRecord.outTime) : null),
//         // Add holiday information
//         isCompanyHoliday: isCompanyHoliday,
//         isWeeklyHoliday: isWeeklyHoliday,
//         isHoliday: isCompanyHoliday || isWeeklyHoliday, // Either company or weekly holiday
//         holidayInfo: holidayInfo,
//         holidayName: isCompanyHoliday ? holidayInfo.name : (isWeeklyHoliday ? `Weekly Holiday (${weeklyHolidayName})` : null),
//         holidayType: isCompanyHoliday ? holidayInfo.type : (isWeeklyHoliday ? 'Weekly' : null),
//         weeklyHolidayName: weeklyHolidayName
//       };
//     } else {
//       // No attendance record for this date - create synthetic record with proper IDs
//       const holidayStatus = isCompanyHoliday ? 'Company Holiday' : (isWeeklyHoliday ? 'Weekly Holiday' : null);
//       const finalStatus = monthDate.isFuture ? 'Future' : (holidayStatus || 'Absent');
//       const holidayNotes = isCompanyHoliday ? `Company Holiday: ${holidayInfo.name}` :
//         (isWeeklyHoliday ? `Weekly Holiday: ${weeklyHolidayName}` : 'No attendance record');

//       return {
//         ...monthDate,
//         id: `no-record-${monthDate.date}`,
//         hasAttendance: false,
//         status: finalStatus,
//         inTime: null,
//         outTime: null,
//         displayInTime: null,
//         displayOutTime: null,
//         workingTime: null,
//         inLocation: null,
//         outLocation: null,
//         notes: monthDate.isFuture ? 'Future date' : holidayNotes,
//         // Add synthetic flags to help with identification
//         isSynthetic: true,
//         needsEmployeeId: true,
//         needsCompanyId: true,
//         // Add holiday information
//         isCompanyHoliday: isCompanyHoliday,
//         isWeeklyHoliday: isWeeklyHoliday,
//         isHoliday: isCompanyHoliday || isWeeklyHoliday, // Either company or weekly holiday
//         holidayInfo: holidayInfo,
//         holidayName: isCompanyHoliday ? holidayInfo.name : (isWeeklyHoliday ? `Weekly Holiday (${weeklyHolidayName})` : null),
//         holidayType: isCompanyHoliday ? holidayInfo.type : (isWeeklyHoliday ? 'Weekly' : null),
//         weeklyHolidayName: weeklyHolidayName
//       };
//     }
//   });

//   console.log('✅ MERGED ATTENDANCE DATA:', {
//     totalDates: mergedData.length,
//     withAttendance: mergedData.filter(d => d.hasAttendance).length,
//     withoutAttendance: mergedData.filter(d => !d.hasAttendance).length,
//     futureDates: mergedData.filter(d => d.isFuture).length,
//     pastDates: mergedData.filter(d => d.isPast).length,
//     companyHolidayDates: mergedData.filter(d => d.isCompanyHoliday).length,
//     weeklyHolidayDates: mergedData.filter(d => d.isWeeklyHoliday).length,
//     totalHolidayDates: mergedData.filter(d => d.isHoliday).length
//   });

//   return mergedData;
// };

// // 📊 ATTENDANCE CALCULATION FUNCTIONS
// // Calculate current month attendance statistics for employee cards
// const calculateCurrentMonthAttendance = (employeeId, attendanceRecords = []) => {
//   const currentDate = new Date();
//   const currentMonth = currentDate.getMonth();
//   const currentYear = currentDate.getFullYear();

//   // Filter attendance records for current month
//   const currentMonthRecords = attendanceRecords.filter(record => {
//     if (!record.date && !record.inTime) return false;

//     const recordDate = new Date(record.date || record.inTime);
//     return recordDate.getMonth() === currentMonth && recordDate.getFullYear() === currentYear;
//   });

//   // Count present, absent, and other statuses
//   let presentCount = 0;
//   let absentCount = 0;
//   let lateCount = 0;
//   let halfDayCount = 0;
//   let incompleteCount = 0;

//   currentMonthRecords.forEach(record => {
//     const status = (record.status || '').toLowerCase().trim();

//     switch (status) {
//       case 'present':
//         presentCount++;
//         break;
//       case 'absent':
//         absentCount++;
//         break;
//       case 'late':
//         lateCount++;
//         presentCount++; // Late is still considered present
//         break;
//       case 'half-day':
//       case 'halfday':
//       case 'half day':
//         halfDayCount++;
//         presentCount++; // Half-day is considered present
//         break;
//       case 'incomplete':
//         incompleteCount++;
//         break;
//       default:
//         // If status is not clear, check if there's punch in time
//         if (record.inTime) {
//           presentCount++;
//         } else {
//           absentCount++;
//         }
//     }
//   });

//   // Calculate attendance rate
//   const totalAttendanceDays = presentCount + absentCount;
//   const attendanceRate = totalAttendanceDays > 0
//     ? Math.round((presentCount / totalAttendanceDays) * 100)
//     : 0;

//   return {
//     presentDays: presentCount,
//     absentDays: absentCount,
//     lateCount,
//     halfDayCount,
//     incompleteCount,
//     attendanceRate,
//     totalRecords: currentMonthRecords.length
//   };
// };

// // Calculate working minutes for attendance records
// const calculateWorkingMinutes = (inTime, outTime) => {
//   if (!inTime || !outTime) return 0;

//   try {
//     const inDate = new Date(inTime);
//     const outDate = new Date(outTime);

//     if (isNaN(inDate.getTime()) || isNaN(outDate.getTime())) return 0;

//     const diffMs = outDate - inDate;
//     if (diffMs <= 0) return 0;

//     return Math.floor(diffMs / (1000 * 60)); // Return minutes
//   } catch (error) {
//     return 0;
//   }
// };

// // 🕒 SHIFT-BASED STATUS CALCULATION
// // Calculate attendance status based on shift hours vs actual working hours
// const calculateShiftBasedStatus = (record, employeeShiftInfo) => {
//   // Reduced logging to prevent console spam
//   // console.log('🕒 CALCULATING SHIFT-BASED STATUS:', {
//   //   recordId: record.id || record._id,
//   //   inTime: record.inTime,
//   //   outTime: record.outTime,
//   //   shiftInfo: employeeShiftInfo
//   // });

//   // If no punch times, return absent
//   if (!record.inTime) {
//     return {
//       status: 'Absent',
//       reason: 'No punch in time recorded',
//       workingMinutes: 0,
//       shiftMinutes: 0,
//       completionPercentage: 0
//     };
//   }

//   // If no punch out, return incomplete
//   if (!record.outTime) {
//     return {
//       status: 'Incomplete',
//       reason: 'No punch out time recorded',
//       workingMinutes: 0,
//       shiftMinutes: 0,
//       completionPercentage: 0
//     };
//   }

//   // Calculate actual working minutes
//   const workingMinutes = calculateWorkingMinutes(record.inTime, record.outTime);

//   // Get shift duration (default to 8 hours = 480 minutes if no shift info)
//   let shiftMinutes = 480; // Default 8 hours

//   if (employeeShiftInfo && employeeShiftInfo.shiftStartTime && employeeShiftInfo.shiftEndTime) {
//     // Calculate shift duration from shift times
//     const shiftStart = new Date(`2000-01-01T${employeeShiftInfo.shiftStartTime}`);
//     const shiftEnd = new Date(`2000-01-01T${employeeShiftInfo.shiftEndTime}`);

//     if (!isNaN(shiftStart.getTime()) && !isNaN(shiftEnd.getTime())) {
//       const shiftDiffMs = shiftEnd - shiftStart;
//       if (shiftDiffMs > 0) {
//         shiftMinutes = Math.floor(shiftDiffMs / (1000 * 60));
//       }
//     }
//   } else if (employeeShiftInfo && employeeShiftInfo.workingHours) {
//     // Use working hours if available
//     shiftMinutes = employeeShiftInfo.workingHours * 60;
//   }

//   // Calculate completion percentage
//   const completionPercentage = shiftMinutes > 0 ? Math.round((workingMinutes / shiftMinutes) * 100) : 0;

//   // Reduced logging to prevent console spam
//   // console.log('📊 SHIFT CALCULATION RESULT:', {
//   //   workingMinutes,
//   //   shiftMinutes,
//   //   completionPercentage,
//   //   workingHours: (workingMinutes / 60).toFixed(2),
//   //   shiftHours: (shiftMinutes / 60).toFixed(2)
//   // });

//   // Determine status based on working hours vs shift hours (STRICT: 100% = Present, <100% = Half Day)
//   let status = 'Present';
//   let reason = 'Full shift completed';

//   if (completionPercentage >= 100) {
//     status = 'Present';
//     reason = `Completed full shift (${(workingMinutes / 60).toFixed(1)}h / ${(shiftMinutes / 60).toFixed(1)}h - ${completionPercentage}%)`;
//   } else if (workingMinutes > 0 && completionPercentage > 0) {
//     status = 'Half Day';
//     reason = `Incomplete shift (${completionPercentage}% completed - ${(workingMinutes / 60).toFixed(1)}h / ${(shiftMinutes / 60).toFixed(1)}h)`;
//   } else {
//     status = 'Absent';
//     reason = 'No valid working time recorded';
//   }

//   return {
//     status,
//     reason,
//     workingMinutes,
//     shiftMinutes,
//     completionPercentage,
//     workingHours: (workingMinutes / 60).toFixed(2),
//     shiftHours: (shiftMinutes / 60).toFixed(2)
//   };
// };

// const AttendanceReports = () => {
//   const [activeReport, setActiveReport] = useState('employeeCard');
//   const [selectedDepartment, setSelectedDepartment] = useState('all');
//   const [selectedCompany, setSelectedCompany] = useState('all');
//   const [companies, setCompanies] = useState([{ id: 'all', name: 'All Companies' }]);
//   const [selectedEmployee, setSelectedEmployee] = useState('all');
//   const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
//   const [employeeSearch, setEmployeeSearch] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [employees, setEmployees] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [departmentStats, setDepartmentStats] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedDeptEmployees, setSelectedDeptEmployees] = useState([]);
//   const [isDeptModalOpen, setIsDeptModalOpen] = useState(false);
//   const [selectedDeptName, setSelectedDeptName] = useState('');
//   const [shifts, setShifts] = useState([]);
//   const [showAlert, setShowAlert] = useState(false);

//   // DEPARTMENT HELPER FUNCTIONS (Same as AddEmployee.js)
//   const getDepartmentNames = (deptIdsOrId) => {
//     if (!deptIdsOrId) return ['N/A'];

//     let ids = [];
//     if (Array.isArray(deptIdsOrId)) {
//       ids = deptIdsOrId;
//     } else if (deptIdsOrId) {
//       ids = [deptIdsOrId];
//     }

//     if (departments.length === 0) {
//       if (ids.length > 0) {
//         console.warn('Departments not loaded yet. Raw IDs:', ids);
//         return ids.map(id => `ID: ${String(id)}`);
//       }
//       return ['Loading departments...'];
//     }

//     const stringIds = ids.map(id => String(id).trim());

//     const names = stringIds.slice(0, 2).map(idStr => {
//       const trimmedId = idStr;
//       const dept = departments.find(d => String(d._id).trim() === trimmedId);
//       if (dept) {
//         return dept.name || dept.departmentName || 'Unknown Department';
//       } else {
//         console.warn(`Department ID not found: ${trimmedId}. Available depts:`, departments.map(d => String(d._id)));
//         return `Unknown (${trimmedId})`;
//       }
//     });

//     if (stringIds.length > 2) {
//       names.push(`+${stringIds.length - 2} more`);
//     }

//     return names;
//   };

//   // Employee Report Card States
//   const [employeeReportData, setEmployeeReportData] = useState([]);
//   const [selectedEmployeeForReport, setSelectedEmployeeForReport] = useState(null);
//   const [attendanceRecords, setAttendanceRecords] = useState([]);
//   const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
//   const [isEditingAttendance, setIsEditingAttendance] = useState(false);
//   const [editingRecord, setEditingRecord] = useState(null);
//   const [loadingAttendance, setLoadingAttendance] = useState(false);
//   const [attendanceError, setAttendanceError] = useState(null);
//   const [notification, setNotification] = useState({ show: false, message: '', type: '' });

//   // Shift Information State
//   const [employeeShiftInfo, setEmployeeShiftInfo] = useState(null);
//   const [loadingShiftInfo, setLoadingShiftInfo] = useState(false);

//   // Filter States for Attendance Modal
//   const [selectedFilterMonth, setSelectedFilterMonth] = useState(new Date().getMonth());
//   const [selectedFilterYear, setSelectedFilterYear] = useState(new Date().getFullYear());
//   const [attendanceStatusFilter, setAttendanceStatusFilter] = useState('all'); // 'all', 'present', 'absent'

//   // Holiday States
//   const [holidays, setHolidays] = useState([]);
//   const [loadingHolidays, setLoadingHolidays] = useState(false);
//   const [holidaysError, setHolidaysError] = useState(null);

//   // Company Data State (for weekly holidays)
//   const [companyData, setCompanyData] = useState(null);

//   // View Toggle State (grid or card view)
//   const [viewMode, setViewMode] = useState('card'); // 'card' or 'grid'
//   const [deptViewMode, setDeptViewMode] = useState('card'); // 'card' or 'grid' for department view
//   const [attendanceViewMode, setAttendanceViewMode] = useState('table'); // 'table' or 'calendar' for attendance records

//   useEffect(() => {
//     const fetchCompanyAndData = async () => {
//       const companyId = localStorage.getItem('selectedCompanyId');
//       const companyName = localStorage.getItem('selectedCompanyName') || 'Your Company';

//       console.log('INITIALIZING COMPANY DATA:', { companyId, companyName });

//       if (companyId) {
//         setCompanies([{ id: companyId, name: companyName }]);
//         setSelectedCompany(companyId);

//         console.log('🚀 STARTING DATA FETCH FOR COMPANY:', companyId);

//         try {
//           await Promise.all([
//             fetchEmployees(companyId),
//             fetchDepartments(companyId),
//             fetchHolidays(),
//             fetchCompanyData(),
//             fetchEmployeeReportData(companyId)
//           ]);

//           console.log('✅ ALL DATA FETCH COMPLETED');
//         } catch (error) {
//           console.error('❌ ERROR IN DATA FETCH:', error);
//           setError(`Failed to load data: ${error.message}`);
//         }
//       } else {
//         console.warn('⚠️ NO COMPANY ID FOUND IN LOCALSTORAGE');
//         setError('No company selected. Please select a company first.');
//       }
//     };

//     fetchCompanyAndData();
//   }, []);

//   useEffect(() => {
//     if (activeReport === 'department' && departments.length > 0 && employees.length > 0) {
//       fetchDepartmentStats();
//     }
//   }, [activeReport, departments, employees, selectedDate]);

//   const fetchEmployees = async (companyId) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setError('No access token found. Please log in.');
//       setLoading(false);
//       return;
//     }

//     if (!companyId) {
//       setError('No company selected. Please select a company first.');
//       setLoading(false);
//       return;
//     }

//     try {
//       console.log('¡ FETCHING EMPLOYEES WITH DEPARTMENT DATA FOR COMPANY:', { companyId });

//       // Fetch employees with populated department data
//       const response = await axios.get(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${companyId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           timeout: 15000,
//           params: {
//             populate: 'department' // Request populated department data
//           }
//         }
//       );

//       console.log('👥 EMPLOYEES API RESPONSE:', {
//         status: response.status,
//         employeeCount: response.data?.length || 0,
//         sampleEmployeeDepartments: response.data?.slice(0, 3).map(emp => ({
//           id: emp._id,
//           name: emp.teamMemberName || emp.name,
//           department: emp.department,
//           departmentType: typeof emp.department
//         })) || []
//       });

//       // Fetch departments for lookup map (fallback mechanism)
//       let departmentsMap = {};
//       try {
//         const departmentsResponse = await axios.get(
//           `https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${companyId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//             timeout: 15000
//           }
//         );

//         console.log('DEPARTMENTS LOOKUP RESPONSE:', {
//           status: departmentsResponse.status,
//           departmentCount: departmentsResponse.data?.length || 0
//         });

//         // Create comprehensive lookup map for departments
//         if (Array.isArray(departmentsResponse.data)) {
//           departmentsResponse.data.forEach(dept => {
//             if (dept._id) {
//               const departmentName = dept.name || dept.departmentName || 'Unknown Department';
//               departmentsMap[dept._id] = {
//                 ...dept,
//                 name: departmentName,
//                 departmentName: departmentName
//               };
//               console.log('—‚ï MAPPED DEPARTMENT:', {
//                 id: dept._id,
//                 name: departmentName
//               });
//             }
//           });
//         }
//       } catch (deptErr) {
//         console.warn('⚠️ Failed to fetch departments for lookup:', deptErr.message);
//       }

//       console.log('📋 DEPARTMENTS MAP CREATED:', {
//         totalMapped: Object.keys(departmentsMap).length,
//         mappedIds: Object.keys(departmentsMap)
//       });

//       // Process employee data with enhanced department information
//       // Process employee data with enhanced department information
//       const processedEmployees = response.data.map((employee, index) => {
//         console.log(`👤 PROCESSING EMPLOYEE ${index + 1} DEPARTMENT:`, {
//           id: employee._id,
//           name: employee.teamMemberName || employee.name,
//           rawDepartment: employee.department,
//           departmentType: typeof employee.department,
//           isArray: Array.isArray(employee.department)
//         });

//         // Enhanced department information processing with multiple department support
//         let departmentInfo = null;
//         let departmentName = 'No Department';
//         let departmentNames = [];
//         let allDepartments = [];
//         let departmentIds = []; // NEW: Store raw department IDs

//         if (employee.department) {
//           if (Array.isArray(employee.department) && employee.department.length > 0) {
//             // Handle array of multiple departments - THIS IS YOUR CASE
//             console.log(`  📂 EMPLOYEE HAS ${employee.department.length} DEPARTMENTS:`, employee.department);

//             // Process each department ID in the array
//             departmentIds = employee.department.map(deptId => {
//               if (typeof deptId === 'object' && deptId._id) {
//                 return deptId._id; // Extract ID from object
//               }
//               return deptId; // Already an ID string
//             });

//             // Get department names from lookup map
//             const processedDepartments = departmentIds.map(deptId => {
//               const deptInfo = departmentsMap[deptId];
//               if (deptInfo) {
//                 const deptName = deptInfo.name || deptInfo.departmentName || 'Unknown Department';
//                 return {
//                   info: deptInfo,
//                   name: deptName,
//                   id: deptId
//                 };
//               } else {
//                 const fallbackName = `Unknown Department (${deptId})`;
//                 return {
//                   info: { _id: deptId, name: fallbackName },
//                   name: fallbackName,
//                   id: deptId
//                 };
//               }
//             }).filter(dept => dept.info !== null);

//             if (processedDepartments.length > 0) {
//               // Set primary department (first one)
//               departmentInfo = processedDepartments[0].info;
//               departmentName = processedDepartments[0].name;

//               // Collect all department names and info
//               departmentNames = processedDepartments.map(dept => dept.name);
//               allDepartments = processedDepartments.map(dept => dept.info);

//               console.log(`  ✅ PROCESSED ${processedDepartments.length} DEPARTMENTS FOR ${employee.teamMemberName}:`, {
//                 departmentIds: departmentIds,
//                 departmentNames: departmentNames
//               });
//             }
//           } else {
//             // Handle single department case (existing logic)
//             // ... keep your existing single department logic
//           }
//         }

//         return {
//           ...employee,
//           // Enhanced department information
//           department: departmentInfo, // Primary department
//           departmentName: departmentName, // Primary department name
//           // Multiple departments support
//           allDepartments: allDepartments, // Array of all department objects
//           departmentNames: departmentNames, // Array of all department names
//           departmentIds: departmentIds, // NEW: Array of raw department IDs
//           isMultipleDepartments: departmentNames.length > 1,
//           departmentCount: departmentNames.length,
//           // Display formatted department names
//           formattedDepartmentNames: departmentNames.length > 1
//             ? departmentNames.slice(0, 2).join(', ') + (departmentNames.length > 2 ? ` +${departmentNames.length - 2} more` : '')
//             : departmentNames[0] || 'No Department',
//           displayName: employee.teamMemberName || employee.name || 'Unknown Employee'
//         };
//       });

//       console.log('✅ PROCESSED EMPLOYEES WITH DEPARTMENT INFO:', {
//         totalProcessed: processedEmployees.length,
//         employeesWithDepartments: processedEmployees.filter(emp => emp.departmentName !== 'No Department').length
//       });

//       setEmployees([
//         { _id: 'all', teamMemberName: 'All Employees', department: 'all', departmentName: 'All Departments' },
//         ...processedEmployees.filter(emp => emp.isActive !== false)
//       ]);

//       console.log('✅ EMPLOYEES FETCHED AND SET WITH DEPARTMENT DATA:', {
//         totalEmployees: processedEmployees.length + 1, // +1 for 'All Employees'
//         departmentsAvailable: departments.length > 0
//       });

//     } catch (err) {
//       console.error('❌ ERROR FETCHING EMPLOYEES:', {
//         status: err.response?.status,
//         message: err.response?.data?.message || err.message,
//         companyId
//       });

//       if (err.response?.status === 401) {
//         console.log('🔄 Token expired, cleaning up...');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         setError('Session expired. Please log in again.');
//         window.location.href = '/login';
//         return;
//       }

//       setError(`Failed to fetch employees: ${err.response?.data?.message || err.message || 'Unable to connect to server'}`);
//     } finally {
//       setLoading(false);
//       console.log(' Fetch employees process completed');
//     }
//   };

//   const fetchDepartments = async (companyId) => {
//     if (!companyId) {
//       console.warn('⚠️ No companyId provided for department fetching');
//       return;
//     }

//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setError('No access token found. Please log in.');
//       setLoading(false);
//       return;
//     }

//     try {
//       console.log('FETCHING DEPARTMENTS FOR COMPANY:', { companyId });

//       const response = await axios.get(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${companyId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           timeout: 15000
//         }
//       );

//       console.log('📊 DEPARTMENTS API RESPONSE:', {
//         status: response.status,
//         dataLength: response.data?.length || 0,
//         departments: response.data?.map(dept => ({
//           id: dept._id,
//           name: dept.name || dept.departmentName,
//           company: dept.company
//         })) || []
//       });

//       // Process departments with proper field mapping
//       const processedDepartments = response.data.map(dept => ({
//         ...dept,
//         name: dept.name || dept.departmentName || 'Unknown Department',
//         departmentName: dept.name || dept.departmentName || 'Unknown Department'
//       }));

//       setDepartments([
//         { _id: 'all', name: 'All Departments', departmentName: 'All Departments' },
//         ...processedDepartments
//       ]);

//       console.log('✅ DEPARTMENTS PROCESSED AND SET:', {
//         totalCount: processedDepartments.length + 1, // +1 for 'All Departments'
//         departmentNames: processedDepartments.map(d => d.name)
//       });

//     } catch (err) {
//       console.error('❌ ERROR FETCHING DEPARTMENTS:', {
//         status: err.response?.status,
//         message: err.response?.data?.message || err.message,
//         companyId
//       });

//       if (err.response?.status === 401) {
//         console.log('🔄 Token expired, cleaning up...');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         setError('Session expired. Please log in again.');
//         window.location.href = '/login';
//         return;
//       }

//       setError(`Failed to fetch departments: ${err.response?.data?.message || err.message}`);
//       setDepartments([{ _id: 'all', name: 'All Departments', departmentName: 'All Departments' }]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchDepartmentStats = async () => {
//     const token = localStorage.getItem('authToken');
//     const companyId = localStorage.getItem('selectedCompanyId');

//     try {
//       console.log('📊 CALCULATING DEPARTMENT STATS WITH MULTIPLE DEPARTMENTS:');

//       // Calculate department-wise attendance statistics
//       const stats = await Promise.all(
//         departments
//           .filter(dept => dept._id !== 'all')
//           .map(async (dept) => {
//             // Get employees in this department
//             const deptEmployees = employees.filter(emp =>
//               emp._id !== 'all' && checkDepartmentMatch(emp, dept._id)
//             );

//             // DEBUG: Log department assignments
//             console.log(`DEPARTMENT ${dept.name} (${dept._id}):`, {
//               employeeCount: deptEmployees.length,
//               employees: deptEmployees.map(e => ({
//                 name: e.displayName,
//                 departments: e.departmentNames,
//                 departmentIds: e.departmentIds
//               }))
//             });

//             // Calculate attendance statistics
//             let presentCount = 0;
//             let absentCount = 0;
//             let lateCount = 0;
//             let halfDayCount = 0;

//             // Your existing attendance calculation logic here...
//             for (const employee of deptEmployees) {
//               try {
//                 if (token && companyId) {
//                   const attendanceResponse = await axios.get(
//                     `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/employee/${employee._id}`,
//                     {
//                       headers: { Authorization: `Bearer ${token}` },
//                       timeout: 5000,
//                       params: { date: selectedDate }
//                     }
//                   );

//                   const attendanceRecords = attendanceResponse.data || [];
//                   const todayRecord = attendanceRecords.find(record => {
//                     const recordDate = new Date(record.date || record.inTime).toISOString().split('T')[0];
//                     return recordDate === selectedDate;
//                   });

//                   if (todayRecord) {
//                     const status = (todayRecord.status || '').toLowerCase().trim();
//                     if (status === 'present' || (todayRecord.inTime && todayRecord.outTime)) {
//                       presentCount++;
//                     } else if (status === 'late') {
//                       lateCount++;
//                       presentCount++;
//                     } else if (status.includes('half')) {
//                       halfDayCount++;
//                       presentCount++;
//                     } else {
//                       absentCount++;
//                     }
//                   } else {
//                     absentCount++;
//                   }
//                 } else {
//                   absentCount++;
//                 }
//               } catch (empErr) {
//                 console.log(`⚠️ Could not fetch attendance for ${employee.displayName}:`, empErr.message);
//                 absentCount++;
//               }
//             }

//             const departmentStat = {
//               _id: dept._id,
//               name: dept.departmentName || dept.name,
//               present: presentCount,
//               absent: absentCount,
//               late: lateCount,
//               halfDay: halfDayCount,
//               employees: deptEmployees.length,
//               attendanceRate: deptEmployees.length > 0
//                 ? Math.round((presentCount / deptEmployees.length) * 100)
//                 : 0
//             };

//             console.log(`📈 FINAL STATS FOR ${dept.name}:`, departmentStat);
//             return departmentStat;
//           })
//       );

//       console.log('✅ FINAL DEPARTMENT STATS:', stats);
//       setDepartmentStats(stats);
//     } catch (err) {
//       console.error('❌ Error calculating department stats:', err);

//       // Enhanced fallback with better counting
//       const fallbackStats = departments
//         .filter(dept => dept._id !== 'all')
//         .map((dept) => {
//           const employeeCount = employees.filter(emp =>
//             emp._id !== 'all' && checkDepartmentMatch(emp, dept._id)
//           ).length;

//           console.log(`🔄 FALLBACK STATS FOR ${dept.name}:`, {
//             employeeCount,
//             departmentId: dept._id
//           });

//           return {
//             _id: dept._id,
//             name: dept.departmentName || dept.name,
//             present: 0,
//             absent: employeeCount,
//             late: 0,
//             halfDay: 0,
//             employees: employeeCount,
//             attendanceRate: 0
//           };
//         });

//       setDepartmentStats(fallbackStats);
//     }
//   };


//   // State for attendance data
//   const [attendanceData, setAttendanceData] = useState({
//     employee: [],
//     lateAbsent: [],
//     workSummary: [],
//     dailyAttendance: []
//   });

//   // API functions to fetch attendance data
//   const fetchAttendanceData = async (companyId) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setError('No access token found. Please log in.');
//       return;
//     }

//     try {

//       setAttendanceData({
//         employee: [], // employeeResponse.data || []
//         lateAbsent: [], // lateAbsentResponse.data || []
//         workSummary: [], // workSummaryResponse.data || []
//         dailyAttendance: [] // dailyAttendanceResponse.data || []
//       });
//     } catch (err) {
//       console.error('Error fetching attendance data:', err);
//       setError(`Failed to fetch attendance data: ${err.response?.data?.message || err.message}`);
//     }
//   };

//   // 🎯 EMPLOYEE REPORT API FUNCTIONS
//   const fetchEmployeeReportData = async (companyId) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setError('No access token found. Please log in.');
//       return;
//     }

//     try {
//       console.log('🚀 FETCHING EMPLOYEE REPORT DATA:', { companyId });

//       // Fetch employees with populated department data
//       const response = await axios.get(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${companyId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           timeout: 15000,
//           params: {
//             populate: 'department' // Request populated data
//           }
//         }
//       );

//       console.log('📊 EMPLOYEE REPORT RESPONSE:', {
//         status: response.status,
//         employeeCount: response.data?.length || 0,
//         sampleEmployee: response.data?.[0] ? {
//           id: response.data[0]._id,
//           name: response.data[0].teamMemberName || response.data[0].name,
//           department: response.data[0].department,
//           departmentType: typeof response.data[0].department
//         } : null
//       });

//       // Fetch departments for fallback lookup
//       const departmentsResponse = await axios.get(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${companyId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//         timeout: 15000
//       }).catch(err => {
//         console.warn('⚠️ Failed to fetch departments for lookup:', err.message);
//         return { data: [] };
//       });

//       console.log('DEPARTMENTS LOOKUP RESPONSE:', {
//         status: departmentsResponse.status || 'Failed',
//         departmentCount: departmentsResponse.data?.length || 0,
//         departments: departmentsResponse.data?.map(dept => ({
//           id: dept._id,
//           name: dept.name || dept.departmentName
//         })) || []
//       });

//       // Create comprehensive lookup map for departments (same as AddEmployee.js)
//       const departmentsMap = {};
//       if (Array.isArray(departmentsResponse.data)) {
//         departmentsResponse.data.forEach(dept => {
//           if (dept._id) {
//             const departmentName = dept.name || dept.departmentName || 'Unknown Department';
//             departmentsMap[dept._id] = {
//               ...dept,
//               name: departmentName,
//               departmentName: departmentName
//             };
//             console.log('—‚ï MAPPED DEPARTMENT:', {
//               id: dept._id,
//               name: departmentName,
//               originalName: dept.name,
//               originalDepartmentName: dept.departmentName
//             });
//           }
//         });
//       }

//       console.log('📋 FINAL DEPARTMENTS MAP:', {
//         totalMapped: Object.keys(departmentsMap).length,
//         mappedIds: Object.keys(departmentsMap)
//       });

//       // Process employee data with enhanced information (same as AddEmployee.js)
//       const processedData = response.data.map((employee, index) => {
//         console.log(`👤 PROCESSING EMPLOYEE ${index + 1}:`, {
//           id: employee._id,
//           name: employee.teamMemberName || employee.name,
//           email: employee.email,
//           phone: employee.phone || employee.phoneNumber || employee.mobile,
//           department: employee.department,
//           departmentType: typeof employee.department,
//           departmentId: employee.department?._id || employee.department
//         });

//         // Enhanced department information processing with multiple department support
//         let departmentInfo = null;
//         let departmentName = 'No Department';
//         let departmentNames = [];
//         let allDepartments = [];
//         let departmentProcessingLog = {
//           originalDepartment: employee.department,
//           departmentType: typeof employee.department,
//           processingMethod: 'none',
//           isMultipleDepartments: false
//         };

//         if (employee.department) {
//           if (typeof employee.department === 'object' && !Array.isArray(employee.department) && (employee.department.name || employee.department.departmentName)) {
//             // Single populated object
//             departmentInfo = {
//               ...employee.department,
//               name: employee.department.name || employee.department.departmentName,
//               departmentName: employee.department.name || employee.department.departmentName
//             };
//             departmentName = departmentInfo.name;
//             departmentNames = [departmentName];
//             allDepartments = [departmentInfo];
//             departmentProcessingLog.processingMethod = 'single_populated_object';
//             departmentProcessingLog.foundName = departmentName;
//           } else if (typeof employee.department === 'string' && employee.department.trim()) {
//             // Single string ID - use lookup map
//             const deptId = employee.department.trim();
//             departmentInfo = departmentsMap[deptId];
//             departmentProcessingLog.processingMethod = 'single_lookup_map';
//             departmentProcessingLog.lookupId = deptId;
//             departmentProcessingLog.foundInMap = !!departmentInfo;

//             if (departmentInfo) {
//               departmentName = departmentInfo.name || departmentInfo.departmentName || 'Unknown Department';
//               departmentNames = [departmentName];
//               allDepartments = [departmentInfo];
//             } else {
//               // Fallback for unknown department ID
//               departmentName = `Unknown Department (${deptId})`;
//               departmentInfo = {
//                 _id: deptId,
//                 name: departmentName,
//                 departmentName: departmentName
//               };
//               departmentNames = [departmentName];
//               allDepartments = [departmentInfo];
//               departmentProcessingLog.usedFallback = true;
//             }
//           } else if (Array.isArray(employee.department) && employee.department.length > 0) {
//             // Handle array of multiple departments
//             departmentProcessingLog.processingMethod = 'multiple_departments_array';
//             departmentProcessingLog.isMultipleDepartments = true;
//             departmentProcessingLog.departmentCount = employee.department.length;

//             const processedDepartments = employee.department.map((dept, deptIndex) => {
//               if (typeof dept === 'object' && (dept.name || dept.departmentName)) {
//                 // Populated department object
//                 const deptName = dept.name || dept.departmentName;
//                 const deptInfo = {
//                   ...dept,
//                   name: deptName,
//                   departmentName: deptName
//                 };
//                 console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (Object):`, { id: dept._id, name: deptName });
//                 return { info: deptInfo, name: deptName };
//               } else if (typeof dept === 'string' && dept.trim()) {
//                 // Department ID string
//                 const deptId = dept.trim();
//                 const deptInfo = departmentsMap[deptId];
//                 if (deptInfo) {
//                   const deptName = deptInfo.name || deptInfo.departmentName || 'Unknown Department';
//                   console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (ID Resolved):`, { id: deptId, name: deptName });
//                   return { info: deptInfo, name: deptName };
//                 } else {
//                   const fallbackName = `Unknown Department (${deptId})`;
//                   const fallbackInfo = { _id: deptId, name: fallbackName, departmentName: fallbackName };
//                   console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (ID Unresolved):`, { id: deptId, name: fallbackName });
//                   return { info: fallbackInfo, name: fallbackName };
//                 }
//               } else {
//                 console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (Invalid):`, dept);
//                 return null;
//               }
//             }).filter(dept => dept !== null);

//             if (processedDepartments.length > 0) {
//               // Set primary department (first one)
//               departmentInfo = processedDepartments[0].info;
//               departmentName = processedDepartments[0].name;

//               // Collect all department names and info
//               departmentNames = processedDepartments.map(dept => dept.name);
//               allDepartments = processedDepartments.map(dept => dept.info);

//               console.log(`  ✅ EMPLOYEE CARD PROCESSED ${processedDepartments.length} DEPARTMENTS:`, {
//                 employeeId: employee._id,
//                 primaryDepartment: departmentName,
//                 allDepartmentNames: departmentNames
//               });
//             } else {
//               departmentName = 'No Valid Departments';
//               departmentNames = [departmentName];
//               allDepartments = [];
//             }
//           }
//         }

//         console.log('EMPLOYEE CARD DEPARTMENT PROCESSING RESULT:', {
//           employeeId: employee._id,
//           employeeName: employee.teamMemberName || employee.name,
//           ...departmentProcessingLog,
//           primaryDepartmentName: departmentName,
//           allDepartmentNames: departmentNames,
//           departmentCount: departmentNames.length,
//           isMultipleDepartments: departmentNames.length > 1,
//           formattedDisplay: departmentNames.length > 1
//             ? departmentNames.slice(0, 2).join(', ') + (departmentNames.length > 2 ? ` +${departmentNames.length - 2} more` : '')
//             : departmentNames[0] || 'No Department'
//         });

//         // Get phone number from various possible fields (same as AddEmployee.js)
//         const phoneNumber = employee.phone ||
//           employee.phoneNumber ||
//           employee.mobile ||
//           employee.contactNumber ||
//           employee.mobileNumber ||
//           'No phone provided';

//         const processedEmployee = {
//           ...employee,
//           // Enhanced contact information
//           displayName: employee.teamMemberName || employee.name || 'Unknown Employee',
//           email: employee.email || 'No email provided',
//           phone: phoneNumber,

//           // Enhanced department information with multiple department support
//           department: departmentInfo, // Primary department
//           departmentName: departmentName, // Primary department name
//           departmentId: departmentInfo?._id || null, // Primary department ID
//           // Multiple departments support
//           allDepartments: allDepartments, // Array of all department objects
//           departmentNames: departmentNames, // Array of all department names
//           isMultipleDepartments: departmentNames.length > 1,
//           departmentCount: departmentNames.length,
//           // Display formatted department names
//           formattedDepartmentNames: departmentNames.length > 1
//             ? departmentNames.slice(0, 2).join(', ') + (departmentNames.length > 2 ? ` +${departmentNames.length - 2} more` : '')
//             : departmentNames[0] || 'No Department',

//           // Attendance statistics (will be calculated later)
//           attendanceCount: 0,
//           presentDays: 0,
//           absentDays: 0,
//           lateDays: 0,
//           halfDays: 0,
//           incompleteDays: 0,
//           attendanceRate: 0
//         };

//         console.log('✅ FINAL PROCESSED EMPLOYEE CARD:', {
//           id: processedEmployee._id,
//           name: processedEmployee.displayName,
//           email: processedEmployee.email,
//           phone: processedEmployee.phone,
//           primaryDepartmentName: processedEmployee.departmentName,
//           allDepartmentNames: processedEmployee.departmentNames,
//           departmentCount: processedEmployee.departmentCount,
//           isMultipleDepartments: processedEmployee.isMultipleDepartments,
//           formattedDepartmentNames: processedEmployee.formattedDepartmentNames
//         });

//         return processedEmployee;
//       });

//       // 📊 FETCH ATTENDANCE DATA FOR EACH EMPLOYEE
//       console.log('📊 FETCHING ATTENDANCE DATA FOR ALL EMPLOYEES...');

//       const employeesWithAttendance = await Promise.all(
//         processedData.map(async (employee) => {
//           try {
//             // Fetch attendance records for this employee
//             const attendanceResponse = await axios.get(
//               `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/employee/${employee._id}`,
//               {
//                 headers: { Authorization: `Bearer ${token}` },
//                 timeout: 10000,
//                 params: { company: companyId }
//               }
//             ).catch(async (err) => {
//               // Fallback to general attendance endpoint
//               console.log(`⚠️ Fallback attendance fetch for ${employee.displayName}`);
//               const fallbackResponse = await axios.get(
//                 'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/',
//                 {
//                   headers: { Authorization: `Bearer ${token}` },
//                   timeout: 10000,
//                   params: {
//                     employee: employee._id,
//                     company: companyId
//                   }
//                 }
//               );
//               return fallbackResponse;
//             });

//             // Process attendance data
//             let attendanceRecords = [];
//             if (Array.isArray(attendanceResponse.data)) {
//               attendanceRecords = attendanceResponse.data;
//             } else if (attendanceResponse.data?.data && Array.isArray(attendanceResponse.data.data)) {
//               attendanceRecords = attendanceResponse.data.data;
//             } else if (attendanceResponse.data?.attendance && Array.isArray(attendanceResponse.data.attendance)) {
//               attendanceRecords = attendanceResponse.data.attendance;
//             } else if (attendanceResponse.data?.records && Array.isArray(attendanceResponse.data.records)) {
//               attendanceRecords = attendanceResponse.data.records;
//             }

//             // Filter records for this employee and company
//             const filteredRecords = attendanceRecords.filter(record => {
//               const recordEmployeeId = record.employee?._id || record.employee;
//               const recordCompanyId = record.company?._id || record.company;
//               return recordEmployeeId === employee._id &&
//                 (!companyId || recordCompanyId === companyId);
//             });

//             console.log(`📊 ATTENDANCE DATA FOR ${employee.displayName}:`, {
//               totalRecords: attendanceRecords.length,
//               filteredRecords: filteredRecords.length,
//               employeeId: employee._id,
//               companyId
//             });

//             // Calculate current month attendance statistics
//             const attendanceStats = calculateCurrentMonthAttendance(employee._id, filteredRecords);

//             return {
//               ...employee,
//               // Update with real attendance data
//               attendanceCount: filteredRecords.length,
//               presentDays: attendanceStats.presentDays,
//               absentDays: attendanceStats.absentDays,
//               lateCount: attendanceStats.lateCount,
//               halfDayCount: attendanceStats.halfDayCount,
//               incompleteCount: attendanceStats.incompleteCount,
//               attendanceRate: attendanceStats.attendanceRate,
//               totalRecords: attendanceStats.totalRecords,
//               // Store raw attendance records for popup modal
//               attendanceRecords: filteredRecords
//             };

//           } catch (attendanceErr) {
//             console.warn(`⚠️ Failed to fetch attendance for ${employee.displayName}:`, attendanceErr.message);

//             // Return employee with default attendance values
//             return {
//               ...employee,
//               attendanceCount: 0,
//               presentDays: 0,
//               absentDays: 0,
//               lateCount: 0,
//               halfDayCount: 0,
//               incompleteCount: 0,
//               attendanceRate: 0,
//               totalRecords: 0,
//               attendanceRecords: []
//             };
//           }
//         })
//       );

//       setEmployeeReportData(employeesWithAttendance);
//       console.log('🎉 EMPLOYEE REPORT DATA SET WITH ATTENDANCE:', {
//         totalEmployees: employeesWithAttendance.length,
//         employeesWithAttendance: employeesWithAttendance.filter(emp => emp.totalRecords > 0).length,
//         attendanceSummary: employeesWithAttendance.map(emp => ({
//           name: emp.displayName,
//           present: emp.presentDays,
//           absent: emp.absentDays,
//           rate: emp.attendanceRate
//         }))
//       });

//     } catch (err) {
//       console.error('❌ Error fetching employee report data:', err);
//       setError(`Failed to fetch employee report data: ${err.response?.data?.message || err.message}`);

//       if (err.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         window.location.href = '/login';
//       }
//     }
//   };

//   // ¡ ENHANCED ATTENDANCE API FUNCTIONS
//   const fetchEmployeeAttendance = async (employeeId, companyId = null) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       showNotification('No access token found. Please log in.', 'error');
//       return;
//     }

//     setLoadingAttendance(true);
//     setAttendanceError(null);

//     try {
//       console.log('🔍 FETCHING ATTENDANCE FOR EMPLOYEE:', { employeeId, companyId });

//       // Try multiple endpoints for better data retrieval
//       let response;
//       const currentCompanyId = companyId || localStorage.getItem('selectedCompanyId');

//       try {
//         // First try employee-specific endpoint
//         response = await axios.get(
//           `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/employee/${employeeId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//             timeout: 15000,
//             params: currentCompanyId ? { company: currentCompanyId } : {}
//           }
//         );
//         console.log('¡ EMPLOYEE ATTENDANCE RESPONSE:', response.data);
//       } catch (employeeErr) {
//         console.warn('⚠️ Employee-specific endpoint failed, trying general endpoint:', employeeErr.message);

//         // Fallback to general attendance endpoint with filtering
//         response = await axios.get(
//           'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/',
//           {
//             headers: { Authorization: `Bearer ${token}` },
//             timeout: 15000,
//             params: currentCompanyId ? { company: currentCompanyId } : {}
//           }
//         );
//         console.log('¡ ALL ATTENDANCE RESPONSE:', response.data);
//       }

//       // Process response data
//       let allRecords = [];
//       if (Array.isArray(response.data)) {
//         allRecords = response.data;
//       } else if (response.data.data && Array.isArray(response.data.data)) {
//         allRecords = response.data.data;
//       } else if (response.data.attendance && Array.isArray(response.data.attendance)) {
//         allRecords = response.data.attendance;
//       } else if (response.data.records && Array.isArray(response.data.records)) {
//         allRecords = response.data.records;
//       }

//       // Filter by employee ID if we got all records
//       const employeeRecords = allRecords.filter(record => {
//         const recordEmployeeId = record.employee?._id || record.employee || record.employeeId;
//         return recordEmployeeId === employeeId;
//       });

//       console.log('🎯 FILTERED EMPLOYEE RECORDS:', employeeRecords.length);

//       // Enhanced record processing with better field mapping and time formatting
//       const processedRecords = employeeRecords.map(record => {
//         // Process times to ensure proper formatting
//         const inTime = record.inTime || null;
//         const outTime = record.outTime || null;

//         const processedRecord = {
//           ...record,
//           id: record._id || record.id,
//           employeeId: record.employee?._id || record.employee || record.employeeId || employeeId,
//           companyId: record.company?._id || record.company || record.companyId || currentCompanyId,
//           date: record.date || (inTime ? inTime.split('T')[0] : new Date().toISOString().split('T')[0]),
//           inTime: inTime,
//           outTime: outTime,
//           inLocation: record.inLocation || null,
//           outLocation: record.outLocation || null,
//           inPhoto: record.inPhoto || null,
//           outPhoto: record.outPhoto || null,
//           workingTime: record.workingTime || calculateEnhancedWorkingTime(inTime, outTime),
//           status: record.status || calculateAttendanceStatus(record),
//           notes: record.notes || record.remarks || '',
//           isEditable: true,
//           // Add formatted display times (same as DailyAttendance.js)
//           displayInTime: inTime ? formatTimeUTC(inTime) : '-',
//           displayOutTime: outTime ? formatTimeUTC(outTime) : '-'
//         };

//         console.log('📊 PROCESSED RECORD:', {
//           id: processedRecord.id,
//           date: processedRecord.date,
//           inTime: processedRecord.inTime,
//           outTime: processedRecord.outTime,
//           status: processedRecord.status,
//           workingTime: processedRecord.workingTime
//         });

//         return processedRecord;
//       }).sort((a, b) => new Date(b.date) - new Date(a.date));

//       setAttendanceRecords(processedRecords);
//       console.log('✅ ATTENDANCE RECORDS SET:', processedRecords.length, 'records for employee', employeeId);

//       return processedRecords;

//     } catch (err) {
//       console.error('❌ Error fetching attendance:', err);
//       const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch attendance records';
//       setAttendanceError(errorMessage);
//       showNotification(errorMessage, 'error');

//       if (err.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         window.location.href = '/login';
//       }

//       return [];
//     } finally {
//       setLoadingAttendance(false);
//     }
//   };

//   //  CREATE ATTENDANCE
//   const createAttendance = async (attendanceData) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       console.error('❌ CREATE ATTENDANCE ERROR: No access token found');
//       showNotification('No access token found. Please log in.', 'error');
//       return false;
//     }

//     try {
//       console.log('🚀 CREATING ATTENDANCE RECORD:');
//       console.log('📋 Request Data:', JSON.stringify(attendanceData, null, 2));
//       console.log('🔍Token Present:', !!token);
//       console.log('Œ API Endpoint:', 'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/');

//       // Validate required fields before sending
//       const validationErrors = [];
//       if (!attendanceData.employee) validationErrors.push('Employee ID is missing');
//       if (!attendanceData.company) validationErrors.push('Company ID is missing');
//       if (!attendanceData.date) validationErrors.push('Date is missing');

//       if (validationErrors.length > 0) {
//         console.error('❌ VALIDATION ERRORS:', validationErrors);
//         showNotification(`Validation errors: ${validationErrors.join(', ')}`, 'error');
//         return false;
//       }

//       console.log('✅ Validation passed, sending request...');

//       const response = await axios.post(
//         'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/',
//         attendanceData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           },
//           timeout: 15000
//         }
//       );

//       console.log('✅ ATTENDANCE CREATED SUCCESSFULLY:');
//       console.log('📊 Response Status:', response.status);
//       console.log('📋 Response Data:', JSON.stringify(response.data, null, 2));
//       console.log('🎉 Record ID:', response.data?._id || response.data?.id);

//       showNotification('Attendance record created successfully!', 'success');

//       // Refresh attendance records
//       if (selectedEmployeeForReport) {
//         console.log('🔄 Refreshing attendance records for employee:', selectedEmployeeForReport._id);
//         await fetchEmployeeAttendance(selectedEmployeeForReport._id);
//       }

//       return true;
//     } catch (err) {
//       console.error('❌ CREATE ATTENDANCE ERROR:');
//       console.error('🔍 Error Type:', err.name);
//       console.error(' Error Message:', err.message);
//       console.error('Œ Request URL:', err.config?.url);
//       console.error('📋 Request Data:', err.config?.data);
//       console.error('📊 Response Status:', err.response?.status);
//       console.error('📋 Response Data:', JSON.stringify(err.response?.data, null, 2));
//       console.error('🔧 Full Error Object:', err);

//       let errorMessage = 'Failed to create attendance record';

//       if (err.response?.status === 400) {
//         errorMessage = `Bad Request: ${err.response?.data?.message || 'Invalid data provided'}`;
//         console.error('❌ BAD REQUEST DETAILS:', err.response?.data);
//       } else if (err.response?.status === 401) {
//         errorMessage = 'Unauthorized: Please log in again';
//         console.error('❌ UNAUTHORIZED: Token may be expired');
//       } else if (err.response?.status === 403) {
//         errorMessage = 'Forbidden: You do not have permission to create attendance records';
//         console.error('❌ FORBIDDEN: Check user permissions');
//       } else if (err.response?.status === 500) {
//         errorMessage = `Server Error: ${err.response?.data?.message || 'Internal server error'}`;
//         console.error('❌ SERVER ERROR: Check server logs');
//       } else if (err.code === 'ECONNABORTED') {
//         errorMessage = 'Request timeout: Server took too long to respond';
//         console.error('❌ TIMEOUT ERROR: Request exceeded 15 seconds');
//       } else if (err.code === 'NETWORK_ERROR') {
//         errorMessage = 'Network error: Check your internet connection';
//         console.error('❌ NETWORK ERROR: Connection failed');
//       }

//       showNotification(errorMessage, 'error');

//       if (err.response?.status === 401) {
//         console.log('🔄 Clearing auth tokens and redirecting to login');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         window.location.href = '/login';
//       }

//       return false;
//     }
//   };

//   // ✅ï ENHANCED UPDATE ATTENDANCE
//   const updateAttendance = async (attendanceId, attendanceData) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       showNotification('No access token found. Please log in.', 'error');
//       return false;
//     }

//     try {
//       console.log('🔄 UPDATING ATTENDANCE RECORD:');
//       console.log('†Attendance ID:', attendanceId);
//       console.log('📋 Request Data:', JSON.stringify(attendanceData, null, 2));
//       console.log('🔍Token Present:', !!token);
//       console.log('Œ API Endpoint:', `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/${attendanceId}`);

//       // Validate required fields
//       const validationErrors = [];
//       if (!attendanceId) validationErrors.push('Attendance ID is missing');
//       if (!attendanceData.date) validationErrors.push('Date is required');
//       if (!attendanceData.employee && !attendanceData.employeeId) validationErrors.push('Employee is required');
//       if (!attendanceData.company && !attendanceData.companyId) validationErrors.push('Company is required');

//       if (validationErrors.length > 0) {
//         console.error('❌ VALIDATION ERRORS:', validationErrors);
//         showNotification(`Validation errors: ${validationErrors.join(', ')}`, 'error');
//         return false;
//       }

//       console.log('✅ Validation passed, preparing update data...');

//       // Prepare data for update
//       const updateData = {
//         ...attendanceData,
//         employee: attendanceData.employee || attendanceData.employeeId,
//         company: attendanceData.company || attendanceData.companyId,
//         workingTime: attendanceData.workingTime || calculateWorkingTime(attendanceData.inTime, attendanceData.outTime)
//       };

//       // Remove undefined fields
//       Object.keys(updateData).forEach(key => {
//         if (updateData[key] === undefined || updateData[key] === null) {
//           delete updateData[key];
//         }
//       });

//       console.log('📤 SENDING UPDATE DATA:', JSON.stringify(updateData, null, 2));
//       console.log('🔧 Working Time Calculated:', updateData.workingTime);

//       const response = await axios.put(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/${attendanceId}`,
//         updateData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           },
//           timeout: 15000
//         }
//       );

//       console.log('✅ ATTENDANCE UPDATED SUCCESSFULLY:');
//       console.log('📊 Response Status:', response.status);
//       console.log('📋 Response Data:', JSON.stringify(response.data, null, 2));
//       console.log('🎉 Updated Record ID:', response.data?._id || response.data?.id);

//       showNotification('Attendance record updated successfully!', 'success');

//       // Refresh attendance records
//       if (selectedEmployeeForReport) {
//         console.log('🔄 Refreshing attendance records for employee:', selectedEmployeeForReport._id);
//         await fetchEmployeeAttendance(selectedEmployeeForReport._id);
//       }

//       return true;
//     } catch (err) {
//       console.error('❌ UPDATE ATTENDANCE ERROR:');
//       console.error('🔍 Error Type:', err.name);
//       console.error(' Error Message:', err.message);
//       console.error('†Attendance ID:', attendanceId);
//       console.error('Œ Request URL:', err.config?.url);
//       console.error('📋 Request Data:', err.config?.data);
//       console.error('📊 Response Status:', err.response?.status);
//       console.error('📋 Response Data:', JSON.stringify(err.response?.data, null, 2));
//       console.error('🔧 Full Error Object:', err);

//       let errorMessage = 'Failed to update attendance record';

//       if (err.response?.status === 400) {
//         errorMessage = `Bad Request: ${err.response?.data?.message || 'Invalid data provided'}`;
//         console.error('❌ BAD REQUEST DETAILS:', err.response?.data);
//       } else if (err.response?.status === 401) {
//         errorMessage = 'Unauthorized: Please log in again';
//         console.error('❌ UNAUTHORIZED: Token may be expired');
//       } else if (err.response?.status === 403) {
//         errorMessage = 'Forbidden: You do not have permission to update attendance records';
//         console.error('❌ FORBIDDEN: Check user permissions');
//       } else if (err.response?.status === 404) {
//         errorMessage = `Record not found: Attendance record with ID ${attendanceId} does not exist`;
//         console.error('❌ NOT FOUND: Record may have been deleted');
//       } else if (err.response?.status === 500) {
//         errorMessage = `Server Error: ${err.response?.data?.message || 'Internal server error'}`;
//         console.error('❌ SERVER ERROR: Check server logs');
//       } else if (err.code === 'ECONNABORTED') {
//         errorMessage = 'Request timeout: Server took too long to respond';
//         console.error('❌ TIMEOUT ERROR: Request exceeded 15 seconds');
//       } else if (err.code === 'NETWORK_ERROR') {
//         errorMessage = 'Network error: Check your internet connection';
//         console.error('❌ NETWORK ERROR: Connection failed');
//       }

//       showNotification(errorMessage, 'error');

//       if (err.response?.status === 401) {
//         console.log('🔄 Clearing auth tokens and redirecting to login');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         window.location.href = '/login';
//       }

//       return false;
//     }
//   };

//   const [employeeDepartments, setEmployeeDepartments] = useState([]);

//   // 🔧 HELPER FUNCTIONS
//   const calculateAttendanceStatus = (record) => {
//     if (!record.inTime) return 'Absent';
//     if (!record.outTime) return 'Incomplete';

//     const workingMinutes = calculateWorkingMinutes(record.inTime, record.outTime);
//     if (workingMinutes < 240) return 'Half-day'; // Less than 4 hours
//     if (workingMinutes >= 480) return 'Present'; // 8+ hours
//     return 'Present';
//   };

//   const calculateWorkingTime = (inTime, outTime) => {
//     return calculateEnhancedWorkingTime(inTime, outTime);
//   };

//   const calculateWorkingMinutes = (inTime, outTime) => {
//     if (!inTime || !outTime) return 0;

//     const inDate = new Date(inTime);
//     const outDate = new Date(outTime);
//     const diffMs = outDate - inDate;

//     return Math.floor(diffMs / (1000 * 60));
//   };

//   // 📢 NOTIFICATION SYSTEM
//   const showNotification = (message, type = 'info') => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: '', type: '' });
//     }, 5000);
//   };

//   // ¡ FETCH EMPLOYEE SHIFT INFORMATION
//   const fetchEmployeeShiftInfo = async (employeeId) => {
//     console.log('🔍 FETCHING EMPLOYEE SHIFT INFO:', { employeeId });


//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       console.warn('⚠️ No access token found for shift info fetch');
//       return null;
//     }

//     setLoadingShiftInfo(true);

//     try {

//       const response = await axios.get(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/employees/${employeeId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           timeout: 15000
//         }
//       );

//       console.log('¡ EMPLOYEE SHIFT RESPONSE:', response.data);

//       const employee = response.data;

//       // Initialize shift info
//       let shiftName = 'General Shift';
//       let shiftTiming = '9:00 AM - 6:00 PM';
//       let shiftType = 'Day Shift';

//       // If employee has a shift ID, fetch the shift details
//       if (employee.shift) {
//         try {
//           console.log('🔍 FETCHING SHIFT DETAILS FOR ID:', employee.shift);

//           const shiftResponse = await axios.get(
//             `https://greenyellow-nightingale-241896.hostingersite.com/api/shifts/${employee.shift}`,
//             {
//               headers: { Authorization: `Bearer ${token}` },
//               timeout: 10000
//             }
//           );

//           console.log('🕒 SHIFT DETAILS RESPONSE:', shiftResponse.data);

//           const shiftData = shiftResponse.data;
//           if (shiftData && shiftData.name) {
//             shiftName = shiftData.name;
//             shiftTiming = shiftData.startTime && shiftData.endTime
//               ? `${shiftData.startTime} - ${shiftData.endTime}`
//               : (employee.shiftTiming || employee.shiftTime || employee.workingHours || '9:00 AM - 6:00 PM');
//             shiftType = shiftData.type || employee.shiftType || 'Day Shift';
//           }
//         } catch (shiftErr) {
//           console.warn('⚠️ Failed to fetch shift details:', shiftErr.message);

//           // Fallback: Try to find in local shifts array if available
//           if (shifts.length > 0) {
//             const shiftObject = shifts.find(s => s._id === employee.shift);
//             if (shiftObject) {
//               shiftName = shiftObject.name || 'General Shift';
//               shiftTiming = shiftObject.startTime && shiftObject.endTime
//                 ? `${shiftObject.startTime} - ${shiftObject.endTime}`
//                 : (employee.shiftTiming || employee.shiftTime || employee.workingHours || '9:00 AM - 6:00 PM');
//               shiftType = shiftObject.type || employee.shiftType || 'Day Shift';
//             }
//           }
//         }
//       } else {
//         // No shift assigned, use employee fields or defaults
//         shiftName = employee.shiftName || employee.workShift || 'General Shift';
//         shiftTiming = employee.shiftTiming || employee.shiftTime || employee.workingHours || '9:00 AM - 6:00 PM';
//         shiftType = employee.shiftType || 'Day Shift';
//       }

//       const shiftInfo = {
//         shiftName: shiftName,
//         shiftTiming: shiftTiming,
//         shiftType: shiftType,
//         shiftId: employee.shiftId || employee.shift || null
//       };

//       console.log('🕒 PROCESSED SHIFT INFO:', shiftInfo);
//       setEmployeeShiftInfo(shiftInfo);

//       return shiftInfo;
//     } catch (err) {
//       console.error('❌ Error fetching employee shift info:', err);

//       // Set default shift info on error
//       const defaultShift = {
//         shiftName: 'General Shift',
//         shiftTiming: '9:00 AM - 6:00 PM',
//         shiftType: 'Day Shift',
//         shiftId: null
//       };

//       setEmployeeShiftInfo(defaultShift);

//       if (err.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         window.location.href = '/login';
//       }

//       return defaultShift;
//     } finally {
//       setLoadingShiftInfo(false);
//     }
//   };

//   // 🎯 ENHANCED EMPLOYEE REPORT HANDLERS
//   const handleEmployeeSelect = async (employee) => {
//     console.log('👤 EMPLOYEE SELECTED FOR ATTENDANCE VIEW:', {
//       id: employee._id,
//       name: employee.displayName || employee.teamMemberName || employee.name,
//       email: employee.email,
//       department: employee.departmentName,
//       currentMonthStats: {
//         present: employee.presentDays,
//         absent: employee.absentDays,
//         rate: employee.attendanceRate,
//         totalRecords: employee.totalRecords
//       }
//     });

//     setSelectedEmployeeForReport(employee);
//     setIsEmployeeModalOpen(true);
//     setAttendanceError(null);
//     setEmployeeShiftInfo(null);

//     // Use existing attendance records from employee data
//     if (employee.attendanceRecords && employee.attendanceRecords.length > 0) {
//       console.log('📊 USING EXISTING ATTENDANCE RECORDS:', employee.attendanceRecords.length);

//       // Process records with proper formatting
//       const processedRecords = employee.attendanceRecords.map(record => ({
//         ...record,
//         id: record._id || record.id,
//         displayInTime: record.inTime ? formatTimeUTC(record.inTime) : '-',
//         displayOutTime: record.outTime ? formatTimeUTC(record.outTime) : '-',
//         workingTime: record.inTime && record.outTime
//           ? calculateEnhancedWorkingTime(record.inTime, record.outTime)
//           : record.workingTime || '--:--',
//         isEditable: true
//       }));

//       setAttendanceRecords(processedRecords);
//     } else {
//       console.log('¡ FETCHING FRESH ATTENDANCE DATA...');
//       setAttendanceRecords([]);

//       // Fetch fresh attendance data if not available
//       const companyId = localStorage.getItem('selectedCompanyId');
//       await fetchEmployeeAttendance(employee._id, companyId);
//     }

//     // Fetch shift information
//     await fetchEmployeeShiftInfo(employee._id);
//   };

//   const closeEmployeeModal = () => {
//     setIsEmployeeModalOpen(false);
//     setSelectedEmployeeForReport(null);
//     setAttendanceRecords([]);
//     setIsEditingAttendance(false);
//     setEditingRecord(null);
//     setAttendanceError(null);
//     setEmployeeShiftInfo(null);
//     setLoadingShiftInfo(false);
//   };

//   // ✅ï ENHANCED ATTENDANCE EDITING HANDLERS
//   const handleEditAttendance = (record = null) => {
//     console.log('✅ï EDITING ATTENDANCE RECORD:', record);

//     // Extract Employee ID and Company ID from JWT token and selected employee
//     const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
//     let extractedEmployeeId = selectedEmployeeForReport?._id;
//     let extractedCompanyId = localStorage.getItem('selectedCompanyId');

//     // Try to decode JWT token for additional ID extraction
//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         console.log('🔍 JWT TOKEN DECODED FOR ATTENDANCE EDIT:', {
//           decoded,
//           selectedEmployee: selectedEmployeeForReport?._id,
//           selectedCompany: localStorage.getItem('selectedCompanyId')
//         });

//         // Use company ID from token if not available in localStorage
//         if (!extractedCompanyId) {
//           extractedCompanyId = decoded.companyId || decoded.company?._id || decoded.orgId;
//         }

//         // Use employee ID from selected employee (priority) or token
//         extractedEmployeeId = selectedEmployeeForReport?._id || decoded.employeeId || decoded._id || decoded.id;

//       } catch (error) {
//         console.warn('⚠️ Failed to decode JWT token:', error);
//       }
//     }

//     console.log('†EXTRACTED IDS FOR ATTENDANCE EDIT:', {
//       employeeId: extractedEmployeeId,
//       companyId: extractedCompanyId,
//       selectedEmployee: selectedEmployeeForReport?.teamMemberName || selectedEmployeeForReport?.name
//     });

//     if (record && (record.id || record._id)) {
//       // Edit existing record
//       // Convert date to proper format for HTML5 date input (yyyy-MM-dd)
//       let formattedDate = new Date().toISOString().split('T')[0]; // Default to today
//       if (record.date) {
//         try {
//           const dateObj = new Date(record.date);
//           if (!isNaN(dateObj.getTime())) {
//             formattedDate = dateObj.toISOString().split('T')[0];
//           }
//         } catch (error) {
//           console.warn('⚠️ Invalid date format, using today:', record.date);
//         }
//       }

//       setEditingRecord({
//         ...record,
//         date: formattedDate,
//         inTime: record.inTime ? record.inTime.slice(0, 16) : '',
//         outTime: record.outTime ? record.outTime.slice(0, 16) : '',
//         inLocation: record.inLocation || '',
//         outLocation: record.outLocation || '',
//         notes: record.notes || record.remarks || '',
//         status: record.status || 'Present',
//         // Ensure we have proper ID fields for validation
//         employeeId: record.employee?._id || record.employee || record.employeeId || extractedEmployeeId,
//         companyId: record.company?._id || record.company || record.companyId || extractedCompanyId
//       });
//     } else {
//       // Create new record
//       const today = new Date().toISOString().split('T')[0];
//       setEditingRecord({
//         id: null,
//         employeeId: extractedEmployeeId,
//         companyId: extractedCompanyId,
//         date: today,
//         inTime: '',
//         outTime: '',
//         inLocation: '',
//         outLocation: '',
//         notes: '',
//         status: 'Present',
//         workingTime: 0,
//         isNew: true
//       });
//     }

//     setIsEditingAttendance(true);
//   };

//   const handleSaveAttendance = async () => {
//     if (!editingRecord) {
//       console.error('❌ SAVE ATTENDANCE ERROR: No record to save');
//       showNotification('No record to save', 'error');
//       return;
//     }


//     // Check if this is a synthetic record (no-record-xxx) or a real record
//     const isSyntheticRecord = editingRecord.id && editingRecord.id.startsWith('no-record-');
//     const isNewRecord = editingRecord.isNew || !editingRecord.id || isSyntheticRecord;


//     // Validate required fields and extract IDs with fallbacks
//     const validationErrors = [];

//     // Extract employee ID from various possible formats with fallbacks
//     let employeeId = editingRecord.employeeId ||
//       editingRecord.employee?._id ||
//       editingRecord.employee ||
//       selectedEmployeeForReport?._id ||
//       null;

//     // Extract company ID from various possible formats with fallbacks
//     let companyId = editingRecord.companyId ||
//       editingRecord.company?._id ||
//       editingRecord.company ||
//       localStorage.getItem('selectedCompanyId') ||
//       null;

//     // If IDs are still missing, try to extract from JWT token
//     if (!employeeId || !companyId) {
//       const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
//       if (token) {
//         try {
//           const decoded = jwtDecode(token);
//           console.log('🔍 JWT TOKEN DECODED FOR SAVE:', {
//             decoded,
//             currentEmployeeId: employeeId,
//             currentCompanyId: companyId
//           });

//           if (!employeeId) {
//             employeeId = selectedEmployeeForReport?._id || decoded.employeeId || decoded._id || decoded.id;
//           }

//           if (!companyId) {
//             companyId = decoded.companyId || decoded.company?._id || decoded.orgId;
//           }
//         } catch (error) {
//           console.warn('⚠️ Failed to decode JWT token for save:', error);
//         }
//       }
//     }

//     if (!employeeId) validationErrors.push('Employee ID is missing');
//     if (!companyId) validationErrors.push('Company ID is missing');
//     if (!editingRecord.date) validationErrors.push('Date is missing');

//     console.log('🔍 EXTRACTED IDs WITH FALLBACKS:', {
//       employeeId,
//       companyId,
//       selectedEmployee: selectedEmployeeForReport?._id,
//       selectedCompany: localStorage.getItem('selectedCompanyId'),
//       originalEmployee: editingRecord.employee,
//       originalCompany: editingRecord.company,
//       isSyntheticRecord
//     });

//     if (validationErrors.length > 0) {
//       console.error('❌ VALIDATION ERRORS:', validationErrors);
//       showNotification(`Validation errors: ${validationErrors.join(', ')}`, 'error');
//       return;
//     }

//     // Prepare data for API using extracted IDs
//     const attendanceData = {
//       employee: employeeId,
//       company: companyId,
//       date: editingRecord.date,
//       inTime: editingRecord.inTime ? new Date(editingRecord.inTime).toISOString() : null,
//       outTime: editingRecord.outTime ? new Date(editingRecord.outTime).toISOString() : null,
//       inLocation: editingRecord.inLocation || null,
//       outLocation: editingRecord.outLocation || null,
//       notes: editingRecord.notes || null,
//       status: editingRecord.status,
//       workingTime: calculateWorkingMinutes(editingRecord.inTime, editingRecord.outTime)
//     };

//     console.log('💾 PREPARED ATTENDANCE DATA:');
//     console.log('📋 Final Data:', JSON.stringify(attendanceData, null, 2));
//     console.log('🕒 Time Calculations:', {
//       inTime: editingRecord.inTime,
//       outTime: editingRecord.outTime,
//       inTimeISO: attendanceData.inTime,
//       outTimeISO: attendanceData.outTime,
//       workingTimeDisplay: calculateEnhancedWorkingTime(editingRecord.inTime, editingRecord.outTime),
//       workingTimeMinutes: attendanceData.workingTime
//     });

//     let success = false;

//     if (isNewRecord) {
//       console.log('🚀 CREATING NEW ATTENDANCE RECORD...');
//       console.log(' Reason: ' + (isSyntheticRecord ? 'Synthetic record (no existing data)' : 'New record'));
//       success = await createAttendance(attendanceData);
//     } else {
//       console.log('🔄 UPDATING EXISTING ATTENDANCE RECORD...');
//       success = await updateAttendance(editingRecord.id, attendanceData);
//     }

//     console.log('📊 SAVE OPERATION RESULT:', success ? 'SUCCESS' : 'FAILED');

//     if (success) {
//       console.log('✅ Save successful, cleaning up form...');
//       setIsEditingAttendance(false);
//       setEditingRecord(null);

//       // Refresh attendance records
//       console.log('🔄 Refreshing attendance records...');
//       await fetchEmployeeAttendance(selectedEmployeeForReport._id, localStorage.getItem('selectedCompanyId'));
//       console.log('✅ Attendance records refreshed');
//     } else {
//       console.error('❌ Save failed, keeping form open for retry');
//     }
//   };

//   const handleCancelEdit = () => {
//     setIsEditingAttendance(false);
//     setEditingRecord(null);
//   };

//   // 🎯 COMPREHENSIVE HOLIDAY FETCHING FUNCTIONALITY
//   const fetchHolidays = async () => {
//     const companyId = localStorage.getItem('selectedCompanyId');
//     if (!companyId) {
//       console.log('Company data not available for holiday fetching');
//       return;
//     }

//     const token = localStorage.getItem('authToken') || localStorage.getItem('accessToken');
//     if (!token) {
//       console.log('🔍No access token found for holiday fetching');
//       setHolidaysError('No access token found. Please log in.');
//       return;
//     }

//     setLoadingHolidays(true);
//     setHolidaysError(null);

//     try {
//       console.log('🚀 FETCHING HOLIDAYS FOR COMPANY:', companyId);

//       // JWT token validation
//       let decoded;
//       try {
//         decoded = jwtDecode(token);
//         console.log('🔍 HOLIDAY FETCH TOKEN DECODED:', {
//           id: decoded.id,
//           role: decoded.role,
//           companyId: decoded.companyId || 'Not in token',
//           exp: new Date(decoded.exp * 1000).toLocaleString()
//         });
//       } catch (tokenError) {
//         console.error('❌ Invalid token for holiday fetch:', tokenError);
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('accessToken');
//         setHolidaysError('Invalid token. Please log in again.');
//         return;
//       }

//       const response = await axios.get(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/holidays/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//             'Accept': 'application/json'
//           },
//           timeout: 15000,
//           validateStatus: (status) => status < 500
//         }
//       );

//       console.log('¡ HOLIDAYS API RESPONSE:', {
//         status: response.status,
//         statusText: response.statusText,
//         dataType: typeof response.data,
//         dataLength: Array.isArray(response.data) ? response.data.length : 'Not array',
//         data: response.data
//       });

//       // Handle authentication errors
//       if (response.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('accessToken');
//         setHolidaysError('Session expired. Please log in again.');
//         return;
//       }

//       if (response.status === 403) {
//         setHolidaysError('Access denied. Please check your permissions.');
//         return;
//       }

//       if (response.status === 404) {
//         console.log('📅 No holidays found for company');
//         setHolidays([]);
//         return;
//       }

//       // Handle different response formats
//       let holidayRecords = [];
//       if (Array.isArray(response.data)) {
//         holidayRecords = response.data;
//       } else if (response.data?.data && Array.isArray(response.data.data)) {
//         holidayRecords = response.data.data;
//       } else if (response.data?.holidays && Array.isArray(response.data.holidays)) {
//         holidayRecords = response.data.holidays;
//       } else if (response.data?.data) {
//         holidayRecords = [response.data.data];
//       } else if (response.data) {
//         holidayRecords = [response.data];
//       }

//       console.log('🎯 PROCESSED HOLIDAYS:', {
//         totalHolidays: holidayRecords.length,
//         holidays: holidayRecords.map((holiday, index) => ({
//           index: index + 1,
//           id: holiday._id || holiday.id,
//           name: holiday.name || holiday.holidayName || holiday.title,
//           date: holiday.date || holiday.holidayDate,
//           description: holiday.description || holiday.details,
//           type: holiday.type || holiday.holidayType || 'General',
//           isActive: holiday.isActive !== undefined ? holiday.isActive : true,
//           company: holiday.company || 'Not specified'
//         }))
//       });

//       // Process and validate holiday data
//       const processedHolidays = holidayRecords
//         .filter(holiday => {
//           // Basic validation
//           if (!holiday) return false;

//           // Must have a date
//           const holidayDate = holiday.date || holiday.holidayDate;
//           if (!holidayDate) {
//             console.log('⚠️ Holiday missing date:', holiday);
//             return false;
//           }

//           // Validate date format
//           try {
//             new Date(holidayDate);
//             return true;
//           } catch (e) {
//             console.log('⚠️ Invalid holiday date format:', holidayDate);
//             return false;
//           }
//         })
//         .map(holiday => {
//           const holidayDate = holiday.date || holiday.holidayDate;
//           return {
//             _id: holiday._id || holiday.id,
//             name: holiday.name || holiday.holidayName || holiday.title || 'Holiday',
//             date: new Date(holidayDate).toISOString().split('T')[0], // Format as YYYY-MM-DD
//             description: holiday.description || holiday.details || '',
//             type: holiday.type || holiday.holidayType || 'General',
//             isActive: holiday.isActive !== undefined ? holiday.isActive : true,
//             company: holiday.company,
//             originalData: holiday // Keep for debugging
//           };
//         })
//         .filter(holiday => holiday.isActive) // Only include active holidays
//         .sort((a, b) => new Date(a.date) - new Date(b.date)); // Sort by date

//       console.log('✅ FINAL PROCESSED HOLIDAYS:', {
//         count: processedHolidays.length,
//         holidays: processedHolidays
//       });

//       setHolidays(processedHolidays);

//       if (processedHolidays.length > 0) {
//         console.log(`✅ Loaded ${processedHolidays.length} company holidays`);
//       }

//     } catch (error) {
//       console.error('❌ HOLIDAY FETCH ERROR:', error);

//       if (error.response) {
//         const status = error.response.status;
//         let errorMessage = 'Failed to load company holidays.';

//         switch (status) {
//           case 401:
//             localStorage.removeItem('authToken');
//             localStorage.removeItem('accessToken');
//             errorMessage = 'Session expired. Please log in again.';
//             break;
//           case 403:
//             errorMessage = 'Access denied to holiday data.';
//             break;
//           case 404:
//             errorMessage = 'No holidays found for your company.';
//             setHolidays([]); // Set empty array for 404
//             break;
//           case 429:
//             errorMessage = 'Too many requests. Please try again later.';
//             break;
//           case 500:
//             errorMessage = 'Server error. Please try again later.';
//             break;
//           default:
//             errorMessage = `Error ${status}: ${error.response.data?.message || 'Unknown error'}`;
//         }

//         setHolidaysError(errorMessage);
//       } else if (error.request) {
//         setHolidaysError('Network error. Please check your internet connection.');
//       } else {
//         setHolidaysError('Unexpected error loading holidays.');
//       }
//     } finally {
//       setLoadingHolidays(false);
//     }
//   };

//   // FETCH COMPANY DATA FOR WEEKLY HOLIDAYS
//   const fetchCompanyData = async () => {
//     const companyId = localStorage.getItem('selectedCompanyId');
//     if (!companyId) {
//       console.log('Company ID not available for company data fetching');
//       return;
//     }

//     const token = localStorage.getItem('authToken') || localStorage.getItem('accessToken');
//     if (!token) {
//       console.log('🔍No access token found for company data fetching');
//       return;
//     }

//     try {
//       console.log('🚀 FETCHING COMPANY DATA FOR WEEKLY HOLIDAYS:', companyId);

//       const response = await axios.get(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/companies/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           },
//           timeout: 10000
//         }
//       );

//       console.log('¡ COMPANY DATA API RESPONSE:', {
//         status: response.status,
//         data: response.data,
//         weeklyHoliday: response.data?.weeklyHoliday || response.data?.data?.weeklyHoliday,
//         weeklyHolidays: response.data?.weeklyHolidays || response.data?.data?.weeklyHolidays
//       });

//       // Handle different response formats
//       let company = response.data;
//       if (response.data?.data) {
//         company = response.data.data;
//       }

//       setCompanyData(company);
//       console.log('✅ COMPANY DATA LOADED:', {
//         companyId: company._id || company.id,
//         companyName: company.name || company.companyName,
//         weeklyHoliday: company.weeklyHoliday,
//         weeklyHolidays: company.weeklyHolidays
//       });

//     } catch (error) {
//       console.error('❌ COMPANY DATA FETCH ERROR:', error);

//       if (error.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('accessToken');
//       }
//     }
//   };

//   const handleEditFieldChange = (field, value) => {
//     setEditingRecord(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   // —ï DELETE ATTENDANCE
//   const deleteAttendance = async (attendanceId) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       showNotification('No access token found. Please log in.', 'error');
//       return false;
//     }

//     try {
//       console.log('—ï DELETING ATTENDANCE:', attendanceId);

//       const response = await axios.delete(
//         `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/${attendanceId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           timeout: 15000
//         }
//       );

//       console.log('✅ ATTENDANCE DELETED:', response.data);
//       showNotification('Attendance record deleted successfully!', 'success');

//       // Refresh attendance records
//       if (selectedEmployeeForReport) {
//         await fetchEmployeeAttendance(selectedEmployeeForReport._id, localStorage.getItem('selectedCompanyId'));
//       }

//       return true;
//     } catch (err) {
//       console.error('❌ Error deleting attendance:', err);
//       const errorMessage = err.response?.data?.message || err.message || 'Failed to delete attendance record';
//       showNotification(errorMessage, 'error');

//       if (err.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         window.location.href = '/login';
//       }

//       return false;
//     }
//   };

//   const handleDeleteAttendance = async (recordId) => {
//     if (window.confirm('Are you sure you want to delete this attendance record?')) {
//       await deleteAttendance(recordId);
//     }
//   };

//   const years = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i);

//   const months = [
//     'January', 'February', 'March', 'April', 'May', 'June',
//     'July', 'August', 'September', 'October', 'November', 'December',
//   ];

//   // Function to get department name by ID
//   const getDepartmentName = (departmentId) => {
//     if (departmentId === 'all') return 'All Departments';

//     // Check if it's a real department from API
//     const department = departments.find(dept => dept._id === departmentId);
//     return department ? (department.departmentName || department.name) : 'N/A';
//   };

//   // Enhanced department filtering function for multiple departments support
//   const checkDepartmentMatch = (employee, targetDepartmentId) => {
//     if (targetDepartmentId === 'all' || employee.department === 'all') {
//       return true;
//     }

//     // Skip the "All Employees" option
//     if (employee._id === 'all') {
//       return false;
//     }

//     // Handle multiple departments using the stored departmentIds array
//     if (employee.departmentIds && employee.departmentIds.length > 0) {
//       const match = employee.departmentIds.some(deptId =>
//         String(deptId) === String(targetDepartmentId)
//       );

//       if (match) {
//         console.log(`✅ EMPLOYEE ${employee.displayName} MATCHES DEPARTMENT ${targetDepartmentId}`, {
//           employeeDepartments: employee.departmentIds,
//           targetDepartment: targetDepartmentId
//         });
//       }

//       return match;
//     }

//     // Fallback for single department
//     if (employee.departmentId) {
//       return String(employee.departmentId) === String(targetDepartmentId);
//     }

//     // Final fallback
//     if (employee.department) {
//       const empDeptId = typeof employee.department === 'object'
//         ? employee.department._id
//         : employee.department;
//       return String(empDeptId) === String(targetDepartmentId);
//     }

//     return false;
//   };

//   // Get employees filtered by selected department with multiple department support
//   const filteredEmployeeData = employees.filter(emp => {
//     // Enhanced department filter with multiple department support
//     const matchesDepartment = checkDepartmentMatch(emp, selectedDepartment);

//     // Handle employee filter
//     const matchesEmployee = selectedEmployee === 'all' ||
//       emp._id === selectedEmployee;

//     // Debug logging for filtering
//     if (selectedDepartment !== 'all') {
//       console.log(`🔍 FILTERING EMPLOYEE:`, {
//         employeeId: emp._id,
//         employeeName: emp.teamMemberName || emp.name,
//         selectedDepartment,
//         isMultipleDepartments: emp.isMultipleDepartments,
//         departmentCount: emp.departmentCount,
//         allDepartmentIds: emp.allDepartments?.map(d => d._id),
//         matchesDepartment,
//         finalMatch: matchesDepartment && matchesEmployee
//       });
//     }

//     return matchesDepartment && matchesEmployee;
//   });

//   const filteredLateAbsentData = attendanceData.lateAbsent.filter(item => {
//     // Enhanced department filtering for late/absent data
//     let matchesDepartment = selectedDepartment === 'all' || item.department === selectedDepartment;

//     // If basic match fails, check if employee has multiple departments
//     if (!matchesDepartment && selectedDepartment !== 'all') {
//       const employee = employees.find(emp => emp.teamMemberName === item.name || emp.name === item.name);
//       if (employee) {
//         matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);
//       }
//     }

//     const matchesEmployee = selectedEmployee === 'all' ||
//       (typeof item.name === 'string' &&
//         employees.some(emp => emp._id === selectedEmployee && emp.teamMemberName === item.name));
//     return matchesDepartment && matchesEmployee;
//   });

//   const filteredWorkSummaryData = attendanceData.workSummary
//     .filter(item => {
//       // Enhanced department filtering for work summary data
//       let matchesDepartment = selectedDepartment === 'all' || item.department === selectedDepartment;

//       // If basic match fails, check if employee has multiple departments
//       if (!matchesDepartment && selectedDepartment !== 'all') {
//         const employee = employees.find(emp => emp.teamMemberName === item.name || emp.name === item.name);
//         if (employee) {
//           matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);
//         }
//       }

//       const matchesEmployee = selectedEmployee === 'all' ||
//         (typeof item.name === 'string' &&
//           employees.some(emp => emp._id === selectedEmployee && emp.teamMemberName === item.name));
//       return matchesDepartment &&
//         matchesEmployee &&
//         (new Date(item.date).getFullYear() === selectedYear) &&
//         (new Date(item.date).getMonth() === selectedMonth) &&
//         (!selectedDate || item.date === selectedDate) &&
//         (employeeSearch === '' || item.name.toLowerCase().includes(employeeSearch.toLowerCase()));
//     });

//   const filteredDailyAttendanceData = attendanceData.dailyAttendance
//     .filter(item => {
//       // Enhanced department filtering for daily attendance data
//       let matchesDepartment = selectedDepartment === 'all' || item.department === selectedDepartment;

//       // If basic match fails, check if employee has multiple departments
//       if (!matchesDepartment && selectedDepartment !== 'all') {
//         const employee = employees.find(emp => emp.teamMemberName === item.name || emp.name === item.name);
//         if (employee) {
//           matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);
//         }
//       }

//       const matchesEmployee = selectedEmployee === 'all' ||
//         (typeof item.name === 'string' &&
//           employees.some(emp => emp._id === selectedEmployee && emp.teamMemberName === item.name));
//       return matchesDepartment &&
//         matchesEmployee &&
//         (new Date(item.date).getFullYear() === selectedYear) &&
//         (new Date(item.date).getMonth() === selectedMonth) &&
//         (!selectedDate || item.date === selectedDate) &&
//         (employeeSearch === '' || item.name.toLowerCase().includes(employeeSearch.toLowerCase()));
//     });

//   const handleViewDetails = (record) => {
//     setSelectedRecord(record);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedRecord(null);
//   };

//   const closeDeptModal = () => {
//     setIsDeptModalOpen(false);
//     setSelectedDeptEmployees([]);
//     setSelectedDeptName('');
//   };

//   const fetchEmployeesByDepartment = async (deptId, deptName) => {
//     if (deptId === 'all') return;

//     setLoading(true);
//     const token = localStorage.getItem('authToken');

//     try {
//       // Enhanced filtering for employees by department (including multiple departments)
//       const deptEmployees = employees.filter(emp =>
//         emp._id !== 'all' && checkDepartmentMatch(emp, deptId)
//       );

//       console.log('DEPARTMENT EMPLOYEES FILTERED:', {
//         departmentId: deptId,
//         departmentName: deptName,
//         totalEmployees: employees.length - 1, // -1 for 'all' option
//         matchingEmployees: deptEmployees.length,
//         employeesWithMultipleDepts: deptEmployees.filter(emp => emp.isMultipleDepartments).length
//       });

//       setSelectedDeptEmployees(deptEmployees);
//       setSelectedDeptName(deptName);
//       setIsDeptModalOpen(true);
//     } catch (err) {
//       console.error('Error fetching department employees:', err);
//       setError(`Failed to fetch department employees: ${err.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4 md:p-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-xl shadow-lg p-6 mb-6 text-white">
//           <h1 className="text-3xl font-bold mb-2">Attendance Reports</h1>
//           <p className="text-blue-100">For managers/admins to analyze attendance patterns and trends</p>
//         </div>

//         {/* Report Type Selector */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
//           <button
//             onClick={() => setActiveReport('employeeCard')}
//             className={`p-4 rounded-xl shadow-md transition-all duration-200 flex flex-col items-center ${activeReport === 'employeeCard' ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg transform scale-105' : 'bg-white text-gray-700 hover:shadow-lg'}`}
//           >
//             <div className="font-semibold text-sm md:text-base">📊 Employee Cards</div>
//             <div className="text-xs mt-1 opacity-80">Individual attendance</div>
//           </button>
//           <button
//             onClick={() => setActiveReport('department')}
//             className={`p-4 rounded-xl shadow-md transition-all duration-200 flex flex-col items-center ${activeReport === 'department' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg transform scale-105' : 'bg-white text-gray-700 hover:shadow-lg'}`}
//           >
//             <div className="font-semibold text-sm md:text-base">Department Report</div>
//             <div className="text-xs mt-1 opacity-80">Summary by department</div>
//           </button>
//         </div>

//         {/* Report Content Area */}
//         <div className="bg-white rounded-xl shadow-lg p-4 md:p-6">
//           {/* Filters for relevant reports */}
//           {(activeReport === 'workSummary' || activeReport === 'dailyAttendance') && (
//             <div className="mb-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//               <div>
//                 <label htmlFor="company-select" className="block text-sm font-medium text-gray-700 mb-1">Company:</label>
//                 <select
//                   id="company-select"
//                   value={selectedCompany}
//                   disabled={companies.length <= 1}
//                   className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 disabled:opacity-75 disabled:cursor-not-allowed"
//                 >
//                   {companies.map(company => (
//                     <option key={company.id} value={company.id}>{company.name}</option>
//                   ))}
//                 </select>
//               </div>
//               <div>
//                 <label htmlFor="department-select" className="block text-sm font-medium text-gray-700 mb-1">
//                   Filter by Department:
//                   {selectedDepartment !== 'all' && (
//                     <span className="ml-2 px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
//                       {filteredEmployeeData.length - 1} employees found
//                     </span>
//                   )}
//                 </label>
//                 <select
//                   id="department-select"
//                   value={selectedDepartment}
//                   onChange={(e) => {
//                     console.log('🔄 DEPARTMENT FILTER CHANGED:', {
//                       from: selectedDepartment,
//                       to: e.target.value,
//                       departmentName: departments.find(d => d._id === e.target.value)?.name || 'All Departments'
//                     });
//                     setSelectedDepartment(e.target.value);
//                   }}
//                   className={`w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${selectedDepartment === 'all'
//                       ? 'border-gray-300 bg-gray-50'
//                       : 'border-blue-300 bg-blue-50'
//                     }`}
//                 >
//                   {loading ? (
//                     <option>Loading departments...</option>
//                   ) : error ? (
//                     <option>Error loading departments</option>
//                   ) : (
//                     departments.map(dept => {
//                       // Count employees in this department (including multiple departments)
//                       const employeeCount = employees.filter(emp =>
//                         emp._id !== 'all' && checkDepartmentMatch(emp, dept._id || dept.id)
//                       ).length;

//                       return (
//                         <option key={dept._id || dept.id} value={dept._id || dept.id}>
//                           {dept.departmentName || dept.name}
//                         </option>
//                       );
//                     })
//                   )}
//                 </select>
//                 {selectedDepartment !== 'all' && (
//                   <div className="mt-1 text-xs text-blue-600">
//                     ℹ️ï Includes employees with multiple departments
//                   </div>
//                 )}
//               </div>

//               {(activeReport === 'workSummary' || activeReport === 'dailyAttendance') && (
//                 <>
//                   <div>
//                     <label htmlFor="year-select" className="block text-sm font-medium text-gray-700 mb-1">Select Year:</label>
//                     <select
//                       id="year-select"
//                       value={selectedYear}
//                       onChange={(e) => setSelectedYear(parseInt(e.target.value))}
//                       className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
//                     >
//                       {years.map(year => (
//                         <option key={year} value={year}>{year}</option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label htmlFor="month-select" className="block text-sm font-medium text-gray-700 mb-1">Select Month:</label>
//                     <select
//                       id="month-select"
//                       value={selectedMonth}
//                       onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
//                       className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
//                     >
//                       {months.map((month, index) => (
//                         <option key={index} value={index}>{month}</option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label htmlFor="date-select" className="block text-sm font-medium text-gray-700 mb-1">Select Date:</label>
//                     <input
//                       id="date-select"
//                       type="date"
//                       value={selectedDate}
//                       onChange={(e) => setSelectedDate(e.target.value)}
//                       className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
//                     />
//                   </div>
//                   <div>
//                     <label htmlFor="employee-search" className="block text-sm font-medium text-gray-700 mb-1">Search Employee:</label>
//                     <input
//                       id="employee-search"
//                       type="text"
//                       value={employeeSearch}
//                       onChange={(e) => setEmployeeSearch(e.target.value)}
//                       placeholder="Search by employee name..."
//                       className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           )}


//           {/* Department-wise Report */}
//           {activeReport === 'department' && (
//             <div>
//               <div className="flex items-center justify-between mb-6">
//                 <h2 className="text-xl font-semibold text-gray-800">📊 Department-wise Attendance {deptViewMode === 'card' ? 'Summary' : 'Grid'}</h2>

//                 {/* View Toggle Buttons for Department */}
//                 <div className="flex items-center space-x-2 bg-gray-100 rounded-lg p-1">
//                   <button
//                     onClick={() => setDeptViewMode('card')}
//                     className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${deptViewMode === 'card'
//                         ? 'bg-white text-blue-600 shadow-sm'
//                         : 'text-gray-600 hover:text-gray-800'
//                       }`}
//                   >
//                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14-7H5m14 14H5" />
//                     </svg>
//                     <span>📋 Card View</span>
//                   </button>
//                   <button
//                     onClick={() => setDeptViewMode('grid')}
//                     className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${deptViewMode === 'grid'
//                         ? 'bg-white text-blue-600 shadow-sm'
//                         : 'text-gray-600 hover:text-gray-800'
//                       }`}
//                   >
//                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
//                     </svg>
//                     <span>📊 Grid View</span>
//                   </button>
//                 </div>
//               </div>

//               {/* Debug Information */}
//               <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
//                 <div className="text-sm text-yellow-800">
//                   <strong>🔍 Debug Info:</strong> Departments: {departments.length}, Employees: {employees.length}, Stats: {departmentStats.length}
//                 </div>
//                 <div className="text-xs text-yellow-600 mt-1">
//                   Selected Date: {selectedDate} | Active Report: {activeReport}
//                 </div>
//                 <div className="flex gap-2 mt-2">
//                   {departments.length === 0 && (
//                     <button
//                       onClick={async () => {
//                         console.log('🔄 MANUAL REFRESH DEPARTMENTS');
//                         const companyId = localStorage.getItem('selectedCompanyId');
//                         if (companyId) {
//                           await fetchDepartments(companyId);
//                         }
//                       }}
//                       className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
//                     >
//                       🔄 Load Departments
//                     </button>
//                   )}
//                   {employees.length === 0 && (
//                     <button
//                       onClick={async () => {
//                         console.log('🔄 MANUAL REFRESH EMPLOYEES');
//                         const companyId = localStorage.getItem('selectedCompanyId');
//                         if (companyId) {
//                           await fetchEmployees(companyId);
//                         }
//                       }}
//                       className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
//                     >
//                       🔄 Load Employees
//                     </button>
//                   )}
//                   {departmentStats.length === 0 && departments.length > 0 && employees.length > 0 && (
//                     <button
//                       onClick={() => {
//                         console.log('🔄 MANUAL REFRESH DEPARTMENT STATS');
//                         fetchDepartmentStats();
//                       }}
//                       className="bg-yellow-600 text-white px-3 py-1 rounded text-xs hover:bg-yellow-700"
//                     >
//                       🔄 Refresh Stats
//                     </button>
//                   )}
//                   <button
//                     onClick={async () => {
//                       console.log('🔄 REFRESH ALL DATA');
//                       const companyId = localStorage.getItem('selectedCompanyId');
//                       if (companyId) {
//                         setLoading(true);
//                         try {
//                           await Promise.all([
//                             fetchEmployees(companyId),
//                             fetchDepartments(companyId),
//                             fetchEmployeeReportData(companyId)
//                           ]);
//                         } catch (error) {
//                           console.error('❌ Error refreshing data:', error);
//                         } finally {
//                           setLoading(false);
//                         }
//                       }
//                     }}
//                     className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700"
//                   >
//                     🔄 Refresh All Data
//                   </button>
//                 </div>
//               </div>

//               {/* Card View for Departments */}
//               {deptViewMode === 'card' && (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//                   {(() => {
//                     // Enhanced display logic with fallback
//                     console.log('📊 DEPARTMENT STATS DISPLAY CHECK:', {
//                       departmentStatsLength: departmentStats.length,
//                       departmentsLength: departments.length,
//                       employeesLength: employees.length,
//                       departmentStats: departmentStats,
//                       departments: departments.map(d => ({ id: d._id, name: d.name || d.departmentName }))
//                     });

//                     if (departmentStats.length > 0) {
//                       // Show actual department stats
//                       return departmentStats.map(dept => (
//                         <div key={dept._id} className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5 shadow border border-blue-100 hover:shadow-md transition-shadow">
//                           <h3 className="font-bold text-lg text-gray-800 mb-3 capitalize">{dept.name}</h3>
//                           <div className="space-y-2">
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Employees:</span>
//                               <span className="font-semibold">{dept.employees}</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Present:</span>
//                               <span className="font-semibold text-green-600">{dept.present}</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Absent:</span>
//                               <span className="font-semibold text-red-600">{dept.absent}</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Half Day:</span>
//                               <span className="font-semibold text-orange-600">{dept.halfDay || 0}</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Late Arrivals:</span>
//                               <span className="font-semibold text-yellow-600">{dept.late}</span>
//                             </div>
//                             <button
//                               onClick={() => fetchEmployeesByDepartment(dept._id, dept.name)}
//                               className="mt-3 w-full bg-blue-50 hover:bg-blue-100 text-blue-600 font-medium py-2 px-4 rounded-lg transition-colors text-sm"
//                             >
//                               View Employees
//                             </button>
//                             <div className="pt-2 mt-2 border-t border-blue-200">
//                               <div className="flex justify-between items-center">
//                                 <span className="text-gray-600">Attendance Rate:</span>
//                                 <span className="font-semibold text-blue-600 text-lg">
//                                   {dept.attendanceRate || 0}%
//                                 </span>
//                               </div>
//                               <div className="text-xs text-gray-500 mt-1">
//                                 For {new Date(selectedDate).toLocaleDateString('en-IN', {
//                                   day: '2-digit',
//                                   month: 'short',
//                                   year: 'numeric'
//                                 })}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ));
//                     } else if (departments.length > 0) {
//                       // Show departments with basic employee counts as fallback
//                       return departments
//                         .filter(dept => dept._id !== 'all')
//                         .map(dept => {
//                           const employeeCount = employees.filter(emp => {
//                             if (Array.isArray(emp.department)) {
//                               return emp.department.some(d =>
//                                 (typeof d === 'object' ? d._id : d) === dept._id
//                               );
//                             } else {
//                               const empDeptId = typeof emp.department === 'object'
//                                 ? emp.department._id
//                                 : emp.department;
//                               return empDeptId === dept._id;
//                             }
//                           }).length;

//                           return (
//                             <div key={dept._id} className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl p-5 shadow border border-gray-200 hover:shadow-md transition-shadow">
//                               <h3 className="font-bold text-lg text-gray-800 mb-3 capitalize">{dept.name || dept.departmentName}</h3>
//                               <div className="space-y-2">
//                                 <div className="flex justify-between">
//                                   <span className="text-gray-600">Employees:</span>
//                                   <span className="font-semibold">{employeeCount}</span>
//                                 </div>
//                                 <div className="flex justify-between">
//                                   <span className="text-gray-600">Present:</span>
//                                   <span className="font-semibold text-gray-400">Loading...</span>
//                                 </div>
//                                 <div className="flex justify-between">
//                                   <span className="text-gray-600">Absent:</span>
//                                   <span className="font-semibold text-gray-400">Loading...</span>
//                                 </div>
//                                 <div className="flex justify-between">
//                                   <span className="text-gray-600">Half Day:</span>
//                                   <span className="font-semibold text-gray-400">Loading...</span>
//                                 </div>
//                                 <button
//                                   onClick={() => {
//                                     console.log('🔄 REFRESH STATS FOR DEPARTMENT:', dept.name);
//                                     fetchDepartmentStats();
//                                   }}
//                                   className="mt-3 w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition-colors text-sm"
//                                 >
//                                   🔄 Load Attendance Data
//                                 </button>
//                                 <div className="pt-2 mt-2 border-t border-gray-200">
//                                   <div className="text-xs text-gray-500">
//                                     Click "Load Attendance Data" to fetch statistics
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           );
//                         });
//                     } else {
//                       // No departments available
//                       return (
//                         <div className="col-span-full text-center py-8">
//                           <div className="text-gray-400 text-6xl mb-4"></div>
//                           <h3 className="text-lg font-medium text-gray-600 mb-2">No Departments Found</h3>
//                           <p className="text-gray-500 mb-4">No departments are available to display attendance statistics.</p>
//                           <button
//                             onClick={() => {
//                               console.log('🔄 REFRESH ALL DATA');
//                               window.location.reload();
//                             }}
//                             className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
//                           >
//                             🔄 Refresh Page
//                           </button>
//                         </div>
//                       );
//                     }
//                   })()
//                   }
//                 </div>
//               )}

//               {/* Grid View for Departments */}
//               {deptViewMode === 'grid' && (
//                 <div className="bg-white rounded-lg shadow-lg overflow-hidden">
//                   {(() => {
//                     const statsToShow = departmentStats.length > 0 ? departmentStats :
//                       departments.filter(dept => dept._id !== 'all').map(dept => {
//                         const employeeCount = employees.filter(emp => {
//                           if (Array.isArray(emp.department)) {
//                             return emp.department.some(d =>
//                               (typeof d === 'object' ? d._id : d) === dept._id
//                             );
//                           } else {
//                             const empDeptId = typeof emp.department === 'object'
//                               ? emp.department._id
//                               : emp.department;
//                             return empDeptId === dept._id;
//                           }
//                         }).length;

//                         return {
//                           _id: dept._id,
//                           name: dept.name || dept.departmentName,
//                           employees: employeeCount,
//                           present: 'Loading...',
//                           absent: 'Loading...',
//                           halfDay: 'Loading...',
//                           late: 'Loading...',
//                           attendanceRate: 'Loading...'
//                         };
//                       });

//                     return statsToShow.length > 0 ? (
//                       <div className="overflow-x-auto">
//                         <table className="min-w-full divide-y divide-gray-200">
//                           {/* Table Header */}
//                           <thead className="bg-gradient-to-r from-blue-50 to-indigo-50">
//                             <tr>
//                               <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                 Department
//                               </th>
//                               <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                 👥 Employees
//                               </th>
//                               <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                 ✅ Present
//                               </th>
//                               <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                 ❌ Absent
//                               </th>
//                               <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                 • Half Day
//                               </th>
//                               <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                  Late
//                               </th>
//                               <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                 📊 Rate
//                               </th>
//                               <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
//                                 š™ï Actions
//                               </th>
//                             </tr>
//                           </thead>

//                           {/* Table Body */}
//                           <tbody className="bg-white divide-y divide-gray-200">
//                             {statsToShow.map((dept, index) => (
//                               <tr key={dept._id} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
//                                 }`}>
//                                 {/* Department Name Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                   <div className="flex items-center">
//                                     <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md flex-shrink-0">
//                                       {dept.name.charAt(0).toUpperCase()}
//                                     </div>
//                                     <div className="ml-4">
//                                       <div className="text-sm font-medium text-gray-900 capitalize">
//                                         {dept.name}
//                                       </div>
//                                       <div className="text-sm text-gray-500">
//                                         {new Date(selectedDate).toLocaleDateString('en-IN', {
//                                           day: '2-digit',
//                                           month: 'short',
//                                           year: 'numeric'
//                                         })}
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </td>

//                                 {/* Employees Count Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <span className="text-lg font-bold text-gray-800">{dept.employees}</span>
//                                 </td>

//                                 {/* Present Count Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <span className="text-lg font-bold text-green-600">
//                                     {typeof dept.present === 'string' ? dept.present : dept.present}
//                                   </span>
//                                 </td>

//                                 {/* Absent Count Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <span className="text-lg font-bold text-red-600">
//                                     {typeof dept.absent === 'string' ? dept.absent : dept.absent}
//                                   </span>
//                                 </td>

//                                 {/* Half Day Count Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <span className="text-lg font-bold text-orange-600">
//                                     {typeof dept.halfDay === 'string' ? dept.halfDay : (dept.halfDay || 0)}
//                                   </span>
//                                 </td>

//                                 {/* Late Count Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <span className="text-lg font-bold text-yellow-600">
//                                     {typeof dept.late === 'string' ? dept.late : dept.late}
//                                   </span>
//                                 </td>

//                                 {/* Attendance Rate Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <span className={`text-lg font-bold ${typeof dept.attendanceRate === 'string' ? 'text-gray-400' :
//                                       (dept.attendanceRate || 0) >= 90 ? 'text-green-600' :
//                                         (dept.attendanceRate || 0) >= 75 ? 'text-yellow-600' :
//                                           'text-red-600'
//                                     }`}>
//                                     {typeof dept.attendanceRate === 'string' ? dept.attendanceRate : `${dept.attendanceRate || 0}%`}
//                                   </span>
//                                 </td>

//                                 {/* Actions Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center">
//                                   <div className="flex justify-center space-x-2">
//                                     {typeof dept.present === 'string' ? (
//                                       <button
//                                         onClick={() => {
//                                           console.log('🔄 REFRESH STATS FOR DEPARTMENT:', dept.name);
//                                           fetchDepartmentStats();
//                                         }}
//                                         className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-lg transition-colors text-sm font-medium"
//                                       >
//                                         🔄 Load Data
//                                       </button>
//                                     ) : (
//                                       <button
//                                         onClick={() => fetchEmployeesByDepartment(dept._id, dept.name)}
//                                         className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 text-sm font-medium"
//                                       >
//                                         👥 View Employees
//                                       </button>
//                                     )}
//                                   </div>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     ) : (
//                       <div className="text-center py-12">
//                         <div className="text-gray-400 text-6xl mb-4"></div>
//                         <h3 className="text-lg font-medium text-gray-600 mb-2">No Departments Found</h3>
//                         <p className="text-gray-500 mb-4">No departments are available to display attendance statistics.</p>
//                         <button
//                           onClick={() => {
//                             console.log('🔄 REFRESH ALL DATA');
//                             window.location.reload();
//                           }}
//                           className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
//                         >
//                           🔄 Refresh Page
//                         </button>
//                       </div>
//                     );
//                   })()
//                   }
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Employee Cards Report */}
//           {activeReport === 'employeeCard' && (
//             <div>
//               <div className="flex items-center justify-between mb-6">
//                 <div className="flex items-center space-x-4">
//                   <h2 className="text-xl font-semibold text-gray-800">📊 Employee Attendance {viewMode === 'card' ? 'Cards' : 'Grid'}</h2>
//                   {selectedDepartment !== 'all' && (
//                     <div className="flex items-center space-x-2">
//                       <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
//                         {departments.find(d => d._id === selectedDepartment)?.name || 'Selected Department'}
//                       </span>
//                       <span className="px-2 py-1 bg-gray-100 text-gray-600 rounded-full text-xs">
//                         {employeeReportData.filter(emp => checkDepartmentMatch(emp, selectedDepartment)).length} employees
//                       </span>
//                     </div>
//                   )}
//                 </div>

//                 {/* View Toggle Buttons */}
//                 <div className="flex items-center space-x-2 bg-gray-100 rounded-lg p-1">
//                   <button
//                     onClick={() => setViewMode('card')}
//                     className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${viewMode === 'card'
//                         ? 'bg-white text-blue-600 shadow-sm'
//                         : 'text-gray-600 hover:text-gray-800'
//                       }`}
//                   >
//                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14-7H5m14 14H5" />
//                     </svg>
//                     <span>📋 Card View</span>
//                   </button>
//                   <button
//                     onClick={() => setViewMode('grid')}
//                     className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${viewMode === 'grid'
//                         ? 'bg-white text-blue-600 shadow-sm'
//                         : 'text-gray-600 hover:text-gray-800'
//                       }`}
//                   >
//                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
//                     </svg>
//                     <span>📊 Grid View</span>
//                   </button>
//                 </div>
//               </div>
//               {/* Card View */}
//               {viewMode === 'card' && (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//                   {employeeReportData.length > 0 ? (
//                     employeeReportData
//                       .filter(employee => {
//                         // Apply department filter to employee cards
//                         const matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);

//                         // Debug logging for employee card filtering
//                         if (selectedDepartment !== 'all') {
//                           console.log(`📋 FILTERING EMPLOYEE CARD:`, {
//                             employeeId: employee._id,
//                             employeeName: employee.displayName,
//                             selectedDepartment,
//                             isMultipleDepartments: employee.isMultipleDepartments,
//                             departmentCount: employee.departmentCount,
//                             allDepartmentIds: employee.allDepartments?.map(d => d._id),
//                             matchesDepartment
//                           });
//                         }

//                         return matchesDepartment;
//                       })
//                       .map(employee => (
//                         <div
//                           key={employee._id}
//                           className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 shadow-lg border border-green-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
//                           onClick={() => handleEmployeeSelect(employee)}
//                         >
//                           <div className="flex items-center mb-4">
//                             <div className="w-14 h-14 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-md">
//                               {(employee.displayName || employee.teamMemberName || employee.name || 'N').charAt(0).toUpperCase()}
//                             </div>
//                             <div className="ml-4 flex-1">
//                               <h3 className="font-bold text-gray-800 text-base leading-tight">
//                                 {employee.displayName || employee.teamMemberName || employee.name || 'Unknown Employee'}
//                               </h3>
//                               <p className="text-sm text-gray-600 mt-1">{employee.email || 'No email provided'}</p>
//                             </div>
//                           </div>

//                           <div className="space-y-3">
//                             <div className="bg-white rounded-lg p-3 border border-green-100">
//                               <div className="text-sm">
//                                 <span className="text-gray-600 font-medium flex items-center mb-2">
//                                   Department{employee.isMultipleDepartments ? 's' : ''}:
//                                   {employee.isMultipleDepartments && (
//                                     <span className="ml-2 px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full text-xs">
//                                       {employee.departmentCount}
//                                     </span>
//                                   )}
//                                 </span>
//                                 {employee.isMultipleDepartments ? (
//                                   <ScrollingDepartments
//                                     departments={employee.departmentNames}
//                                     employeeId={employee._id}
//                                   />
//                                 ) : (
//                                   <div className="font-semibold text-gray-800">
//                                     {employee.departmentName || employee.department?.name || 'No Department'}
//                                   </div>
//                                 )}
//                               </div>
//                             </div>

//                             <div className="bg-white rounded-lg p-3 border border-green-100">
//                               <div className="flex justify-between items-center text-sm">
//                                 <span className="text-gray-600 font-medium">ž Phone:</span>
//                                 <span className="font-semibold text-gray-800 text-right flex-1 ml-2">
//                                   {employee.phone !== 'N/A' ? employee.phone : 'No phone provided'}
//                                 </span>
//                               </div>
//                             </div>
//                           </div>

//                           <div className="mt-4 pt-4 border-t border-green-200">
//                             {/* Current Month Header */}
//                             <div className="text-center mb-3">
//                               <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
//                                 📅 {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
//                               </div>
//                             </div>

//                             <div className="grid grid-cols-2 gap-3 text-center">
//                               <div className="bg-white rounded-lg p-2 border border-green-100">
//                                 <div className="text-lg font-bold text-green-600">{employee.presentDays || 0}</div>
//                                 <div className="text-xs text-gray-600">Present</div>
//                                 {employee.lateCount > 0 && (
//                                   <div className="text-xs text-orange-500 mt-1">+{employee.lateCount} late</div>
//                                 )}
//                               </div>
//                               <div className="bg-white rounded-lg p-2 border border-red-100">
//                                 <div className="text-lg font-bold text-red-600">{employee.absentDays || 0}</div>
//                                 <div className="text-xs text-gray-600">Absent</div>
//                                 {employee.halfDayCount > 0 && (
//                                   <div className="text-xs text-yellow-600 mt-1">+{employee.halfDayCount} half</div>
//                                 )}
//                               </div>
//                             </div>

//                             <div className="mt-3 bg-white rounded-lg p-2 text-center border border-blue-100">
//                               <div className="text-sm font-medium text-gray-600">Attendance Rate</div>
//                               <div className="text-lg font-bold text-blue-600">{employee.attendanceRate || 0}%</div>
//                               <div className="text-xs text-gray-500 mt-1">
//                                 {employee.totalRecords || 0} records this month
//                               </div>
//                             </div>
//                           </div>

//                           <div className="mt-4">
//                             <button className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-2 px-4 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 text-sm font-medium">
//                               📊 View Attendance Details
//                             </button>
//                           </div>
//                         </div>
//                       ))
//                   ) : (
//                     <div className="col-span-full text-center py-12">
//                       <div className="text-gray-400 text-6xl mb-4">👥</div>
//                       <h3 className="text-lg font-medium text-gray-600 mb-2">No Employees Found</h3>
//                       <p className="text-gray-500">No employee data available for this company.</p>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Grid View */}
//               {viewMode === 'grid' && (
//                 <div className="bg-white rounded-lg shadow-lg overflow-hidden">
//                   {employeeReportData.length > 0 ? (
//                     <div className="overflow-x-auto">
//                       <table className="min-w-full divide-y divide-gray-200">
//                         {/* Table Header */}
//                         <thead className="bg-gradient-to-r from-green-50 to-emerald-50">
//                           <tr>
//                             <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                               👤 Employee
//                             </th>
//                             <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                               Department
//                             </th>
//                             <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                               ž Contact
//                             </th>
//                             <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                               ✅ Present
//                             </th>
//                             <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                               ❌ Absent
//                             </th>
//                             <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                               📊 Rate
//                             </th>
//                             <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
//                               š™ï Actions
//                             </th>
//                           </tr>
//                         </thead>

//                         {/* Table Body */}
//                         <tbody className="bg-white divide-y divide-gray-200">
//                           {employeeReportData
//                             .filter(employee => checkDepartmentMatch(employee, selectedDepartment))
//                             .map((employee, index) => (
//                               <tr key={employee._id} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
//                                 }`}>
//                                 {/* Employee Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                   <div className="flex items-center">
//                                     <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md flex-shrink-0">
//                                       {(employee.displayName || employee.teamMemberName || employee.name || 'N').charAt(0).toUpperCase()}
//                                     </div>
//                                     <div className="ml-4">
//                                       <div className="text-sm font-medium text-gray-900">
//                                         {employee.displayName || employee.teamMemberName || employee.name || 'Unknown Employee'}
//                                       </div>
//                                       <div className="text-sm text-gray-500">
//                                         {employee.email || 'No email provided'}
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </td>

//                                 {/* Department Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                   <div className="text-sm text-gray-900">
//                                     {employee.isMultipleDepartments ? (
//                                       <div className="space-y-1">
//                                         <ScrollingDepartments
//                                           departments={employee.departmentNames}
//                                           employeeId={employee._id}
//                                         />
//                                       </div>
//                                     ) : (
//                                       <div className="font-medium">
//                                         {employee.departmentName || employee.department?.name || 'No Department'}
//                                       </div>
//                                     )}
//                                   </div>
//                                 </td>

//                                 {/* Contact Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                   <div className="text-sm text-gray-900">
//                                     {employee.phone !== 'N/A' ? (
//                                       <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md font-medium">
//                                         {employee.phone}
//                                       </span>
//                                     ) : (
//                                       <span className="text-gray-400 italic">No phone</span>
//                                     )}
//                                   </div>
//                                 </td>

//                                 {/* Present Days Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <div className="flex flex-col items-center">
//                                     <span className="text-lg font-bold text-green-600">{employee.presentDays || 0}</span>
//                                     {employee.lateCount > 0 && (
//                                       <span className="text-xs text-orange-500 mt-1">+{employee.lateCount} late</span>
//                                     )}
//                                   </div>
//                                 </td>

//                                 {/* Absent Days Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <div className="flex flex-col items-center">
//                                     <span className="text-lg font-bold text-red-600">{employee.absentDays || 0}</span>
//                                     {employee.halfDayCount > 0 && (
//                                       <span className="text-xs text-yellow-600 mt-1">+{employee.halfDayCount} half</span>
//                                     )}
//                                   </div>
//                                 </td>

//                                 {/* Attendance Rate Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
//                                   <div className="flex flex-col items-center">
//                                     <span className={`text-lg font-bold ${(employee.attendanceRate || 0) >= 90 ? 'text-green-600' :
//                                         (employee.attendanceRate || 0) >= 75 ? 'text-yellow-600' :
//                                           'text-red-600'
//                                       }`}>
//                                       {employee.attendanceRate || 0}%
//                                     </span>
//                                     <span className="text-xs text-gray-500 mt-1">
//                                       {employee.totalRecords || 0} records
//                                     </span>
//                                   </div>
//                                 </td>

//                                 {/* Actions Column */}
//                                 <td className="px-6 py-4 whitespace-nowrap text-center">
//                                   <button
//                                     onClick={() => handleEmployeeSelect(employee)}
//                                     className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 text-sm font-medium"
//                                   >
//                                     📊 View Details
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   ) : (
//                     <div className="text-center py-12">
//                       <div className="text-gray-400 text-6xl mb-4">👥</div>
//                       <h3 className="text-lg font-medium text-gray-600 mb-2">No Employees Found</h3>
//                       <p className="text-gray-500">No employee data available for this company.</p>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           )}


//         </div>

//         {/* Department Employees Modal */}
//         {isDeptModalOpen && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//             <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
//               <div className="p-6 border-b border-gray-200 flex justify-between items-center">
//                 <h3 className="text-xl font-semibold text-gray-800">
//                   Employees in {selectedDeptName}
//                 </h3>
//                 <button
//                   onClick={closeDeptModal}
//                   className="text-gray-500 hover:text-gray-700"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>
//               <div className="p-6 overflow-y-auto flex-1">
//                 {loading ? (
//                   <div className="flex justify-center items-center h-32">
//                     <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
//                   </div>
//                 ) : selectedDeptEmployees.length > 0 ? (
//                   <div className="space-y-4">
//                     {selectedDeptEmployees.map(emp => (
//                       <div key={emp._id} className="bg-gray-50 p-4 rounded-lg flex items-center justify-between">
//                         <div>
//                           <h4 className="font-medium text-gray-900">{emp.teamMemberName || emp.name}</h4>
//                           <p className="text-sm text-gray-500">{emp.email || 'No email provided'}</p>
//                         </div>
//                         <span className="text-sm px-3 py-1 bg-blue-100 text-blue-800 rounded-full">
//                           Employee
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="text-center py-8">
//                     <p className="text-gray-500">No employees found in this department.</p>
//                   </div>
//                 )}
//               </div>
//               <div className="p-4 border-t border-gray-200 flex justify-end">
//                 <button
//                   onClick={closeDeptModal}
//                   className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* 📊 EMPLOYEE ATTENDANCE MODAL */}
//         {isEmployeeModalOpen && selectedEmployeeForReport && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[5000]">
//             <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[95vh] flex flex-col">
//               {/* Modal Header */}
//               <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-t-xl">
//                 <div className="flex justify-between items-center">
//                   <div>
//                     <h3 className="text-2xl font-bold">📊 {selectedEmployeeForReport.displayName || selectedEmployeeForReport.teamMemberName || selectedEmployeeForReport.name}</h3>
//                     <p className="text-green-100 mt-1">Attendance Records & Management</p>
//                   </div>
//                   <button
//                     onClick={closeEmployeeModal}
//                     className="text-white hover:text-green-200 transition-colors"
//                   >
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                     </svg>
//                   </button>
//                 </div>
//               </div>

//               {/* Modal Body */}
//               <div className="p-6 overflow-y-auto flex-1">
//                 {/* Employee Info */}
//                 <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-6 mb-6">
//                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//                     <div className="bg-white rounded-lg p-4 border border-green-100">
//                       <span className="text-sm font-medium text-gray-600 flex items-center">
//                         📧 Email:
//                       </span>
//                       <p className="text-gray-800 font-semibold mt-1">
//                         {selectedEmployeeForReport.email || 'No email provided'}
//                       </p>
//                     </div>
//                     <div className="bg-white rounded-lg p-4 border border-green-100">
//                       <span className="text-sm font-medium text-gray-600 flex items-center">
//                         Department:
//                       </span>
//                       <p className="text-gray-800 font-semibold mt-1">
//                         {selectedEmployeeForReport.departmentName ||
//                           selectedEmployeeForReport.department?.name ||
//                           'No Department'}
//                       </p>
//                     </div>
//                     <div className="bg-white rounded-lg p-4 border border-green-100">
//                       <span className="text-sm font-medium text-gray-600 flex items-center">
//                         ž Phone:
//                       </span>
//                       <p className="text-gray-800 font-semibold mt-1">
//                         {selectedEmployeeForReport.phone !== 'N/A' ?
//                           selectedEmployeeForReport.phone :
//                           'No phone provided'}
//                       </p>
//                     </div>
//                     <div className="bg-white rounded-lg p-4 border border-green-100">
//                       <span className="text-sm font-medium text-gray-600 flex items-center">
//                         🕒 Shift:
//                       </span>
//                       <p className="text-gray-800 font-semibold mt-1">
//                         {loadingShiftInfo ? (
//                           <span className="text-blue-600">Loading...</span>
//                         ) : employeeShiftInfo ? (
//                           <span className="text-green-700">{employeeShiftInfo.shiftName}</span>
//                         ) : (
//                           <span className="text-gray-500">No shift assigned</span>
//                         )}
//                       </p>
//                       {employeeShiftInfo && employeeShiftInfo.shiftTiming && (
//                         <p className="text-xs text-gray-500 mt-1">
//                           {employeeShiftInfo.shiftTiming}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Add New Attendance Button */}
//                 <div className="mb-6">
//                   <button
//                     onClick={() => handleEditAttendance({})}
//                     className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-3 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 font-medium"
//                   >
//                     ž• Add New Attendance Record
//                   </button>
//                 </div>

//                 {/* 🔍 FILTER CONTROLS */}
//                 <div className="mb-6 bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-6 border border-gray-200">
//                   <div className="flex items-center justify-between mb-4">
//                     <h4 className="text-lg font-semibold text-gray-800 flex items-center">
//                       🔍 Filter Attendance Records
//                     </h4>
//                     <div className="flex items-center space-x-4">
//                       {/* View Toggle Buttons for Attendance Records */}
//                       <div className="flex items-center space-x-2 bg-white rounded-lg p-1 shadow-sm">
//                         <button
//                           onClick={() => setAttendanceViewMode('table')}
//                           className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${attendanceViewMode === 'table'
//                               ? 'bg-blue-500 text-white shadow-sm'
//                               : 'text-gray-600 hover:text-gray-800'
//                             }`}
//                         >
//                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 6h18m-9 8h9" />
//                           </svg>
//                           <span>📊 Table</span>
//                         </button>
//                         <button
//                           onClick={() => setAttendanceViewMode('calendar')}
//                           className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${attendanceViewMode === 'calendar'
//                               ? 'bg-blue-500 text-white shadow-sm'
//                               : 'text-gray-600 hover:text-gray-800'
//                             }`}
//                         >
//                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                           </svg>
//                           <span>📅 Calendar</span>
//                         </button>
//                       </div>
//                       <button
//                         onClick={() => {
//                           setSelectedFilterMonth(new Date().getMonth());
//                           setSelectedFilterYear(new Date().getFullYear());
//                           setAttendanceStatusFilter('all');
//                         }}
//                         className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//                       >
//                         🔄 Reset Filters
//                       </button>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                     {/* Month Filter */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         📅 Month
//                       </label>
//                       <select
//                         value={selectedFilterMonth}
//                         onChange={(e) => setSelectedFilterMonth(parseInt(e.target.value))}
//                         className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       >
//                         {Array.from({ length: 12 }, (_, i) => (
//                           <option key={i} value={i}>
//                             {new Date(2024, i, 1).toLocaleDateString('en-US', { month: 'long' })}
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     {/* Year Filter */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         📅 Year
//                       </label>
//                       <select
//                         value={selectedFilterYear}
//                         onChange={(e) => setSelectedFilterYear(parseInt(e.target.value))}
//                         className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       >
//                         {Array.from({ length: 5 }, (_, i) => {
//                           const year = new Date().getFullYear() - 2 + i;
//                           return (
//                             <option key={year} value={year}>
//                               {year}
//                             </option>
//                           );
//                         })}
//                       </select>
//                     </div>

//                     {/* Status Filter */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         📊 Status
//                       </label>
//                       <select
//                         value={attendanceStatusFilter}
//                         onChange={(e) => setAttendanceStatusFilter(e.target.value)}
//                         className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       >
//                         <option value="all">All Status</option>
//                         <option value="present">✅ Present</option>
//                         <option value="absent">❌ Absent</option>
//                         <option value="half-day"> Half Day</option>
//                         <option value="holiday">🎉 Holiday</option>
//                       </select>
//                     </div>

//                   </div>
//                 </div>

//                 {/* Attendance Records */}
//                 {loadingAttendance ? (
//                   <div className="flex justify-center items-center h-32">
//                     <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
//                     <span className="ml-3 text-gray-600">Loading attendance records...</span>
//                   </div>
//                 ) : attendanceError ? (
//                   <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
//                     <div className="text-red-600 text-lg mb-2">⚠️ Error Loading Attendance</div>
//                     <p className="text-red-700">{attendanceError}</p>
//                     <button
//                       onClick={() => fetchEmployeeAttendance(selectedEmployeeForReport._id)}
//                       className="mt-3 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
//                     >
//                       🔄 Try Again
//                     </button>
//                   </div>
//                 ) : (() => {
//                   // Generate dates for selected month/year and merge with attendance records
//                   const monthDates = generateMonthDates(selectedFilterMonth, selectedFilterYear);
//                   const mergedAttendanceData = mergeAttendanceWithMonthDates(attendanceRecords, monthDates, holidays, companyData);

//                   // Apply status filtering with enhanced logic
//                   let filteredAttendanceData = mergedAttendanceData;

//                   // Debug: Log all unique statuses to understand the data
//                   const uniqueStatuses = [...new Set(mergedAttendanceData.map(record => record.status))];
//                   console.log('🔍 UNIQUE STATUSES IN DATA:', uniqueStatuses);
//                   console.log('🎯 CURRENT FILTER:', attendanceStatusFilter);

//                   if (attendanceStatusFilter !== 'all') {
//                     filteredAttendanceData = mergedAttendanceData.filter(record => {
//                       const status = (record.status || '').toLowerCase().trim();

//                       // Debug: Log each record being filtered
//                       console.log('🔍 FILTERING RECORD:', {
//                         date: record.date,
//                         originalStatus: record.status,
//                         normalizedStatus: status,
//                         isHoliday: record.isHoliday,
//                         filterType: attendanceStatusFilter
//                       });

//                       let matches = false;

//                       switch (attendanceStatusFilter) {
//                         case 'present':
//                           matches = status === 'present' ||
//                             (record.inTime && record.outTime && !status.includes('absent') && !status.includes('holiday'));
//                           break;
//                         case 'absent':
//                           matches = status === 'absent' ||
//                             status === 'future' ||
//                             (!record.inTime && !record.isHoliday && !record.isFuture);
//                           break;
//                         case 'half-day':
//                           matches = status === 'half day' ||
//                             status === 'half-day' ||
//                             status === 'halfday' ||
//                             status.includes('half');
//                           break;
//                         case 'holiday':
//                           matches = record.isHoliday ||
//                             record.isCompanyHoliday ||
//                             record.isWeeklyHoliday ||
//                             status === 'company holiday' ||
//                             status === 'weekly holiday' ||
//                             status.includes('holiday');
//                           break;
//                         default:
//                           matches = true;
//                       }

//                       console.log('✅ FILTER RESULT:', { matches, reason: `Status: ${status}, Filter: ${attendanceStatusFilter}` });
//                       return matches;
//                     });
//                   }

//                   console.log('🔍 FILTERED ATTENDANCE DATA:', {
//                     originalCount: mergedAttendanceData.length,
//                     filteredCount: filteredAttendanceData.length,
//                     filterType: attendanceStatusFilter,
//                     month: selectedFilterMonth + 1,
//                     year: selectedFilterYear,
//                     sampleFilteredRecords: filteredAttendanceData.slice(0, 3).map(r => ({
//                       date: r.date,
//                       status: r.status,
//                       inTime: r.inTime,
//                       outTime: r.outTime,
//                       isHoliday: r.isHoliday
//                     }))
//                   });

//                   return filteredAttendanceData.length > 0 ? (
//                     <div className="space-y-4">
//                       {/* Filter Status Indicator */}
//                       <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//                         <div className="flex items-center justify-between">
//                           <div className="flex items-center space-x-4">
//                             <span className="text-blue-800 font-medium">
//                               📊 Showing {filteredAttendanceData.length} records for:
//                             </span>
//                             <div className="flex items-center space-x-2">
//                               <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
//                                 📅 {new Date(selectedFilterYear, selectedFilterMonth, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
//                               </span>
//                               {attendanceStatusFilter !== 'all' && (
//                                 <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
//                                   📊 {attendanceStatusFilter === 'present' ? '✅ Present' :
//                                     attendanceStatusFilter === 'absent' ? '❌ Absent' :
//                                       attendanceStatusFilter === 'half-day' ? ' Half Day' :
//                                         attendanceStatusFilter === 'holiday' ? '🎉 Holiday' : attendanceStatusFilter}
//                                 </span>
//                               )}
//                               <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium">
//                                 {attendanceViewMode === 'table' ? '📊 Table View' : '📅 Calendar View'}
//                               </span>
//                             </div>
//                           </div>
//                           {(selectedFilterMonth !== new Date().getMonth() || selectedFilterYear !== new Date().getFullYear()) && (
//                             <button
//                               onClick={() => {
//                                 setSelectedFilterMonth(new Date().getMonth());
//                                 setSelectedFilterYear(new Date().getFullYear());
//                               }}
//                               className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//                             >
//                               🔄 Clear Filters
//                             </button>
//                           )}
//                         </div>
//                       </div>

//                       {/* 📊 ATTENDANCE TABLE VIEW */}
//                       {attendanceViewMode === 'table' && (
//                         <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
//                           <div className="overflow-x-auto">
//                             <table className="min-w-full divide-y divide-gray-200">
//                               {/* Table Header */}
//                               <thead className="bg-gradient-to-r from-green-50 to-emerald-50">
//                                 <tr>
//                                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                     📅 Date
//                                   </th>
//                                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                     •˜ In Time
//                                   </th>
//                                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                     •• Out Time
//                                   </th>
//                                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                     ï Working Time
//                                   </th>
//                                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
//                                     📊 Status
//                                   </th>
//                                   <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
//                                     š™ï Actions
//                                   </th>
//                                 </tr>
//                               </thead>

//                               {/* Table Body */}
//                               <tbody className="bg-white divide-y divide-gray-200">
//                                 {filteredAttendanceData.map((record, index) => (
//                                   <tr key={record.id || record._id || `date-${record.date}`} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
//                                     } ${record.hasAttendance ? '' : 'bg-gray-50'
//                                     } ${record.isToday ? 'ring-2 ring-blue-200 bg-blue-50' : ''
//                                     } ${record.isHoliday ? 'ring-2 ring-purple-200 bg-purple-50' : ''
//                                     }`}>
//                                     {/* Date Column */}
//                                     <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                       <div className="flex flex-col">
//                                         <div className={`text-sm font-medium ${record.isToday ? 'text-blue-700 font-bold' :
//                                             record.isCompanyHoliday ? 'text-purple-700 font-bold' :
//                                               record.isWeeklyHoliday ? 'text-red-600 font-bold' :
//                                                 record.hasAttendance ? 'text-gray-900' : 'text-gray-500'
//                                           }`}>
//                                           {record.date ? new Date(record.date).toLocaleDateString('en-US', {
//                                             weekday: 'short',
//                                             year: 'numeric',
//                                             month: 'short',
//                                             day: 'numeric'
//                                           }) : 'N/A'}
//                                         </div>
//                                         {record.isToday && (
//                                           <div className="text-xs text-blue-600 font-medium mt-1">
//                                             📅 Today
//                                           </div>
//                                         )}
//                                         {record.isCompanyHoliday && (
//                                           <div className="text-xs text-purple-600 font-medium mt-1">
//                                             🎉 {record.holidayName}
//                                           </div>
//                                         )}
//                                         {record.isWeeklyHoliday && !record.isCompanyHoliday && (
//                                           <div className="text-xs text-red-600 font-medium mt-1">
//                                             📅 {record.weeklyHolidayName}
//                                           </div>
//                                         )}
//                                         {!record.hasAttendance && !record.isFuture && !record.isHoliday && (
//                                           <div className="text-xs text-red-500 mt-1">
//                                             ❌ No Record
//                                           </div>
//                                         )}
//                                         {record.isFuture && (
//                                           <div className="text-xs text-gray-400 mt-1">
//                                              Future
//                                           </div>
//                                         )}
//                                       </div>
//                                     </td>

//                                     {/* In Time Column */}
//                                     <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                       <div className="text-sm text-gray-900">
//                                         {(() => {
//                                           if (!record.hasAttendance) {
//                                             return (
//                                               <span className={`px-2 py-1 rounded-md text-xs font-medium ${record.isFuture ? 'bg-gray-100 text-gray-500' : 'bg-red-100 text-red-600'
//                                                 }`}>
//                                                 {record.isFuture ? ' Future' : '❌ No Punch In'}
//                                               </span>
//                                             );
//                                           }

//                                           // Use the same formatting logic as edit modal
//                                           let displayTime = '-';

//                                           if (record.inTime) {
//                                             // If it's a datetime-local format (from edit), format it
//                                             if (record.inTime.includes('T') && !record.inTime.includes('Z')) {
//                                               displayTime = formatDateTimeForDisplay(record.inTime);
//                                             } else {
//                                               // Use existing display time or format UTC time
//                                               displayTime = record.displayInTime || formatTimeUTC(record.inTime);
//                                             }
//                                           }

//                                           return displayTime && displayTime !== '-' ? (
//                                             <span className="bg-green-100 text-green-800 px-2 py-1 rounded-md font-medium">
//                                               {displayTime}
//                                             </span>
//                                           ) : (
//                                             <span className="text-gray-400 italic">-</span>
//                                           );
//                                         })()}
//                                       </div>
//                                     </td>

//                                     {/* Out Time Column */}
//                                     <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                       <div className="text-sm text-gray-900">
//                                         {(() => {
//                                           if (!record.hasAttendance) {
//                                             return (
//                                               <span className={`px-2 py-1 rounded-md text-xs font-medium ${record.isFuture ? 'bg-gray-100 text-gray-500' : 'bg-red-100 text-red-600'
//                                                 }`}>
//                                                 {record.isFuture ? ' Future' : '❌ No Punch Out'}
//                                               </span>
//                                             );
//                                           }

//                                           // Use the same formatting logic as edit modal
//                                           let displayTime = '-';

//                                           if (record.outTime) {
//                                             // If it's a datetime-local format (from edit), format it
//                                             if (record.outTime.includes('T') && !record.outTime.includes('Z')) {
//                                               displayTime = formatDateTimeForDisplay(record.outTime);
//                                             } else {
//                                               // Use existing display time or format UTC time
//                                               displayTime = record.displayOutTime || formatTimeUTC(record.outTime);
//                                             }
//                                           }

//                                           return displayTime && displayTime !== '-' ? (
//                                             <span className="bg-red-100 text-red-800 px-2 py-1 rounded-md font-medium">
//                                               {displayTime}
//                                             </span>
//                                           ) : (
//                                             <span className="text-gray-400 italic">-</span>
//                                           );
//                                         })()}
//                                       </div>
//                                     </td>

//                                     {/* Working Time Column */}
//                                     <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                       <div className="text-sm font-semibold text-gray-900">
//                                         {record.inTime && record.outTime ? (
//                                           <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md font-medium">
//                                             {calculateEnhancedWorkingTime(record.inTime, record.outTime)}
//                                           </span>
//                                         ) : record.workingTime && record.workingTime !== '--:--' ? (
//                                           <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md font-medium">
//                                             {record.workingTime}
//                                           </span>
//                                         ) : (
//                                           <span className="text-gray-400 italic">--:--</span>
//                                         )}
//                                       </div>
//                                     </td>

//                                     {/* Status Column - Shift-Based Calculation */}
//                                     <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
//                                       {(() => {
//                                         // Check if it's a holiday first
//                                         if (record.isHoliday) {
//                                           return (
//                                             <div className="space-y-1">
//                                               <span className="inline-flex px-3 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
//                                                 🎉 Holiday
//                                               </span>
//                                               <div className="text-xs text-orange-600">
//                                                 {record.holidayName}
//                                               </div>
//                                               {record.holidayType && (
//                                                 <div className="text-xs text-gray-500">
//                                                   {record.holidayType}
//                                                 </div>
//                                               )}
//                                             </div>
//                                           );
//                                         }

//                                         // Calculate shift-based status for non-holiday dates
//                                         const shiftStatus = calculateShiftBasedStatus(record, employeeShiftInfo);
//                                         const statusText = shiftStatus.status;
//                                         const completionPercentage = shiftStatus.completionPercentage;

//                                         // Determine badge color based on calculated status
//                                         const badgeClass =
//                                           statusText === 'Present' ? 'bg-green-100 text-green-800' :
//                                             statusText === 'Absent' ? 'bg-red-100 text-red-800' :
//                                               statusText === 'Late' ? 'bg-yellow-100 text-yellow-800' :
//                                                 statusText === 'Half Day' ? 'bg-orange-100 text-orange-800' :
//                                                   statusText === 'Incomplete' ? 'bg-blue-100 text-blue-800' :
//                                                     statusText === 'Future' ? 'bg-gray-100 text-gray-800' :
//                                                       'bg-gray-100 text-gray-800';

//                                         return (
//                                           <div className="space-y-1">
//                                             <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${badgeClass}`}>
//                                               {statusText}
//                                             </span>
//                                             {employeeShiftInfo && completionPercentage > 0 && (
//                                               <div className="text-xs text-gray-500">
//                                                 {completionPercentage}% of shift
//                                               </div>
//                                             )}
//                                             {employeeShiftInfo && shiftStatus.workingHours && shiftStatus.shiftHours && (
//                                               <div className="text-xs text-gray-400">
//                                                 {shiftStatus.workingHours}h / {shiftStatus.shiftHours}h
//                                               </div>
//                                             )}
//                                           </div>
//                                         );
//                                       })()}
//                                     </td>

//                                     {/* Actions Column */}
//                                     <td className="px-6 py-4 whitespace-nowrap text-center">
//                                       <div className="flex justify-center space-x-2">
//                                         {/* View Button */}
//                                         <button
//                                           onClick={() => {
//                                             const formattedDate = record.date ? new Date(record.date).toLocaleDateString('en-US', {
//                                               weekday: 'long',
//                                               year: 'numeric',
//                                               month: 'long',
//                                               day: 'numeric'
//                                             }) : 'N/A';

//                                             // Use the same formatting logic as table display
//                                             let displayInTime = '-';
//                                             let displayOutTime = '-';

//                                             if (record.inTime) {
//                                               if (record.inTime.includes('T') && !record.inTime.includes('Z')) {
//                                                 displayInTime = formatDateTimeForDisplay(record.inTime);
//                                               } else {
//                                                 displayInTime = record.displayInTime || formatTimeUTC(record.inTime);
//                                               }
//                                             }

//                                             if (record.outTime) {
//                                               if (record.outTime.includes('T') && !record.outTime.includes('Z')) {
//                                                 displayOutTime = formatDateTimeForDisplay(record.outTime);
//                                               } else {
//                                                 displayOutTime = record.displayOutTime || formatTimeUTC(record.outTime);
//                                               }
//                                             }

//                                             const calculatedWorkingTime = record.inTime && record.outTime ?
//                                               calculateEnhancedWorkingTime(record.inTime, record.outTime) :
//                                               (record.workingTime || '--:--');

//                                             // Calculate shift-based status for popup
//                                             const shiftStatus = calculateShiftBasedStatus(record, employeeShiftInfo);

//                                             let shiftInfo = '';
//                                             if (employeeShiftInfo) {
//                                               shiftInfo = `\n\n🕒 Shift Analysis:\nShift Hours: ${shiftStatus.shiftHours}h\nWorked Hours: ${shiftStatus.workingHours}h\nCompletion: ${shiftStatus.completionPercentage}%\nCalculated Status: ${shiftStatus.status}\nReason: ${shiftStatus.reason}`;
//                                             }

//                                             setShowAlert(`📋 Attendance Details:\n\nDate: ${formattedDate}\nIn Time: ${displayInTime}\nOut Time: ${displayOutTime}\nWorking Hours: ${calculatedWorkingTime}\nOriginal Status: ${record.status || 'Unknown'}\nIn Location: ${record.inLocation || '-'}\nOut Location: ${record.outLocation || '-'}\nNotes: ${record.notes || 'No notes'}${shiftInfo}`);
//                                           }}
//                                           className="text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded-md text-sm font-medium transition-colors"
//                                           title="View Details"
//                                         >
//                                           ï View
//                                         </button>

//                                         {/* Edit Button */}
//                                         <button
//                                           onClick={() => {
//                                             if (record.isFuture) {
//                                               setShowAlert(' Cannot edit future dates.\n\nYou can only edit attendance records for past and current dates.');
//                                               return;
//                                             }
//                                             handleEditAttendance(record);
//                                           }}
//                                           className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${record.isFuture
//                                               ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
//                                               : 'text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100'
//                                             }`}
//                                           title={record.isFuture ? 'Cannot edit future dates' : 'Edit Record'}
//                                           disabled={record.isFuture}
//                                         >
//                                           ✅ï Edit
//                                         </button>

//                                         {/* Delete Button */}
//                                         <button
//                                           onClick={() => {
//                                             if (!record.hasAttendance || record.isSynthetic) {
//                                               setShowAlert('❌ Cannot delete this record.\n\nThis date has no actual attendance record to delete.');
//                                               return;
//                                             }
//                                             handleDeleteAttendance(record.id || record._id);
//                                           }}
//                                           className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${!record.hasAttendance || record.isSynthetic
//                                               ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
//                                               : 'text-red-600 hover:text-red-800 bg-red-50 hover:bg-red-100'
//                                             }`}
//                                           title={!record.hasAttendance || record.isSynthetic ? 'No record to delete' : 'Delete Record'}
//                                           disabled={!record.hasAttendance || record.isSynthetic}
//                                         >
//                                           —ï Delete
//                                         </button>
//                                       </div>
//                                     </td>
//                                   </tr>
//                                 ))}
//                               </tbody>
//                             </table>
//                           </div>

//                           {/* Table Footer with Summary */}
//                           <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
//                               {/* Attendance Summary */}
//                               <div>
//                                 <span className="font-medium">📊 Attendance Summary:</span>
//                                 <div className="mt-1">
//                                   {(() => {
//                                     // Calculate attendance statistics with enhanced logic
//                                     const totalDays = filteredAttendanceData.length;

//                                     // Present: Records with actual attendance (inTime and outTime) or status 'Present'
//                                     const presentCount = filteredAttendanceData.filter(r => {
//                                       const status = (r.status || '').toLowerCase().trim();
//                                       return status === 'present' ||
//                                         (r.hasAttendance && r.inTime && r.outTime && !r.isHoliday && !r.isFuture);
//                                     }).length;

//                                     // Half Day: Records with half day status or incomplete attendance
//                                     const halfDayCount = filteredAttendanceData.filter(r => {
//                                       const status = (r.status || '').toLowerCase().trim();
//                                       return status === 'half day' || status === 'half-day' || status === 'halfday' ||
//                                         status.includes('half') ||
//                                         (r.hasAttendance && r.inTime && !r.outTime);
//                                     }).length;

//                                     // Holidays: Company holidays and weekly holidays
//                                     const holidayCount = filteredAttendanceData.filter(r => r.isHoliday).length;

//                                     // Absent: No attendance and not holiday or future
//                                     const absentCount = filteredAttendanceData.filter(r => {
//                                       const status = (r.status || '').toLowerCase().trim();
//                                       return (status === 'absent' || (!r.hasAttendance && !r.isHoliday && !r.isFuture)) && !r.isHoliday;
//                                     }).length;

//                                     // Future: Future dates
//                                     const futureCount = filteredAttendanceData.filter(r => r.isFuture).length;

//                                     return (
//                                       <>
//                                         Total Days: <strong>{totalDays}</strong> |
//                                         Present: <strong className="text-green-600 ml-2">{presentCount}</strong> |
//                                         Half Day: <strong className="text-orange-600 ml-2">{halfDayCount}</strong> |
//                                         Holidays: <strong className="text-orange-600 ml-2">{holidayCount}</strong> |
//                                         Absent: <strong className="text-red-600 ml-2">{absentCount}</strong> |
//                                         Future: <strong className="text-gray-600 ml-2">{futureCount}</strong>
//                                       </>
//                                     );
//                                   })()}
//                                 </div>
//                               </div>

//                               {/* Working Hours Summary */}
//                               <div>
//                                 <span className="font-medium">ï Working Hours Summary:</span>
//                                 <div className="mt-1">
//                                   {(() => {
//                                     // Enhanced working hours calculation
//                                     const validRecords = filteredAttendanceData.filter(r => {
//                                       return r.hasAttendance && r.inTime && r.outTime && !r.isHoliday && !r.isFuture;
//                                     });

//                                     console.log('ï WORKING HOURS CALCULATION:', {
//                                       totalRecords: filteredAttendanceData.length,
//                                       validRecords: validRecords.length,
//                                       sampleRecords: validRecords.slice(0, 3).map(r => ({
//                                         date: r.date,
//                                         inTime: r.inTime,
//                                         outTime: r.outTime,
//                                         workingTime: r.workingTime
//                                       }))
//                                     });

//                                     const totalMinutes = validRecords.reduce((total, record) => {
//                                       const workingMinutes = calculateWorkingMinutes(record.inTime, record.outTime);
//                                       return total + workingMinutes;
//                                     }, 0);

//                                     const totalHours = Math.floor(totalMinutes / 60);
//                                     const remainingMinutes = totalMinutes % 60;
//                                     const avgMinutes = validRecords.length > 0 ? Math.floor(totalMinutes / validRecords.length) : 0;
//                                     const avgHours = Math.floor(avgMinutes / 60);
//                                     const avgMins = avgMinutes % 60;

//                                     // Calculate attendance rate
//                                     const workingDays = filteredAttendanceData.filter(r => !r.isHoliday && !r.isFuture).length;
//                                     const attendanceRate = workingDays > 0 ? Math.round((validRecords.length / workingDays) * 100) : 0;

//                                     return (
//                                       <>
//                                         Total: <strong className="text-blue-600">{totalHours}h {remainingMinutes}m</strong> |
//                                         Average: <strong className="text-indigo-600 ml-2">{avgHours}h {avgMins}m</strong> |
//                                         Days Worked: <strong className="text-green-600 ml-2">{validRecords.length}</strong> |
//                                         Rate: <strong className="text-purple-600 ml-2">{attendanceRate}%</strong>
//                                       </>
//                                     );
//                                   })()}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       )}

//                       {/* 📅 ATTENDANCE CALENDAR VIEW */}
//                       {attendanceViewMode === 'calendar' && (
//                         <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
//                           {(() => {
//                             // Create calendar grid for the selected month
//                             const year = selectedFilterYear;
//                             const month = selectedFilterMonth;
//                             const firstDay = new Date(year, month, 1);
//                             const lastDay = new Date(year, month + 1, 0);
//                             const startDate = new Date(firstDay);
//                             startDate.setDate(startDate.getDate() - firstDay.getDay()); // Start from Sunday

//                             const endDate = new Date(lastDay);
//                             endDate.setDate(endDate.getDate() + (6 - lastDay.getDay())); // End on Saturday

//                             const calendarDates = [];
//                             const currentDate = new Date(startDate);

//                             while (currentDate <= endDate) {
//                               const dateString = currentDate.toISOString().split('T')[0];
//                               const attendanceRecord = filteredAttendanceData.find(record => record.date === dateString);
//                               const isCurrentMonth = currentDate.getMonth() === month;
//                               const isToday = dateString === new Date().toISOString().split('T')[0];

//                               calendarDates.push({
//                                 date: dateString,
//                                 dateObj: new Date(currentDate),
//                                 dayNumber: currentDate.getDate(),
//                                 isCurrentMonth,
//                                 isToday,
//                                 attendanceRecord
//                               });

//                               currentDate.setDate(currentDate.getDate() + 1);
//                             }

//                             // Group dates into weeks
//                             const weeks = [];
//                             for (let i = 0; i < calendarDates.length; i += 7) {
//                               weeks.push(calendarDates.slice(i, i + 7));
//                             }

//                             return (
//                               <div className="p-6">
//                                 {/* Calendar Header */}
//                                 <div className="mb-6">
//                                   <h3 className="text-2xl font-bold text-gray-800 text-center mb-4">
//                                     📅 {new Date(year, month, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
//                                   </h3>

//                                   {/* Days of Week Header */}
//                                   <div className="grid grid-cols-7 gap-1 mb-2">
//                                     {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
//                                       <div key={day} className="p-3 text-center font-semibold text-gray-600 bg-gray-50 rounded-lg">
//                                         {day}
//                                       </div>
//                                     ))}
//                                   </div>
//                                 </div>

//                                 {/* Calendar Grid */}
//                                 <div className="space-y-1">
//                                   {weeks.map((week, weekIndex) => (
//                                     <div key={weekIndex} className="grid grid-cols-7 gap-1">
//                                       {week.map((dateInfo, dayIndex) => {
//                                         const { date, dateObj, dayNumber, isCurrentMonth, isToday, attendanceRecord } = dateInfo;

//                                         // Determine cell styling based on attendance status
//                                         let cellClass = 'min-h-[120px] p-2 border border-gray-200 rounded-lg transition-all hover:shadow-md cursor-pointer ';
//                                         let statusColor = 'bg-gray-50';
//                                         let statusIcon = '';
//                                         let statusText = '';

//                                         if (!isCurrentMonth) {
//                                           cellClass += 'opacity-30 ';
//                                           statusColor = 'bg-gray-100';
//                                         } else if (isToday) {
//                                           cellClass += 'ring-2 ring-blue-500 ';
//                                         }

//                                         if (attendanceRecord) {
//                                           if (attendanceRecord.isHoliday) {
//                                             statusColor = 'bg-orange-100 border-orange-300';
//                                             statusIcon = '🎉';
//                                             statusText = 'Holiday';
//                                           } else if (attendanceRecord.status === 'Present' || (attendanceRecord.inTime && attendanceRecord.outTime)) {
//                                             statusColor = 'bg-green-100 border-green-300';
//                                             statusIcon = '✅';
//                                             statusText = 'Present';
//                                           } else if (attendanceRecord.status === 'Absent' || (!attendanceRecord.inTime && !attendanceRecord.isHoliday)) {
//                                             statusColor = 'bg-red-100 border-red-300';
//                                             statusIcon = '❌';
//                                             statusText = 'Absent';
//                                           } else if (attendanceRecord.status?.toLowerCase().includes('half')) {
//                                             statusColor = 'bg-yellow-100 border-yellow-300';
//                                             statusIcon = '';
//                                             statusText = 'Half Day';
//                                           } else if (attendanceRecord.status === 'Incomplete' || (attendanceRecord.inTime && !attendanceRecord.outTime)) {
//                                             statusColor = 'bg-blue-100 border-blue-300';
//                                             statusIcon = '⚠️';
//                                             statusText = 'Incomplete';
//                                           } else {
//                                             statusColor = 'bg-gray-100 border-gray-300';
//                                             statusIcon = '';
//                                             statusText = 'Unknown';
//                                           }
//                                         } else if (isCurrentMonth) {
//                                           const isFuture = dateObj > new Date();
//                                           if (isFuture) {
//                                             statusColor = 'bg-gray-50 border-gray-200';
//                                             statusIcon = '';
//                                             statusText = 'Future';
//                                           } else {
//                                             statusColor = 'bg-red-50 border-red-200';
//                                             statusIcon = '❌';
//                                             statusText = 'No Record';
//                                           }
//                                         }

//                                         return (
//                                           <div
//                                             key={`${weekIndex}-${dayIndex}`}
//                                             className={`${cellClass} ${statusColor}`}
//                                             onClick={() => {
//                                               if (attendanceRecord && isCurrentMonth) {
//                                                 // Show attendance details in popup
//                                                 const formattedDate = dateObj.toLocaleDateString('en-US', {
//                                                   weekday: 'long',
//                                                   year: 'numeric',
//                                                   month: 'long',
//                                                   day: 'numeric'
//                                                 });

//                                                 const displayInTime = attendanceRecord.inTime ?
//                                                   (attendanceRecord.displayInTime || formatTimeUTC(attendanceRecord.inTime)) : '-';
//                                                 const displayOutTime = attendanceRecord.outTime ?
//                                                   (attendanceRecord.displayOutTime || formatTimeUTC(attendanceRecord.outTime)) : '-';
//                                                 const workingTime = attendanceRecord.inTime && attendanceRecord.outTime ?
//                                                   calculateEnhancedWorkingTime(attendanceRecord.inTime, attendanceRecord.outTime) : '--:--';

//                                                 setShowAlert(`📋 Attendance Details:\n\nDate: ${formattedDate}\nStatus: ${attendanceRecord.status || 'Unknown'}\nIn Time: ${displayInTime}\nOut Time: ${displayOutTime}\nWorking Hours: ${workingTime}\nIn Location: ${attendanceRecord.inLocation || '-'}\nOut Location: ${attendanceRecord.outLocation || '-'}\nNotes: ${attendanceRecord.notes || 'No notes'}`);
//                                               }
//                                             }}
//                                           >
//                                             {/* Date Number */}
//                                             <div className={`text-lg font-bold mb-2 ${isToday ? 'text-blue-600' :
//                                                 isCurrentMonth ? 'text-gray-800' : 'text-gray-400'
//                                               }`}>
//                                               {dayNumber}
//                                             </div>

//                                             {/* Status Info */}
//                                             {isCurrentMonth && (
//                                               <div className="space-y-1">
//                                                 <div className="flex items-center justify-center">
//                                                   <span className="text-2xl">{statusIcon}</span>
//                                                 </div>
//                                                 <div className={`text-xs font-medium text-center ${attendanceRecord?.isHoliday ? 'text-orange-700' :
//                                                     attendanceRecord?.status === 'Present' || (attendanceRecord?.inTime && attendanceRecord?.outTime) ? 'text-green-700' :
//                                                       attendanceRecord?.status === 'Absent' || (!attendanceRecord?.inTime && !attendanceRecord?.isHoliday) ? 'text-red-700' :
//                                                         attendanceRecord?.status?.toLowerCase().includes('half') ? 'text-yellow-700' :
//                                                           attendanceRecord?.status === 'Incomplete' ? 'text-blue-700' :
//                                                             'text-gray-600'
//                                                   }`}>
//                                                   {statusText}
//                                                 </div>

//                                                 {/* Working Hours */}
//                                                 {attendanceRecord?.inTime && attendanceRecord?.outTime && (
//                                                   <div className="text-xs text-gray-600 text-center mt-1">
//                                                     {calculateEnhancedWorkingTime(attendanceRecord.inTime, attendanceRecord.outTime)}
//                                                   </div>
//                                                 )}

//                                                 {/* Holiday Name */}
//                                                 {attendanceRecord?.isHoliday && attendanceRecord?.holidayName && (
//                                                   <div className="text-xs text-orange-600 text-center mt-1 truncate" title={attendanceRecord.holidayName}>
//                                                     {attendanceRecord.holidayName.length > 12 ?
//                                                       attendanceRecord.holidayName.substring(0, 12) + '...' :
//                                                       attendanceRecord.holidayName}
//                                                   </div>
//                                                 )}
//                                               </div>
//                                             )}
//                                           </div>
//                                         );
//                                       })}
//                                     </div>
//                                   ))}
//                                 </div>

//                                 {/* Calendar Legend */}
//                                 <div className="mt-6 p-4 bg-gray-50 rounded-lg">
//                                   <h4 className="text-sm font-semibold text-gray-700 mb-3">📋 Legend:</h4>
//                                   <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 text-xs">
//                                     <div className="flex items-center space-x-2">
//                                       <div className="w-4 h-4 bg-green-100 border border-green-300 rounded"></div>
//                                       <span>✅ Present</span>
//                                     </div>
//                                     <div className="flex items-center space-x-2">
//                                       <div className="w-4 h-4 bg-red-100 border border-red-300 rounded"></div>
//                                       <span>❌ Absent</span>
//                                     </div>
//                                     <div className="flex items-center space-x-2">
//                                       <div className="w-4 h-4 bg-yellow-100 border border-yellow-300 rounded"></div>
//                                       <span> Half Day</span>
//                                     </div>
//                                     <div className="flex items-center space-x-2">
//                                       <div className="w-4 h-4 bg-orange-100 border border-orange-300 rounded"></div>
//                                       <span>🎉 Holiday</span>
//                                     </div>
//                                     <div className="flex items-center space-x-2">
//                                       <div className="w-4 h-4 bg-blue-100 border border-blue-300 rounded"></div>
//                                       <span>⚠️ Incomplete</span>
//                                     </div>
//                                     <div className="flex items-center space-x-2">
//                                       <div className="w-4 h-4 bg-gray-50 border border-gray-200 rounded"></div>
//                                       <span> Future/No Record</span>
//                                     </div>
//                                   </div>
//                                   <div className="mt-3 text-xs text-gray-600">
//                                     💡 Click on any date with attendance data to view detailed information
//                                   </div>
//                                 </div>
//                               </div>
//                             );
//                           })()
//                           }
//                         </div>
//                       )}
//                     </div>
//                   ) : (
//                     <div className="text-center py-12">
//                       <div className="text-gray-400 text-6xl mb-4">📅</div>
//                       <h3 className="text-lg font-medium text-gray-600 mb-2">
//                         {attendanceStatusFilter !== 'all' ? 'No Records Match Filter' : 'No Attendance Records'}
//                       </h3>
//                       <p className="text-gray-500">
//                         {attendanceStatusFilter !== 'all'
//                           ? `No attendance records found with status "${attendanceStatusFilter}" for the selected period.`
//                           : 'No attendance records found for this employee.'}
//                       </p>
//                       {attendanceStatusFilter !== 'all' && (
//                         <button
//                           onClick={() => setAttendanceStatusFilter('all')}
//                           className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
//                         >
//                           🔄 Show All Records
//                         </button>
//                       )}
//                     </div>
//                   );
//                 })()}
//               </div>

//               {/* Modal Footer */}
//               <div className="p-4 border-t border-gray-200 flex justify-end">
//                 <button
//                   onClick={closeEmployeeModal}
//                   className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ✅ï ATTENDANCE EDIT MODAL */}
//         {isEditingAttendance && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[50000]">
//             <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl">
//               <div className="p-6 border-b border-gray-200">
//                 <h3 className="text-xl font-semibold text-gray-800">
//                   {editingRecord?.id || editingRecord?._id ? '✅ï Edit Attendance Record' : 'ž• Add New Attendance Record'}
//                 </h3>
//               </div>

//               {/* Validation Status Display */}
//               <div className="px-6 pt-4">
//                 {(() => {
//                   const employeeId = editingRecord?.employeeId || editingRecord?.employee?._id || editingRecord?.employee;
//                   const companyId = editingRecord?.companyId || editingRecord?.company?._id || editingRecord?.company;
//                   const hasValidationErrors = !employeeId || !companyId;

//                   if (hasValidationErrors) {
//                     return (
//                       <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
//                         <div className="flex items-center">
//                           <div className="flex-shrink-0">
//                             <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
//                               <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                             </svg>
//                           </div>
//                           <div className="ml-3">
//                             <h3 className="text-sm font-medium text-red-800">Validation Errors</h3>
//                             <div className="mt-2 text-sm text-red-700">
//                               <ul className="list-disc pl-5 space-y-1">
//                                 {!employeeId && <li>Employee ID is missing</li>}
//                                 {!companyId && <li>Company ID is missing</li>}
//                               </ul>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   } else {
//                     return (
//                       <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
//                         <div className="flex items-center">
//                           <div className="flex-shrink-0">
//                             <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
//                               <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                             </svg>
//                           </div>
//                           <div className="ml-3">
//                             <p className="text-sm font-medium text-green-800">
//                               ✅ Employee: {selectedEmployeeForReport?.teamMemberName || selectedEmployeeForReport?.name} |
//                               Company: {localStorage.getItem('selectedCompanyName') || 'Selected Company'}
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   }
//                 })()}
//               </div>

//               <div className="p-6 space-y-4">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Date *</label>
//                     <input
//                       type="date"
//                       value={editingRecord?.date || ''}
//                       onChange={(e) => setEditingRecord({ ...editingRecord, date: e.target.value })}
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">In Time *</label>
//                     <input
//                       type="datetime-local"
//                       value={editingRecord?.inTime || ''}
//                       onChange={(e) => setEditingRecord({ ...editingRecord, inTime: e.target.value })}
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       required
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Out Time</label>
//                     <input
//                       type="datetime-local"
//                       value={editingRecord?.outTime || ''}
//                       onChange={(e) => setEditingRecord({ ...editingRecord, outTime: e.target.value })}
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     />
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">In Location</label>
//                     <input
//                       type="text"
//                       value={editingRecord?.inLocation || ''}
//                       onChange={(e) => setEditingRecord({ ...editingRecord, inLocation: e.target.value })}
//                       placeholder="Enter check-in location"
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Out Location</label>
//                     <input
//                       type="text"
//                       value={editingRecord?.outLocation || ''}
//                       onChange={(e) => setEditingRecord({ ...editingRecord, outLocation: e.target.value })}
//                       placeholder="Enter check-out location"
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     />
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Working Time (Auto-calculated)</label>
//                     <input
//                       type="text"
//                       value={editingRecord?.inTime && editingRecord?.outTime ?
//                         calculateEnhancedWorkingTime(editingRecord.inTime, editingRecord.outTime) :
//                         '--:--'}
//                       readOnly
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-50 text-gray-600"
//                       placeholder="Auto-calculated from in/out times"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
//                     <select
//                       value={editingRecord?.status || 'Present'}
//                       onChange={(e) => setEditingRecord({ ...editingRecord, status: e.target.value })}
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     >
//                       <option value="Present">✅ Present</option>
//                       <option value="Absent">❌ Absent</option>
//                       <option value="Late"> Late</option>
//                       <option value="Half-day">• Half-day</option>
//                       <option value="Incomplete">⚠️ Incomplete</option>
//                     </select>
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">Notes & Remarks</label>
//                   <textarea
//                     value={editingRecord?.notes || ''}
//                     onChange={(e) => setEditingRecord({ ...editingRecord, notes: e.target.value })}
//                     placeholder="Add any additional notes, remarks, or comments about this attendance record..."
//                     rows={3}
//                     className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   />
//                 </div>
//               </div>

//               <div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
//                 <button
//                   onClick={() => {
//                     setIsEditingAttendance(false);
//                     setEditingRecord(null);
//                   }}
//                   className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleSaveAttendance}
//                   className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                 >
//                   💾 Save Attendance
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* 📢 NOTIFICATION SYSTEM */}
//         {notification.show && (
//           <div className={`fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg max-w-md ${notification.type === 'success' ? 'bg-green-500 text-white' :
//               notification.type === 'error' ? 'bg-red-500 text-white' :
//                 'bg-blue-500 text-white'
//             }`}>
//             <div className="flex items-center">
//               <span className="mr-2">
//                 {notification.type === 'success' ? '✅' : notification.type === 'error' ? '❌' : 'ℹ️ï'}
//               </span>
//               <p>{notification.message}</p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AttendanceReports;





import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import AlertBox from '../../Components/AlertBox';
// 🕒 TIME FORMATTING FUNCTIONS (Same as DailyAttendance.js)
// Format time to 12-hour format with AM/PM
const formatTo12Hour = (time24) => {
  if (!time24 || time24 === '-' || time24 === '--:--') return time24;

  try {
    const [hours, minutes] = time24.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return time24;

    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;

    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  } catch (error) {
    return time24; // Return original if formatting fails
  }
};

const formatTimeUTC = (time) => {
  console.log("time", time);

  if (!time) return '-';

  try {
    const date = new Date(time);
    if (isNaN(date.getTime())) return '-';

    // Use local time methods to preserve database time as-is (no UTC adjustment)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const time24 = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    return formatTo12Hour(time24);
  } catch (error) {
    return '-';
  }
};


// Format datetime-local input to display format
const formatDateTimeForDisplay = (dateTimeString) => {
  if (!dateTimeString) return 'Not recorded';

  try {
    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) return 'Invalid time';

    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    return 'Invalid time';
  }
};

// 🕒 WORKING HOURS CALCULATION (Same as DailyAttendance.js)
// Calculate work hours between punch in and punch out
const calculateWorkHours = (punchIn, punchOut) => {
  if (!punchIn || !punchOut) return '--:--';

  try {
    const inDate = new Date(punchIn);
    const outDate = new Date(punchOut);

    if (isNaN(inDate.getTime()) || isNaN(outDate.getTime())) return '--:--';

    const diffMs = outDate - inDate;
    if (diffMs <= 0) return '--:--';

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}:${minutes.toString().padStart(2, '0')}`;
  } catch (error) {
    return '--:--';
  }
};

// Calculate work hours from 24-hour time format (for compatibility)
const calculateWorkHoursFromTime = (punchIn, punchOut) => {
  if (!punchIn || !punchOut) return '--:--';

  try {
    // Handle both time strings and full datetime strings
    let inTime, outTime;

    if (punchIn.includes('T') || punchIn.includes(' ')) {
      // Full datetime string
      inTime = punchIn;
      outTime = punchOut;
    } else {
      // Time only string (HH:MM format)
      const today = new Date().toISOString().split('T')[0];
      inTime = `${today}T${punchIn}:00`;
      outTime = `${today}T${punchOut}:00`;
    }

    return calculateWorkHours(inTime, outTime);
  } catch (error) {
    return '--:--';
  }
};

// Enhanced working time calculation with proper formatting
const calculateEnhancedWorkingTime = (inTime, outTime) => {
  if (!inTime || !outTime) return '--:--';

  try {
    const inDate = new Date(inTime);
    const outDate = new Date(outTime);

    if (isNaN(inDate.getTime()) || isNaN(outDate.getTime())) return '--:--';

    const diffMs = outDate - inDate;
    if (diffMs <= 0) return '--:--';

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format like DailyAttendance.js: "8:30", "7:45", etc.
    return `${hours}:${minutes.toString().padStart(2, '0')}`;
  } catch (error) {
    return '--:--';
  }
};

// 🔄 ENHANCED DEPARTMENTS DISPLAY COMPONENT
// Clean department display for employees with multiple departments (no scrollbars)
const ScrollingDepartments = ({ departments, employeeId }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (!departments || departments.length <= 1) return;

    const interval = setInterval(() => {
      setIsAnimating(true);

      setTimeout(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === departments.length - 1 ? 0 : prevIndex + 1
        );
        setIsAnimating(false);
      }, 300); // Smooth animation duration
    }, 3000); // 3 second interval for better readability

    return () => clearInterval(interval);
  }, [departments]);

  if (!departments || departments.length === 0) {
    return (
      <div className="font-semibold text-gray-800 py-1">
        No Department
      </div>
    );
  }

  if (departments.length === 1) {
    return (
      <div className="font-semibold text-gray-800 py-1">
        {departments[0]}
      </div>
    );
  }

  return (
    <div className="relative min-h-[2rem] w-full">
      {/* Current department display */}
      <div
        className={`transition-all duration-300 ease-in-out transform ${isAnimating ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
          }`}
      >
        <div className="flex items-center justify-between w-full py-1">
          <div className="font-semibold text-gray-800 flex-1 pr-2 leading-tight">
            {departments[currentIndex]}
          </div>
          <div className="flex items-center space-x-1 flex-shrink-0">
            {/* Department indicator dots */}
            {departments.map((_, index) => (
              <div
                key={index}
                className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${index === currentIndex
                  ? 'bg-blue-500 scale-125'
                  : 'bg-gray-300 scale-100'
                  }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Department counter badge */}
      <div className="absolute -top-1 -right-1">
        <span className="inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-blue-500 rounded-full">
          {departments.length}
        </span>
      </div>

      {/* Progress indicator */}
      <div className="mt-1 w-full h-1 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-blue-400 to-blue-600 rounded-full transition-all duration-300 ease-out"
          style={{
            width: `${((currentIndex + 1) / departments.length) * 100}%`
          }}
        />
      </div>
    </div>
  );
};

// 📅 MONTHLY CALENDAR FUNCTIONS
// Generate all dates for the specified month and year
const generateMonthDates = (month = new Date().getMonth(), year = new Date().getFullYear()) => {
  // Get first and last day of specified month
  // Use UTC to avoid timezone shifts when generating the month grid
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const dates = [];

  // Generate all dates for the month
  for (let date = new Date(firstDay); date <= lastDay; date.setDate(date.getDate() + 1)) {
    // Format date as YYYY-MM-DD in LOCAL time to match what user expects
    const yearStr = date.getFullYear();
    const monthStr = (date.getMonth() + 1).toString().padStart(2, '0');
    const dayStr = date.getDate().toString().padStart(2, '0');
    const dateString = `${yearStr}-${monthStr}-${dayStr}`;

    dates.push({
      date: dateString,
      dateObj: new Date(date),
      dayName: date.toLocaleDateString('en-US', { weekday: 'short' }),
      dayNumber: date.getDate(),
      isToday: dateString === new Date().toLocaleDateString('en-CA'), // YYYY-MM-DD
      isPast: date < new Date().setHours(0, 0, 0, 0),
      isFuture: date > new Date().setHours(23, 59, 59, 999)
    });
  }

  return dates;
};

// Merge attendance records with all month dates
const mergeAttendanceWithMonthDates = (attendanceRecords = [], monthDates = [], holidays = [], selectedCompany = null) => {
  console.log('🗓️ï MERGING ATTENDANCE WITH MONTH DATES:', {
    attendanceRecords: attendanceRecords.length,
    monthDates: monthDates.length,
    holidays: holidays.length,
    hasCompanyData: !!selectedCompany
  });

  // Get company weekly holidays
  let weeklyHolidays = [];
  if (selectedCompany && selectedCompany.weeklyHoliday) {
    weeklyHolidays = Array.isArray(selectedCompany.weeklyHoliday)
      ? selectedCompany.weeklyHoliday
      : [selectedCompany.weeklyHoliday];
  } else if (selectedCompany && selectedCompany.weeklyHolidays) {
    weeklyHolidays = Array.isArray(selectedCompany.weeklyHolidays)
      ? selectedCompany.weeklyHolidays
      : [selectedCompany.weeklyHolidays];
  }

  // Convert day names to day numbers (0 = Sunday, 1 = Monday, etc.)
  const dayNameToNumber = {
    'sunday': 0, 'sun': 0,
    'monday': 1, 'mon': 1,
    'tuesday': 2, 'tue': 2, 'tues': 2,
    'wednesday': 3, 'wed': 3,
    'thursday': 4, 'thu': 4, 'thur': 4, 'thurs': 4,
    'friday': 5, 'fri': 5,
    'saturday': 6, 'sat': 6
  };

  const weeklyHolidayDayNumbers = weeklyHolidays.map(day =>
    dayNameToNumber[day.toLowerCase()] !== undefined ? dayNameToNumber[day.toLowerCase()] : -1
  ).filter(num => num !== -1);

  console.log('📅 WEEKLY HOLIDAYS PROCESSED:', {
    weeklyHolidays: weeklyHolidays,
    weeklyHolidayDayNumbers: weeklyHolidayDayNumbers,
    dayNames: weeklyHolidayDayNumbers.map(num => ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][num])
  });

  // Create a map of existing attendance records by date
  const attendanceMap = {};
  attendanceRecords.forEach(record => {
    if (record.date) {
      // Robust date extraction to YYYY-MM-DD
      let recordDate;
      try {
        const d = new Date(record.date);
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        recordDate = `${year}-${month}-${day}`;
      } catch (e) {
        recordDate = record.date.split('T')[0];
      }
      attendanceMap[recordDate] = record;
    } else if (record.inTime) {
      // If no date field, extract from inTime
      const d = new Date(record.inTime);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      const recordDate = `${year}-${month}-${day}`;
      attendanceMap[recordDate] = {
        ...record,
        date: recordDate
      };
    }
  });

  console.log('🎉 HOLIDAY MAP CREATION START:', {
    totalHolidays: holidays.length,
    holidayDates: holidays.map(h => h.date || h.startDate)
  });

  // Create a map of holidays by date (handling both single dates and ranges)
  const holidayMap = {};
  holidays.forEach(holiday => {
    if (holiday.startDate && holiday.endDate) {
      // Range holiday - map all dates in the range
      try {
        // Parse YYYY-MM-DD into local date components
        const parseYMD = (s) => {
          const [y, m, d] = s.split('-').map(n => parseInt(n, 10));
          return new Date(y, m - 1, d);
        };

        const start = parseYMD(holiday.startDate);
        const end = parseYMD(holiday.endDate);

        console.log(`📅 Mapping holiday range: ${holiday.name} (${holiday.startDate} to ${holiday.endDate})`);

        // Loop through each day in the range
        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
          // Format back to YYYY-MM-DD local
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          const dateStr = `${y}-${m}-${day}`;

          holidayMap[dateStr] = holiday;
          console.log(`   Mapped ${dateStr} to ${holiday.name}`);
        }
      } catch (err) {
        console.error('Error processing holiday range:', err);
      }
    } else if (holiday.date) {
      // Single date holiday
      holidayMap[holiday.date] = holiday;
      console.log(`Mapped single date ${holiday.date} to ${holiday.name}`);
    }
  });

  console.log('📊 ATTENDANCE MAP CREATED:', {
    mappedDates: Object.keys(attendanceMap).length,
    dates: Object.keys(attendanceMap)
  });

  console.log('🎉 FINAL HOLIDAY MAP:', {
    mappedHolidays: Object.keys(holidayMap).length,
    mappedDates: Object.keys(holidayMap)
  });

  // Merge month dates with attendance records, holiday information, and weekly holidays
  const mergedData = monthDates.map(monthDate => {
    const existingRecord = attendanceMap[monthDate.date];
    const holidayInfo = holidayMap[monthDate.date];
    const isCompanyHoliday = !!holidayInfo;

    // Check if this date is a weekly holiday
    // Use dateObj from monthDate to avoid timezone issues
    const dayOfWeek = monthDate.dateObj.getDay(); // 0 = Sunday, 1 = Monday, etc.
    const isWeeklyHoliday = weeklyHolidayDayNumbers.includes(dayOfWeek);
    const weeklyHolidayName = isWeeklyHoliday ? ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek] : null;

    if (existingRecord) {
      // Existing attendance record
      return {
        ...existingRecord,
        ...monthDate,
        hasAttendance: true,
        status: existingRecord.status || 'Present',
        displayInTime: existingRecord.displayInTime || (existingRecord.inTime ? formatTimeUTC(existingRecord.inTime) : null),
        displayOutTime: existingRecord.displayOutTime || (existingRecord.outTime ? formatTimeUTC(existingRecord.outTime) : null),
        workingTime: existingRecord.workingTime || (existingRecord.inTime && existingRecord.outTime ?
          calculateEnhancedWorkingTime(existingRecord.inTime, existingRecord.outTime) : null),
        // Add holiday information
        isCompanyHoliday: isCompanyHoliday,
        isWeeklyHoliday: isWeeklyHoliday,
        isHoliday: isCompanyHoliday || isWeeklyHoliday, // Either company or weekly holiday
        holidayInfo: holidayInfo,
        holidayName: isCompanyHoliday ? holidayInfo.name : (isWeeklyHoliday ? `Weekly Holiday (${weeklyHolidayName})` : null),
        holidayType: isCompanyHoliday ? holidayInfo.type : (isWeeklyHoliday ? 'Weekly' : null),
        weeklyHolidayName: weeklyHolidayName
      };
    } else {
      // No attendance record for this date - create synthetic record with proper IDs
      const holidayStatus = isCompanyHoliday ? 'Company Holiday' : (isWeeklyHoliday ? 'Weekly Holiday' : null);
      const finalStatus = holidayStatus || (monthDate.isFuture ? 'Future' : 'Absent');
      const holidayNotes = isCompanyHoliday ? `Company Holiday: ${holidayInfo.name}` :
        (isWeeklyHoliday ? `Weekly Holiday: ${weeklyHolidayName}` : 'No attendance record');

      return {
        ...monthDate,
        id: `no-record-${monthDate.date}`,
        hasAttendance: false,
        status: finalStatus,
        inTime: null,
        outTime: null,
        displayInTime: null,
        displayOutTime: null,
        workingTime: null,
        inLocation: null,
        outLocation: null,
        notes: monthDate.isFuture ? 'Future date' : holidayNotes,
        // Add synthetic flags to help with identification
        isSynthetic: true,
        needsEmployeeId: true,
        needsCompanyId: true,
        // Add holiday information
        isCompanyHoliday: isCompanyHoliday,
        isWeeklyHoliday: isWeeklyHoliday,
        isHoliday: isCompanyHoliday || isWeeklyHoliday, // Either company or weekly holiday
        holidayInfo: holidayInfo,
        holidayName: isCompanyHoliday ? holidayInfo.name : (isWeeklyHoliday ? `Weekly Holiday (${weeklyHolidayName})` : null),
        holidayType: isCompanyHoliday ? holidayInfo.type : (isWeeklyHoliday ? 'Weekly' : null),
        weeklyHolidayName: weeklyHolidayName
      };
    }
  });

  console.log('✅ MERGED ATTENDANCE DATA:', {
    totalDates: mergedData.length,
    withAttendance: mergedData.filter(d => d.hasAttendance).length,
    withoutAttendance: mergedData.filter(d => !d.hasAttendance).length,
    futureDates: mergedData.filter(d => d.isFuture).length,
    pastDates: mergedData.filter(d => d.isPast).length,
    companyHolidayDates: mergedData.filter(d => d.isCompanyHoliday).length,
    weeklyHolidayDates: mergedData.filter(d => d.isWeeklyHoliday).length,
    totalHolidayDates: mergedData.filter(d => d.isHoliday).length
  });

  return mergedData;
};

// 📊 ATTENDANCE CALCULATION FUNCTIONS
// Calculate current month attendance statistics for employee cards
const calculateCurrentMonthAttendance = (employeeId, attendanceRecords = []) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  // Filter attendance records for current month
  const currentMonthRecords = attendanceRecords.filter(record => {
    if (!record.date && !record.inTime) return false;

    // Robust date extraction
    const d = new Date(record.date || record.inTime);
    return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
  });

  // Count present, absent, and other statuses
  let presentCount = 0;
  let absentCount = 0;
  let lateCount = 0;
  let halfDayCount = 0;
  let incompleteCount = 0;

  currentMonthRecords.forEach(record => {
    const status = (record.status || '').toLowerCase().trim();

    if (status === 'absent') {
      absentCount++;
    } else if (status === 'present' || status === 'late') {
      presentCount++;
      if (status === 'late') lateCount++;
    } else if (status.includes('half')) {
      halfDayCount++;
      presentCount++; // Counted as present for the rate
    } else if (status === 'incomplete' || record.inTime) {
      // Incomplete or just has inTime counts as present (matching our new logic)
      presentCount++;
      if (status === 'incomplete') incompleteCount++;
    } else {
      absentCount++;
    }
  });

  // Calculate attendance rate
  const totalAttendanceDays = presentCount + absentCount;
  const attendanceRate = totalAttendanceDays > 0
    ? Math.round((presentCount / totalAttendanceDays) * 100)
    : 0;

  return {
    presentDays: presentCount,
    absentDays: absentCount,
    lateCount,
    halfDayCount,
    incompleteCount,
    attendanceRate,
    totalRecords: currentMonthRecords.length
  };
};

// Calculate working minutes for attendance records
const calculateWorkingMinutes = (inTime, outTime) => {
  if (!inTime || !outTime) return 0;

  try {
    const inDate = new Date(inTime);
    const outDate = new Date(outTime);

    if (isNaN(inDate.getTime()) || isNaN(outDate.getTime())) return 0;

    const diffMs = outDate - inDate;
    if (diffMs <= 0) return 0;

    return Math.floor(diffMs / (1000 * 60)); // Return minutes
  } catch (error) {
    return 0;
  }
};

// 🕒 SHIFT-BASED STATUS CALCULATION
// Calculate attendance status based on shift hours vs actual working hours
const calculateShiftBasedStatus = (record, employeeShiftInfo) => {
  // Reduced logging to prevent console spam
  // console.log('🕒 CALCULATING SHIFT-BASED STATUS:', {
  //   recordId: record.id || record._id,
  //   inTime: record.inTime,
  //   outTime: record.outTime,
  //   shiftInfo: employeeShiftInfo
  // });

  // If no punch times, return absent
  if (!record.inTime) {
    return {
      status: 'Absent',
      reason: 'No punch in time recorded',
      workingMinutes: 0,
      shiftMinutes: 0,
      completionPercentage: 0
    };
  }

  // If no punch out, return incomplete
  if (!record.outTime) {
    return {
      status: 'Incomplete',
      reason: 'No punch out time recorded',
      workingMinutes: 0,
      shiftMinutes: 0,
      completionPercentage: 0
    };
  }

  // Calculate actual working minutes
  const workingMinutes = calculateWorkingMinutes(record.inTime, record.outTime);

  // Get shift duration (default to 8 hours = 480 minutes if no shift info)
  let shiftMinutes = 480; // Default 8 hours

  if (employeeShiftInfo && employeeShiftInfo.shiftStartTime && employeeShiftInfo.shiftEndTime) {
    // Calculate shift duration from shift times
    const shiftStart = new Date(`2000-01-01T${employeeShiftInfo.shiftStartTime}`);
    const shiftEnd = new Date(`2000-01-01T${employeeShiftInfo.shiftEndTime}`);

    if (!isNaN(shiftStart.getTime()) && !isNaN(shiftEnd.getTime())) {
      const shiftDiffMs = shiftEnd - shiftStart;
      if (shiftDiffMs > 0) {
        shiftMinutes = Math.floor(shiftDiffMs / (1000 * 60));
      }
    }
  } else if (employeeShiftInfo && employeeShiftInfo.workingHours) {
    // Use working hours if available
    shiftMinutes = employeeShiftInfo.workingHours * 60;
  }

  // Calculate completion percentage
  const completionPercentage = shiftMinutes > 0 ? Math.round((workingMinutes / shiftMinutes) * 100) : 0;

  // Reduced logging to prevent console spam
  // console.log('📊 SHIFT CALCULATION RESULT:', {
  //   workingMinutes,
  //   shiftMinutes,
  //   completionPercentage,
  //   workingHours: (workingMinutes / 60).toFixed(2),
  //   shiftHours: (shiftMinutes / 60).toFixed(2)
  // });

  // Determine status based on working hours vs shift hours
  let status = 'Present';
  let reason = 'Full shift completed';

  // Leniency: If completion is >= 90%, mark as Present.
  // This accounts for small breaks or early/late punches.
  if (completionPercentage >= 90) {
    status = 'Present';
    reason = `Shift completed (${completionPercentage}%)`;
  } else if (workingMinutes > 0) {
    status = 'Half Day';
    reason = `Short shift (${completionPercentage}% completed)`;
  } else {
    // If we have punch times but 0 minutes (e.g. same-time punch)
    status = 'Present';
    reason = 'Record exists but zero duration';
  }

  // Override: If it was incomplete (no out time) but we want to show it as present (matching Android)
  if (!record.outTime && record.inTime) {
    return {
      status: 'Present',
      reason: 'Punched in (No punch out recorded)',
      workingMinutes: 0,
      shiftMinutes,
      completionPercentage: 0,
      workingHours: '0.00',
      shiftHours: (shiftMinutes / 60).toFixed(2),
      isIncomplete: true
    };
  }

  return {
    status,
    reason,
    workingMinutes,
    shiftMinutes,
    completionPercentage,
    workingHours: (workingMinutes / 60).toFixed(2),
    shiftHours: (shiftMinutes / 60).toFixed(2)
  };
};

const AttendanceReports = () => {
  const [activeReport, setActiveReport] = useState('employeeCard');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [selectedCompany, setSelectedCompany] = useState('all');
  const [companies, setCompanies] = useState([{ id: 'all', name: 'All Companies' }]);
  const [selectedEmployee, setSelectedEmployee] = useState('all');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [employeeSearch, setEmployeeSearch] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [departmentStats, setDepartmentStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDeptEmployees, setSelectedDeptEmployees] = useState([]);
  const [isDeptModalOpen, setIsDeptModalOpen] = useState(false);
  const [selectedDeptName, setSelectedDeptName] = useState('');
  const [shifts, setShifts] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  // DEPARTMENT HELPER FUNCTIONS (Same as AddEmployee.js)
  const getDepartmentNames = (deptIdsOrId) => {
    if (!deptIdsOrId) return ['N/A'];

    let ids = [];
    if (Array.isArray(deptIdsOrId)) {
      ids = deptIdsOrId;
    } else if (deptIdsOrId) {
      ids = [deptIdsOrId];
    }

    if (departments.length === 0) {
      if (ids.length > 0) {
        console.warn('Departments not loaded yet. Raw IDs:', ids);
        return ids.map(id => `ID: ${String(id)}`);
      }
      return ['Loading departments...'];
    }

    const stringIds = ids.map(id => String(id).trim());

    const names = stringIds.slice(0, 2).map(idStr => {
      const trimmedId = idStr;
      const dept = departments.find(d => String(d._id).trim() === trimmedId);
      if (dept) {
        return dept.name || dept.departmentName || 'Unknown Department';
      } else {
        console.warn(`Department ID not found: ${trimmedId}. Available depts:`, departments.map(d => String(d._id)));
        return `Unknown (${trimmedId})`;
      }
    });

    if (stringIds.length > 2) {
      names.push(`+${stringIds.length - 2} more`);
    }

    return names;
  };

  // Employee Report Card States
  const [employeeReportData, setEmployeeReportData] = useState([]);
  const [selectedEmployeeForReport, setSelectedEmployeeForReport] = useState(null);
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
  const [isEditingAttendance, setIsEditingAttendance] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [loadingAttendance, setLoadingAttendance] = useState(false);
  const [attendanceError, setAttendanceError] = useState(null);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });

  // Shift Information State
  const [employeeShiftInfo, setEmployeeShiftInfo] = useState(null);
  const [loadingShiftInfo, setLoadingShiftInfo] = useState(false);

  // Filter States for Attendance Modal
  const [selectedFilterMonth, setSelectedFilterMonth] = useState(new Date().getMonth());
  const [selectedFilterYear, setSelectedFilterYear] = useState(new Date().getFullYear());
  const [attendanceStatusFilter, setAttendanceStatusFilter] = useState('all'); // 'all', 'present', 'absent'

  // Holiday States
  const [holidays, setHolidays] = useState([]);
  const [loadingHolidays, setLoadingHolidays] = useState(false);
  const [holidaysError, setHolidaysError] = useState(null);

  // Company Data State (for weekly holidays)
  const [companyData, setCompanyData] = useState(null);

  // View Toggle State (grid or card view)
  const [viewMode, setViewMode] = useState('card'); // 'card' or 'grid'
  const [deptViewMode, setDeptViewMode] = useState('card'); // 'card' or 'grid' for department view
  const [attendanceViewMode, setAttendanceViewMode] = useState('table'); // 'table' or 'calendar' for attendance records

  useEffect(() => {
    const fetchCompanyAndData = async () => {
      const companyId = localStorage.getItem('selectedCompanyId');
      const companyName = localStorage.getItem('selectedCompanyName') || 'Your Company';

      console.log('INITIALIZING COMPANY DATA:', { companyId, companyName });

      if (companyId) {
        setCompanies([{ id: companyId, name: companyName }]);
        setSelectedCompany(companyId);

        console.log('🚀 STARTING DATA FETCH FOR COMPANY:', companyId);

        try {
          await Promise.all([
            fetchEmployees(companyId),
            fetchDepartments(companyId),
            fetchHolidays(),
            fetchCompanyData(),
            fetchEmployeeReportData(companyId)
          ]);

          console.log('✅ ALL DATA FETCH COMPLETED');
        } catch (error) {
          console.error('❌ ERROR IN DATA FETCH:', error);
          setError(`Failed to load data: ${error.message}`);
        }
      } else {
        console.warn('⚠️ NO COMPANY ID FOUND IN LOCALSTORAGE');
        setError('No company selected. Please select a company first.');
      }
    };

    fetchCompanyAndData();
  }, []);

  useEffect(() => {
    if (activeReport === 'department' && departments.length > 0 && employees.length > 0) {
      fetchDepartmentStats();
    }
  }, [activeReport, departments, employees, selectedDate]);

  const fetchEmployees = async (companyId) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('No access token found. Please log in.');
      setLoading(false);
      return;
    }

    if (!companyId) {
      setError('No company selected. Please select a company first.');
      setLoading(false);
      return;
    }

    try {
      console.log('¡ FETCHING EMPLOYEES WITH DEPARTMENT DATA FOR COMPANY:', { companyId });

      // Fetch employees with populated department data
      const response = await axios.get(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 15000,
          params: {
            populate: 'department' // Request populated department data
          }
        }
      );

      console.log('👥 EMPLOYEES API RESPONSE:', {
        status: response.status,
        employeeCount: response.data?.length || 0,
        sampleEmployeeDepartments: response.data?.slice(0, 3).map(emp => ({
          id: emp._id,
          name: emp.teamMemberName || emp.name,
          department: emp.department,
          departmentType: typeof emp.department
        })) || []
      });

      // Fetch departments for lookup map (fallback mechanism)
      let departmentsMap = {};
      try {
        const departmentsResponse = await axios.get(
          `https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${companyId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            timeout: 15000
          }
        );

        console.log('DEPARTMENTS LOOKUP RESPONSE:', {
          status: departmentsResponse.status,
          departmentCount: departmentsResponse.data?.length || 0
        });

        // Create comprehensive lookup map for departments
        if (Array.isArray(departmentsResponse.data)) {
          departmentsResponse.data.forEach(dept => {
            if (dept._id) {
              const departmentName = dept.name || dept.departmentName || 'Unknown Department';
              departmentsMap[dept._id] = {
                ...dept,
                name: departmentName,
                departmentName: departmentName
              };
              console.log('—‚ï MAPPED DEPARTMENT:', {
                id: dept._id,
                name: departmentName
              });
            }
          });
        }
      } catch (deptErr) {
        console.warn('⚠️ Failed to fetch departments for lookup:', deptErr.message);
      }

      console.log('📋 DEPARTMENTS MAP CREATED:', {
        totalMapped: Object.keys(departmentsMap).length,
        mappedIds: Object.keys(departmentsMap)
      });

      // Process employee data with enhanced department information
      // Process employee data with enhanced department information
      const processedEmployees = response.data.map((employee, index) => {
        console.log(`👤 PROCESSING EMPLOYEE ${index + 1} DEPARTMENT:`, {
          id: employee._id,
          name: employee.teamMemberName || employee.name,
          rawDepartment: employee.department,
          departmentType: typeof employee.department,
          isArray: Array.isArray(employee.department)
        });

        // Enhanced department information processing with multiple department support
        let departmentInfo = null;
        let departmentName = 'No Department';
        let departmentNames = [];
        let allDepartments = [];
        let departmentIds = []; // NEW: Store raw department IDs

        if (employee.department) {
          if (Array.isArray(employee.department) && employee.department.length > 0) {
            // Handle array of multiple departments - THIS IS YOUR CASE
            console.log(`  📂 EMPLOYEE HAS ${employee.department.length} DEPARTMENTS:`, employee.department);

            // Process each department ID in the array
            departmentIds = employee.department.map(deptId => {
              if (typeof deptId === 'object' && deptId._id) {
                return deptId._id; // Extract ID from object
              }
              return deptId; // Already an ID string
            });

            // Get department names from lookup map
            const processedDepartments = departmentIds.map(deptId => {
              const deptInfo = departmentsMap[deptId];
              if (deptInfo) {
                const deptName = deptInfo.name || deptInfo.departmentName || 'Unknown Department';
                return {
                  info: deptInfo,
                  name: deptName,
                  id: deptId
                };
              } else {
                const fallbackName = `Unknown Department (${deptId})`;
                return {
                  info: { _id: deptId, name: fallbackName },
                  name: fallbackName,
                  id: deptId
                };
              }
            }).filter(dept => dept.info !== null);

            if (processedDepartments.length > 0) {
              // Set primary department (first one)
              departmentInfo = processedDepartments[0].info;
              departmentName = processedDepartments[0].name;

              // Collect all department names and info
              departmentNames = processedDepartments.map(dept => dept.name);
              allDepartments = processedDepartments.map(dept => dept.info);

              console.log(`  ✅ PROCESSED ${processedDepartments.length} DEPARTMENTS FOR ${employee.teamMemberName}:`, {
                departmentIds: departmentIds,
                departmentNames: departmentNames
              });
            }
          } else {
            // Handle single department case (existing logic)
            // ... keep your existing single department logic
          }
        }

        return {
          ...employee,
          // Enhanced department information
          department: departmentInfo, // Primary department
          departmentName: departmentName, // Primary department name
          // Multiple departments support
          allDepartments: allDepartments, // Array of all department objects
          departmentNames: departmentNames, // Array of all department names
          departmentIds: departmentIds, // NEW: Array of raw department IDs
          isMultipleDepartments: departmentNames.length > 1,
          departmentCount: departmentNames.length,
          // Display formatted department names
          formattedDepartmentNames: departmentNames.length > 1
            ? departmentNames.slice(0, 2).join(', ') + (departmentNames.length > 2 ? ` +${departmentNames.length - 2} more` : '')
            : departmentNames[0] || 'No Department',
          displayName: employee.teamMemberName || employee.name || 'Unknown Employee'
        };
      });

      console.log('✅ PROCESSED EMPLOYEES WITH DEPARTMENT INFO:', {
        totalProcessed: processedEmployees.length,
        employeesWithDepartments: processedEmployees.filter(emp => emp.departmentName !== 'No Department').length
      });

      setEmployees([
        { _id: 'all', teamMemberName: 'All Employees', department: 'all', departmentName: 'All Departments' },
        ...processedEmployees
      ]);

      console.log('✅ EMPLOYEES FETCHED AND SET WITH DEPARTMENT DATA:', {
        totalEmployees: processedEmployees.length + 1, // +1 for 'All Employees'
        departmentsAvailable: departments.length > 0
      });

    } catch (err) {
      console.error('❌ ERROR FETCHING EMPLOYEES:', {
        status: err.response?.status,
        message: err.response?.data?.message || err.message,
        companyId
      });

      if (err.response?.status === 401) {
        console.log('🔄 Token expired, cleaning up...');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        setError('Session expired. Please log in again.');
        window.location.href = '/login';
        return;
      }

      setError(`Failed to fetch employees: ${err.response?.data?.message || err.message || 'Unable to connect to server'}`);
    } finally {
      setLoading(false);
      console.log(' Fetch employees process completed');
    }
  };

  const fetchDepartments = async (companyId) => {
    if (!companyId) {
      console.warn('⚠️ No companyId provided for department fetching');
      return;
    }

    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('No access token found. Please log in.');
      setLoading(false);
      return;
    }

    try {
      console.log('FETCHING DEPARTMENTS FOR COMPANY:', { companyId });

      const response = await axios.get(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 15000
        }
      );

      console.log('📊 DEPARTMENTS API RESPONSE:', {
        status: response.status,
        dataLength: response.data?.length || 0,
        departments: response.data?.map(dept => ({
          id: dept._id,
          name: dept.name || dept.departmentName,
          company: dept.company
        })) || []
      });

      // Process departments with proper field mapping
      const processedDepartments = response.data.map(dept => ({
        ...dept,
        name: dept.name || dept.departmentName || 'Unknown Department',
        departmentName: dept.name || dept.departmentName || 'Unknown Department'
      }));

      setDepartments([
        { _id: 'all', name: 'All Departments', departmentName: 'All Departments' },
        ...processedDepartments
      ]);

      console.log('✅ DEPARTMENTS PROCESSED AND SET:', {
        totalCount: processedDepartments.length + 1, // +1 for 'All Departments'
        departmentNames: processedDepartments.map(d => d.name)
      });

    } catch (err) {
      console.error('❌ ERROR FETCHING DEPARTMENTS:', {
        status: err.response?.status,
        message: err.response?.data?.message || err.message,
        companyId
      });

      if (err.response?.status === 401) {
        console.log('🔄 Token expired, cleaning up...');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        setError('Session expired. Please log in again.');
        window.location.href = '/login';
        return;
      }

      setError(`Failed to fetch departments: ${err.response?.data?.message || err.message}`);
      setDepartments([{ _id: 'all', name: 'All Departments', departmentName: 'All Departments' }]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartmentStats = async () => {
    const token = localStorage.getItem('authToken');
    const companyId = localStorage.getItem('selectedCompanyId');

    try {
      console.log('📊 CALCULATING DEPARTMENT STATS WITH MULTIPLE DEPARTMENTS:');

      // Calculate department-wise attendance statistics
      const stats = await Promise.all(
        departments
          .filter(dept => dept._id !== 'all')
          .map(async (dept) => {
            // Get employees in this department
            const deptEmployees = employees.filter(emp =>
              emp._id !== 'all' && checkDepartmentMatch(emp, dept._id)
            );

            // DEBUG: Log department assignments
            console.log(`DEPARTMENT ${dept.name} (${dept._id}):`, {
              employeeCount: deptEmployees.length,
              employees: deptEmployees.map(e => ({
                name: e.displayName,
                departments: e.departmentNames,
                departmentIds: e.departmentIds
              }))
            });

            // Calculate attendance statistics
            let presentCount = 0;
            let absentCount = 0;
            let lateCount = 0;
            let halfDayCount = 0;

            // Your existing attendance calculation logic here...
            for (const employee of deptEmployees) {
              try {
                if (token && companyId) {
                  const attendanceResponse = await axios.get(
                    `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/employee/${employee._id}`,
                    {
                      headers: { Authorization: `Bearer ${token}` },
                      timeout: 5000,
                      params: { date: selectedDate }
                    }
                  );

                  const attendanceRecords = attendanceResponse.data || [];
                  const todayRecord = attendanceRecords.find(record => {
                    const recordDate = new Date(record.date || record.inTime).toISOString().split('T')[0];
                    return recordDate === selectedDate;
                  });

                  if (todayRecord) {
                    const status = (todayRecord.status || '').toLowerCase().trim();
                    if (status === 'present' || (todayRecord.inTime && todayRecord.outTime)) {
                      presentCount++;
                    } else if (status === 'late') {
                      lateCount++;
                      presentCount++;
                    } else if (status.includes('half')) {
                      halfDayCount++;
                      presentCount++;
                    } else {
                      absentCount++;
                    }
                  } else {
                    absentCount++;
                  }
                } else {
                  absentCount++;
                }
              } catch (empErr) {
                console.log(`⚠️ Could not fetch attendance for ${employee.displayName}:`, empErr.message);
                absentCount++;
              }
            }

            const departmentStat = {
              _id: dept._id,
              name: dept.departmentName || dept.name,
              present: presentCount,
              absent: absentCount,
              late: lateCount,
              halfDay: halfDayCount,
              employees: deptEmployees.length,
              attendanceRate: deptEmployees.length > 0
                ? Math.round((presentCount / deptEmployees.length) * 100)
                : 0
            };

            console.log(`📈 FINAL STATS FOR ${dept.name}:`, departmentStat);
            return departmentStat;
          })
      );

      console.log('✅ FINAL DEPARTMENT STATS:', stats);
      setDepartmentStats(stats);
    } catch (err) {
      console.error('❌ Error calculating department stats:', err);

      // Enhanced fallback with better counting
      const fallbackStats = departments
        .filter(dept => dept._id !== 'all')
        .map((dept) => {
          const employeeCount = employees.filter(emp =>
            emp._id !== 'all' && checkDepartmentMatch(emp, dept._id)
          ).length;

          console.log(`🔄 FALLBACK STATS FOR ${dept.name}:`, {
            employeeCount,
            departmentId: dept._id
          });

          return {
            _id: dept._id,
            name: dept.departmentName || dept.name,
            present: 0,
            absent: employeeCount,
            late: 0,
            halfDay: 0,
            employees: employeeCount,
            attendanceRate: 0
          };
        });

      setDepartmentStats(fallbackStats);
    }
  };


  // State for attendance data
  const [attendanceData, setAttendanceData] = useState({
    employee: [],
    lateAbsent: [],
    workSummary: [],
    dailyAttendance: []
  });

  // API functions to fetch attendance data
  const fetchAttendanceData = async (companyId) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('No access token found. Please log in.');
      return;
    }

    try {

      setAttendanceData({
        employee: [], // employeeResponse.data || []
        lateAbsent: [], // lateAbsentResponse.data || []
        workSummary: [], // workSummaryResponse.data || []
        dailyAttendance: [] // dailyAttendanceResponse.data || []
      });
    } catch (err) {
      console.error('Error fetching attendance data:', err);
      setError(`Failed to fetch attendance data: ${err.response?.data?.message || err.message}`);
    }
  };

  // 🎯 EMPLOYEE REPORT API FUNCTIONS
  const fetchEmployeeReportData = async (companyId) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('No access token found. Please log in.');
      return;
    }

    try {
      console.log('🚀 FETCHING EMPLOYEE REPORT DATA:', { companyId });

      // Fetch employees with populated department data
      const response = await axios.get(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 15000,
          params: {
            populate: 'department' // Request populated data
          }
        }
      );

      console.log('📊 EMPLOYEE REPORT RESPONSE:', {
        status: response.status,
        employeeCount: response.data?.length || 0,
        sampleEmployee: response.data?.[0] ? {
          id: response.data[0]._id,
          name: response.data[0].teamMemberName || response.data[0].name,
          department: response.data[0].department,
          departmentType: typeof response.data[0].department
        } : null
      });

      // Fetch departments for fallback lookup
      const departmentsResponse = await axios.get(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 15000
      }).catch(err => {
        console.warn('⚠️ Failed to fetch departments for lookup:', err.message);
        return { data: [] };
      });

      console.log('DEPARTMENTS LOOKUP RESPONSE:', {
        status: departmentsResponse.status || 'Failed',
        departmentCount: departmentsResponse.data?.length || 0,
        departments: departmentsResponse.data?.map(dept => ({
          id: dept._id,
          name: dept.name || dept.departmentName
        })) || []
      });

      // Create comprehensive lookup map for departments (same as AddEmployee.js)
      const departmentsMap = {};
      if (Array.isArray(departmentsResponse.data)) {
        departmentsResponse.data.forEach(dept => {
          if (dept._id) {
            const departmentName = dept.name || dept.departmentName || 'Unknown Department';
            departmentsMap[dept._id] = {
              ...dept,
              name: departmentName,
              departmentName: departmentName
            };
            console.log('—‚ï MAPPED DEPARTMENT:', {
              id: dept._id,
              name: departmentName,
              originalName: dept.name,
              originalDepartmentName: dept.departmentName
            });
          }
        });
      }

      console.log('📋 FINAL DEPARTMENTS MAP:', {
        totalMapped: Object.keys(departmentsMap).length,
        mappedIds: Object.keys(departmentsMap)
      });

      // Process employee data with enhanced information (same as AddEmployee.js)
      const processedData = response.data.map((employee, index) => {
        console.log(`👤 PROCESSING EMPLOYEE ${index + 1}:`, {
          id: employee._id,
          name: employee.teamMemberName || employee.name,
          email: employee.email,
          phone: employee.phone || employee.phoneNumber || employee.mobile,
          department: employee.department,
          departmentType: typeof employee.department,
          departmentId: employee.department?._id || employee.department
        });

        // Enhanced department information processing with multiple department support
        let departmentInfo = null;
        let departmentName = 'No Department';
        let departmentNames = [];
        let allDepartments = [];
        let departmentProcessingLog = {
          originalDepartment: employee.department,
          departmentType: typeof employee.department,
          processingMethod: 'none',
          isMultipleDepartments: false
        };

        if (employee.department) {
          if (typeof employee.department === 'object' && !Array.isArray(employee.department) && (employee.department.name || employee.department.departmentName)) {
            // Single populated object
            departmentInfo = {
              ...employee.department,
              name: employee.department.name || employee.department.departmentName,
              departmentName: employee.department.name || employee.department.departmentName
            };
            departmentName = departmentInfo.name;
            departmentNames = [departmentName];
            allDepartments = [departmentInfo];
            departmentProcessingLog.processingMethod = 'single_populated_object';
            departmentProcessingLog.foundName = departmentName;
          } else if (typeof employee.department === 'string' && employee.department.trim()) {
            // Single string ID - use lookup map
            const deptId = employee.department.trim();
            departmentInfo = departmentsMap[deptId];
            departmentProcessingLog.processingMethod = 'single_lookup_map';
            departmentProcessingLog.lookupId = deptId;
            departmentProcessingLog.foundInMap = !!departmentInfo;

            if (departmentInfo) {
              departmentName = departmentInfo.name || departmentInfo.departmentName || 'Unknown Department';
              departmentNames = [departmentName];
              allDepartments = [departmentInfo];
            } else {
              // Fallback for unknown department ID
              departmentName = `Unknown Department (${deptId})`;
              departmentInfo = {
                _id: deptId,
                name: departmentName,
                departmentName: departmentName
              };
              departmentNames = [departmentName];
              allDepartments = [departmentInfo];
              departmentProcessingLog.usedFallback = true;
            }
          } else if (Array.isArray(employee.department) && employee.department.length > 0) {
            // Handle array of multiple departments
            departmentProcessingLog.processingMethod = 'multiple_departments_array';
            departmentProcessingLog.isMultipleDepartments = true;
            departmentProcessingLog.departmentCount = employee.department.length;

            const processedDepartments = employee.department.map((dept, deptIndex) => {
              if (typeof dept === 'object' && (dept.name || dept.departmentName)) {
                // Populated department object
                const deptName = dept.name || dept.departmentName;
                const deptInfo = {
                  ...dept,
                  name: deptName,
                  departmentName: deptName
                };
                console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (Object):`, { id: dept._id, name: deptName });
                return { info: deptInfo, name: deptName };
              } else if (typeof dept === 'string' && dept.trim()) {
                // Department ID string
                const deptId = dept.trim();
                const deptInfo = departmentsMap[deptId];
                if (deptInfo) {
                  const deptName = deptInfo.name || deptInfo.departmentName || 'Unknown Department';
                  console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (ID Resolved):`, { id: deptId, name: deptName });
                  return { info: deptInfo, name: deptName };
                } else {
                  const fallbackName = `Unknown Department (${deptId})`;
                  const fallbackInfo = { _id: deptId, name: fallbackName, departmentName: fallbackName };
                  console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (ID Unresolved):`, { id: deptId, name: fallbackName });
                  return { info: fallbackInfo, name: fallbackName };
                }
              } else {
                console.log(`  📂 EMPLOYEE CARD DEPT ${deptIndex + 1} (Invalid):`, dept);
                return null;
              }
            }).filter(dept => dept !== null);

            if (processedDepartments.length > 0) {
              // Set primary department (first one)
              departmentInfo = processedDepartments[0].info;
              departmentName = processedDepartments[0].name;

              // Collect all department names and info
              departmentNames = processedDepartments.map(dept => dept.name);
              allDepartments = processedDepartments.map(dept => dept.info);

              console.log(`  ✅ EMPLOYEE CARD PROCESSED ${processedDepartments.length} DEPARTMENTS:`, {
                employeeId: employee._id,
                primaryDepartment: departmentName,
                allDepartmentNames: departmentNames
              });
            } else {
              departmentName = 'No Valid Departments';
              departmentNames = [departmentName];
              allDepartments = [];
            }
          }
        }

        console.log('EMPLOYEE CARD DEPARTMENT PROCESSING RESULT:', {
          employeeId: employee._id,
          employeeName: employee.teamMemberName || employee.name,
          ...departmentProcessingLog,
          primaryDepartmentName: departmentName,
          allDepartmentNames: departmentNames,
          departmentCount: departmentNames.length,
          isMultipleDepartments: departmentNames.length > 1,
          formattedDisplay: departmentNames.length > 1
            ? departmentNames.slice(0, 2).join(', ') + (departmentNames.length > 2 ? ` +${departmentNames.length - 2} more` : '')
            : departmentNames[0] || 'No Department'
        });

        // Get phone number from various possible fields (same as AddEmployee.js)
        const phoneNumber = employee.phone ||
          employee.phoneNumber ||
          employee.mobile ||
          employee.contactNumber ||
          employee.mobileNumber ||
          'No phone provided';

        const processedEmployee = {
          ...employee,
          // Enhanced contact information
          displayName: employee.teamMemberName || employee.name || 'Unknown Employee',
          email: employee.email || 'No email provided',
          phone: phoneNumber,

          // Enhanced department information with multiple department support
          department: departmentInfo, // Primary department
          departmentName: departmentName, // Primary department name
          departmentId: departmentInfo?._id || null, // Primary department ID
          // Multiple departments support
          allDepartments: allDepartments, // Array of all department objects
          departmentNames: departmentNames, // Array of all department names
          isMultipleDepartments: departmentNames.length > 1,
          departmentCount: departmentNames.length,
          // Display formatted department names
          formattedDepartmentNames: departmentNames.length > 1
            ? departmentNames.slice(0, 2).join(', ') + (departmentNames.length > 2 ? ` +${departmentNames.length - 2} more` : '')
            : departmentNames[0] || 'No Department',

          // Attendance statistics (will be calculated later)
          attendanceCount: 0,
          presentDays: 0,
          absentDays: 0,
          lateDays: 0,
          halfDays: 0,
          incompleteDays: 0,
          attendanceRate: 0
        };

        console.log('✅ FINAL PROCESSED EMPLOYEE CARD:', {
          id: processedEmployee._id,
          name: processedEmployee.displayName,
          email: processedEmployee.email,
          phone: processedEmployee.phone,
          primaryDepartmentName: processedEmployee.departmentName,
          allDepartmentNames: processedEmployee.departmentNames,
          departmentCount: processedEmployee.departmentCount,
          isMultipleDepartments: processedEmployee.isMultipleDepartments,
          formattedDepartmentNames: processedEmployee.formattedDepartmentNames
        });

        return processedEmployee;
      });

      // 📊 FETCH ATTENDANCE DATA FOR EACH EMPLOYEE
      console.log('📊 FETCHING ATTENDANCE DATA FOR ALL EMPLOYEES...');

      const employeesWithAttendance = await Promise.all(
        processedData.map(async (employee) => {
          try {
            // Fetch attendance records for this employee
            const attendanceResponse = await axios.get(
              `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/employee/${employee._id}`,
              {
                headers: { Authorization: `Bearer ${token}` },
                timeout: 10000,
                params: { company: companyId }
              }
            ).catch(async (err) => {
              // Fallback to general attendance endpoint
              console.log(`⚠️ Fallback attendance fetch for ${employee.displayName}`);
              const fallbackResponse = await axios.get(
                'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/',
                {
                  headers: { Authorization: `Bearer ${token}` },
                  timeout: 10000,
                  params: {
                    employee: employee._id,
                    company: companyId
                  }
                }
              );
              return fallbackResponse;
            });

            // Process attendance data
            let attendanceRecords = [];
            if (Array.isArray(attendanceResponse.data)) {
              attendanceRecords = attendanceResponse.data;
            } else if (attendanceResponse.data?.data && Array.isArray(attendanceResponse.data.data)) {
              attendanceRecords = attendanceResponse.data.data;
            } else if (attendanceResponse.data?.attendance && Array.isArray(attendanceResponse.data.attendance)) {
              attendanceRecords = attendanceResponse.data.attendance;
            } else if (attendanceResponse.data?.records && Array.isArray(attendanceResponse.data.records)) {
              attendanceRecords = attendanceResponse.data.records;
            }

            // Filter records for this employee and company
            const filteredRecords = attendanceRecords.filter(record => {
              const recordEmployeeId = record.employee?._id || record.employee;
              const recordCompanyId = record.company?._id || record.company;
              return recordEmployeeId === employee._id &&
                (!companyId || recordCompanyId === companyId);
            });

            console.log(`📊 ATTENDANCE DATA FOR ${employee.displayName}:`, {
              totalRecords: attendanceRecords.length,
              filteredRecords: filteredRecords.length,
              employeeId: employee._id,
              companyId
            });

            // Calculate current month attendance statistics
            const attendanceStats = calculateCurrentMonthAttendance(employee._id, filteredRecords);

            return {
              ...employee,
              // Update with real attendance data
              attendanceCount: filteredRecords.length,
              presentDays: attendanceStats.presentDays,
              absentDays: attendanceStats.absentDays,
              lateCount: attendanceStats.lateCount,
              halfDayCount: attendanceStats.halfDayCount,
              incompleteCount: attendanceStats.incompleteCount,
              attendanceRate: attendanceStats.attendanceRate,
              totalRecords: attendanceStats.totalRecords,
              // Store raw attendance records for popup modal
              attendanceRecords: filteredRecords
            };

          } catch (attendanceErr) {
            console.warn(`⚠️ Failed to fetch attendance for ${employee.displayName}:`, attendanceErr.message);

            // Return employee with default attendance values
            return {
              ...employee,
              attendanceCount: 0,
              presentDays: 0,
              absentDays: 0,
              lateCount: 0,
              halfDayCount: 0,
              incompleteCount: 0,
              attendanceRate: 0,
              totalRecords: 0,
              attendanceRecords: []
            };
          }
        })
      );

      setEmployeeReportData(employeesWithAttendance);
      console.log('🎉 EMPLOYEE REPORT DATA SET WITH ATTENDANCE:', {
        totalEmployees: employeesWithAttendance.length,
        employeesWithAttendance: employeesWithAttendance.filter(emp => emp.totalRecords > 0).length,
        attendanceSummary: employeesWithAttendance.map(emp => ({
          name: emp.displayName,
          present: emp.presentDays,
          absent: emp.absentDays,
          rate: emp.attendanceRate
        }))
      });

    } catch (err) {
      console.error('❌ Error fetching employee report data:', err);
      setError(`Failed to fetch employee report data: ${err.response?.data?.message || err.message}`);

      if (err.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        window.location.href = '/login';
      }
    }
  };

  // ¡ ENHANCED ATTENDANCE API FUNCTIONS
  const fetchEmployeeAttendance = async (employeeId, companyId = null) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      showNotification('No access token found. Please log in.', 'error');
      return;
    }

    setLoadingAttendance(true);
    setAttendanceError(null);

    try {
      console.log('🔍 FETCHING ATTENDANCE FOR EMPLOYEE:', { employeeId, companyId });

      // Try multiple endpoints for better data retrieval
      let response;
      const currentCompanyId = companyId || localStorage.getItem('selectedCompanyId');

      try {
        // First try employee-specific endpoint
        response = await axios.get(
          `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/employee/${employeeId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            timeout: 15000,
            params: currentCompanyId ? { company: currentCompanyId } : {}
          }
        );
        console.log('¡ EMPLOYEE ATTENDANCE RESPONSE:', response.data);
      } catch (employeeErr) {
        console.warn('⚠️ Employee-specific endpoint failed, trying general endpoint:', employeeErr.message);

        // Fallback to general attendance endpoint with proper filtering
        response = await axios.get(
          'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/',
          {
            headers: { Authorization: `Bearer ${token}` },
            timeout: 15000,
            params: {
              ...(currentCompanyId ? { company: currentCompanyId } : {}),
              employee: employeeId // CRITICAL: Filter by employee
            }
          }
        );
        console.log('¡ ALL ATTENDANCE RESPONSE:', response.data);
      }

      // Process response data
      let allRecords = [];
      if (Array.isArray(response.data)) {
        allRecords = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        allRecords = response.data.data;
      } else if (response.data.attendance && Array.isArray(response.data.attendance)) {
        allRecords = response.data.attendance;
      } else if (response.data.records && Array.isArray(response.data.records)) {
        allRecords = response.data.records;
      }

      // Filter by employee ID if we got all records
      const employeeRecords = allRecords.filter(record => {
        const recordEmployeeId = record.employee?._id || record.employee || record.employeeId;
        return recordEmployeeId === employeeId;
      });

      console.log('🎯 FILTERED EMPLOYEE RECORDS:', employeeRecords.length);

      // Enhanced record processing with better field mapping and time formatting
      const processedRecords = employeeRecords.map(record => {
        // Process times to ensure proper formatting
        const inTime = record.inTime || null;
        const outTime = record.outTime || null;

        const processedRecord = {
          ...record,
          id: record._id || record.id,
          employeeId: record.employee?._id || record.employee || record.employeeId || employeeId,
          companyId: record.company?._id || record.company || record.companyId || currentCompanyId,
          date: record.date || (inTime ? inTime.split('T')[0] : new Date().toISOString().split('T')[0]),
          inTime: inTime,
          outTime: outTime,
          inLocation: record.inLocation || null,
          outLocation: record.outLocation || null,
          inPhoto: record.inPhoto || null,
          outPhoto: record.outPhoto || null,
          workingTime: record.workingTime || calculateEnhancedWorkingTime(inTime, outTime),
          status: record.status || calculateAttendanceStatus(record),
          notes: record.notes || record.remarks || '',
          isEditable: true,
          // Add formatted display times (same as DailyAttendance.js)
          displayInTime: inTime ? formatTimeUTC(inTime) : '-',
          displayOutTime: outTime ? formatTimeUTC(outTime) : '-'
        };

        console.log('📊 PROCESSED RECORD:', {
          id: processedRecord.id,
          date: processedRecord.date,
          inTime: processedRecord.inTime,
          outTime: processedRecord.outTime,
          status: processedRecord.status,
          workingTime: processedRecord.workingTime
        });

        return processedRecord;
      }).sort((a, b) => new Date(b.date) - new Date(a.date));

      setAttendanceRecords(processedRecords);
      console.log('✅ ATTENDANCE RECORDS SET:', processedRecords.length, 'records for employee', employeeId);

      return processedRecords;

    } catch (err) {
      console.error('❌ Error fetching attendance:', err);
      const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch attendance records';
      setAttendanceError(errorMessage);
      showNotification(errorMessage, 'error');

      if (err.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        window.location.href = '/login';
      }

      return [];
    } finally {
      setLoadingAttendance(false);
    }
  };

  //  CREATE ATTENDANCE
  const createAttendance = async (attendanceData) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      console.error('❌ CREATE ATTENDANCE ERROR: No access token found');
      showNotification('No access token found. Please log in.', 'error');
      return false;
    }

    try {
      console.log('🚀 CREATING ATTENDANCE RECORD:');
      console.log('📋 Request Data:', JSON.stringify(attendanceData, null, 2));
      console.log('🔍Token Present:', !!token);
      console.log('Œ API Endpoint:', 'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/');

      // Validate required fields before sending
      const validationErrors = [];
      if (!attendanceData.employee) validationErrors.push('Employee ID is missing');
      if (!attendanceData.company) validationErrors.push('Company ID is missing');
      if (!attendanceData.date) validationErrors.push('Date is missing');

      if (validationErrors.length > 0) {
        console.error('❌ VALIDATION ERRORS:', validationErrors);
        showNotification(`Validation errors: ${validationErrors.join(', ')}`, 'error');
        return false;
      }

      console.log('✅ Validation passed, sending request...');

      const response = await axios.post(
        'https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/',
        attendanceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          timeout: 15000
        }
      );

      console.log('✅ ATTENDANCE CREATED SUCCESSFULLY:');
      console.log('📊 Response Status:', response.status);
      console.log('📋 Response Data:', JSON.stringify(response.data, null, 2));
      console.log('🎉 Record ID:', response.data?._id || response.data?.id);

      showNotification('Attendance record created successfully!', 'success');

      // Refresh attendance records
      if (selectedEmployeeForReport) {
        console.log('🔄 Refreshing attendance records for employee:', selectedEmployeeForReport._id);
        await fetchEmployeeAttendance(selectedEmployeeForReport._id);
      }

      return true;
    } catch (err) {
      console.error('❌ CREATE ATTENDANCE ERROR:');
      console.error('🔍 Error Type:', err.name);
      console.error(' Error Message:', err.message);
      console.error('Œ Request URL:', err.config?.url);
      console.error('📋 Request Data:', err.config?.data);
      console.error('📊 Response Status:', err.response?.status);
      console.error('📋 Response Data:', JSON.stringify(err.response?.data, null, 2));
      console.error('🔧 Full Error Object:', err);

      let errorMessage = 'Failed to create attendance record';

      if (err.response?.status === 400) {
        errorMessage = `Bad Request: ${err.response?.data?.message || 'Invalid data provided'}`;
        console.error('❌ BAD REQUEST DETAILS:', err.response?.data);
      } else if (err.response?.status === 401) {
        errorMessage = 'Unauthorized: Please log in again';
        console.error('❌ UNAUTHORIZED: Token may be expired');
      } else if (err.response?.status === 403) {
        errorMessage = 'Forbidden: You do not have permission to create attendance records';
        console.error('❌ FORBIDDEN: Check user permissions');
      } else if (err.response?.status === 500) {
        errorMessage = `Server Error: ${err.response?.data?.message || 'Internal server error'}`;
        console.error('❌ SERVER ERROR: Check server logs');
      } else if (err.code === 'ECONNABORTED') {
        errorMessage = 'Request timeout: Server took too long to respond';
        console.error('❌ TIMEOUT ERROR: Request exceeded 15 seconds');
      } else if (err.code === 'NETWORK_ERROR') {
        errorMessage = 'Network error: Check your internet connection';
        console.error('❌ NETWORK ERROR: Connection failed');
      }

      showNotification(errorMessage, 'error');

      if (err.response?.status === 401) {
        console.log('🔄 Clearing auth tokens and redirecting to login');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        window.location.href = '/login';
      }

      return false;
    }
  };

  // ✅ï ENHANCED UPDATE ATTENDANCE
  const updateAttendance = async (attendanceId, attendanceData) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      showNotification('No access token found. Please log in.', 'error');
      return false;
    }

    try {
      console.log('🔄 UPDATING ATTENDANCE RECORD:');
      console.log('†Attendance ID:', attendanceId);
      console.log('📋 Request Data:', JSON.stringify(attendanceData, null, 2));
      console.log('🔍Token Present:', !!token);
      console.log('Œ API Endpoint:', `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/${attendanceId}`);

      // Validate required fields
      const validationErrors = [];
      if (!attendanceId) validationErrors.push('Attendance ID is missing');
      if (!attendanceData.date) validationErrors.push('Date is required');
      if (!attendanceData.employee && !attendanceData.employeeId) validationErrors.push('Employee is required');
      if (!attendanceData.company && !attendanceData.companyId) validationErrors.push('Company is required');

      if (validationErrors.length > 0) {
        console.error('❌ VALIDATION ERRORS:', validationErrors);
        showNotification(`Validation errors: ${validationErrors.join(', ')}`, 'error');
        return false;
      }

      console.log('✅ Validation passed, preparing update data...');

      // Prepare data for update
      const updateData = {
        ...attendanceData,
        employee: attendanceData.employee || attendanceData.employeeId,
        company: attendanceData.company || attendanceData.companyId,
        workingTime: attendanceData.workingTime || calculateWorkingTime(attendanceData.inTime, attendanceData.outTime)
      };

      // Remove undefined fields
      Object.keys(updateData).forEach(key => {
        if (updateData[key] === undefined || updateData[key] === null) {
          delete updateData[key];
        }
      });

      console.log('📤 SENDING UPDATE DATA:', JSON.stringify(updateData, null, 2));
      console.log('🔧 Working Time Calculated:', updateData.workingTime);

      const response = await axios.put(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/${attendanceId}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          timeout: 15000
        }
      );

      console.log('✅ ATTENDANCE UPDATED SUCCESSFULLY:');
      console.log('📊 Response Status:', response.status);
      console.log('📋 Response Data:', JSON.stringify(response.data, null, 2));
      console.log('🎉 Updated Record ID:', response.data?._id || response.data?.id);

      showNotification('Attendance record updated successfully!', 'success');

      // Refresh attendance records
      if (selectedEmployeeForReport) {
        console.log('🔄 Refreshing attendance records for employee:', selectedEmployeeForReport._id);
        await fetchEmployeeAttendance(selectedEmployeeForReport._id);
      }

      return true;
    } catch (err) {
      console.error('❌ UPDATE ATTENDANCE ERROR:');
      console.error('🔍 Error Type:', err.name);
      console.error(' Error Message:', err.message);
      console.error('†Attendance ID:', attendanceId);
      console.error('Œ Request URL:', err.config?.url);
      console.error('📋 Request Data:', err.config?.data);
      console.error('📊 Response Status:', err.response?.status);
      console.error('📋 Response Data:', JSON.stringify(err.response?.data, null, 2));
      console.error('🔧 Full Error Object:', err);

      let errorMessage = 'Failed to update attendance record';

      if (err.response?.status === 400) {
        errorMessage = `Bad Request: ${err.response?.data?.message || 'Invalid data provided'}`;
        console.error('❌ BAD REQUEST DETAILS:', err.response?.data);
      } else if (err.response?.status === 401) {
        errorMessage = 'Unauthorized: Please log in again';
        console.error('❌ UNAUTHORIZED: Token may be expired');
      } else if (err.response?.status === 403) {
        errorMessage = 'Forbidden: You do not have permission to update attendance records';
        console.error('❌ FORBIDDEN: Check user permissions');
      } else if (err.response?.status === 404) {
        errorMessage = `Record not found: Attendance record with ID ${attendanceId} does not exist`;
        console.error('❌ NOT FOUND: Record may have been deleted');
      } else if (err.response?.status === 500) {
        errorMessage = `Server Error: ${err.response?.data?.message || 'Internal server error'}`;
        console.error('❌ SERVER ERROR: Check server logs');
      } else if (err.code === 'ECONNABORTED') {
        errorMessage = 'Request timeout: Server took too long to respond';
        console.error('❌ TIMEOUT ERROR: Request exceeded 15 seconds');
      } else if (err.code === 'NETWORK_ERROR') {
        errorMessage = 'Network error: Check your internet connection';
        console.error('❌ NETWORK ERROR: Connection failed');
      }

      showNotification(errorMessage, 'error');

      if (err.response?.status === 401) {
        console.log('🔄 Clearing auth tokens and redirecting to login');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        window.location.href = '/login';
      }

      return false;
    }
  };

  const [employeeDepartments, setEmployeeDepartments] = useState([]);

  // 🔧 HELPER FUNCTIONS
  const calculateAttendanceStatus = (record) => {
    if (!record.inTime) return 'Absent';
    if (!record.outTime) return 'Incomplete';

    const workingMinutes = calculateWorkingMinutes(record.inTime, record.outTime);
    if (workingMinutes < 240) return 'Half-day'; // Less than 4 hours
    if (workingMinutes >= 480) return 'Present'; // 8+ hours
    return 'Present';
  };

  const calculateWorkingTime = (inTime, outTime) => {
    return calculateEnhancedWorkingTime(inTime, outTime);
  };

  const calculateWorkingMinutes = (inTime, outTime) => {
    if (!inTime || !outTime) return 0;

    const inDate = new Date(inTime);
    const outDate = new Date(outTime);
    const diffMs = outDate - inDate;

    return Math.floor(diffMs / (1000 * 60));
  };

  // 📢 NOTIFICATION SYSTEM
  const showNotification = (message, type = 'info') => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: '', type: '' });
    }, 5000);
  };

  // ¡ FETCH EMPLOYEE SHIFT INFORMATION
  const fetchEmployeeShiftInfo = async (employeeId) => {
    console.log('🔍 FETCHING EMPLOYEE SHIFT INFO:', { employeeId });


    const token = localStorage.getItem('authToken');
    if (!token) {
      console.warn('⚠️ No access token found for shift info fetch');
      return null;
    }

    setLoadingShiftInfo(true);

    try {

      const response = await axios.get(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/employees/${employeeId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 15000
        }
      );

      console.log('¡ EMPLOYEE SHIFT RESPONSE:', response.data);

      const employee = response.data;

      // Initialize shift info
      let shiftName = 'General Shift';
      let shiftTiming = '9:00 AM - 6:00 PM';
      let shiftType = 'Day Shift';

      // If employee has a shift ID, fetch the shift details
      if (employee.shift) {
        try {
          console.log('🔍 FETCHING SHIFT DETAILS FOR ID:', employee.shift);

          const shiftResponse = await axios.get(
            `https://greenyellow-nightingale-241896.hostingersite.com/api/shifts/${employee.shift}`,
            {
              headers: { Authorization: `Bearer ${token}` },
              timeout: 10000
            }
          );

          console.log('🕒 SHIFT DETAILS RESPONSE:', shiftResponse.data);

          const shiftData = shiftResponse.data;
          if (shiftData && shiftData.name) {
            shiftName = shiftData.name;
            shiftTiming = shiftData.startTime && shiftData.endTime
              ? `${shiftData.startTime} - ${shiftData.endTime}`
              : (employee.shiftTiming || employee.shiftTime || employee.workingHours || '9:00 AM - 6:00 PM');
            shiftType = shiftData.type || employee.shiftType || 'Day Shift';
          }
        } catch (shiftErr) {
          console.warn('⚠️ Failed to fetch shift details:', shiftErr.message);

          // Fallback: Try to find in local shifts array if available
          if (shifts.length > 0) {
            const shiftObject = shifts.find(s => s._id === employee.shift);
            if (shiftObject) {
              shiftName = shiftObject.name || 'General Shift';
              shiftTiming = shiftObject.startTime && shiftObject.endTime
                ? `${shiftObject.startTime} - ${shiftObject.endTime}`
                : (employee.shiftTiming || employee.shiftTime || employee.workingHours || '9:00 AM - 6:00 PM');
              shiftType = shiftObject.type || employee.shiftType || 'Day Shift';
            }
          }
        }
      } else {
        // No shift assigned, use employee fields or defaults
        shiftName = employee.shiftName || employee.workShift || 'General Shift';
        shiftTiming = employee.shiftTiming || employee.shiftTime || employee.workingHours || '9:00 AM - 6:00 PM';
        shiftType = employee.shiftType || 'Day Shift';
      }

      const shiftInfo = {
        shiftName: shiftName,
        shiftTiming: shiftTiming,
        shiftType: shiftType,
        shiftId: employee.shiftId || employee.shift || null
      };

      console.log('🕒 PROCESSED SHIFT INFO:', shiftInfo);
      setEmployeeShiftInfo(shiftInfo);

      return shiftInfo;
    } catch (err) {
      console.error('❌ Error fetching employee shift info:', err);

      // Set default shift info on error
      const defaultShift = {
        shiftName: 'General Shift',
        shiftTiming: '9:00 AM - 6:00 PM',
        shiftType: 'Day Shift',
        shiftId: null
      };

      setEmployeeShiftInfo(defaultShift);

      if (err.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        window.location.href = '/login';
      }

      return defaultShift;
    } finally {
      setLoadingShiftInfo(false);
    }
  };

  // 🎯 ENHANCED EMPLOYEE REPORT HANDLERS
  const handleEmployeeSelect = async (employee) => {
    console.log('👤 EMPLOYEE SELECTED FOR ATTENDANCE VIEW:', {
      id: employee._id,
      name: employee.displayName || employee.teamMemberName || employee.name,
      email: employee.email,
      department: employee.departmentName,
      currentMonthStats: {
        present: employee.presentDays,
        absent: employee.absentDays,
        rate: employee.attendanceRate,
        totalRecords: employee.totalRecords
      }
    });

    setSelectedEmployeeForReport(employee);
    setIsEmployeeModalOpen(true);
    setAttendanceError(null);
    setEmployeeShiftInfo(null);

    // Use existing attendance records from employee data
    if (employee.attendanceRecords && employee.attendanceRecords.length > 0) {
      console.log('📊 USING EXISTING ATTENDANCE RECORDS:', employee.attendanceRecords.length);

      // Process records with proper formatting
      const processedRecords = employee.attendanceRecords.map(record => ({
        ...record,
        id: record._id || record.id,
        displayInTime: record.inTime ? formatTimeUTC(record.inTime) : '-',
        displayOutTime: record.outTime ? formatTimeUTC(record.outTime) : '-',
        workingTime: record.inTime && record.outTime
          ? calculateEnhancedWorkingTime(record.inTime, record.outTime)
          : record.workingTime || '--:--',
        isEditable: true
      }));

      setAttendanceRecords(processedRecords);
    } else {
      console.log('¡ FETCHING FRESH ATTENDANCE DATA...');
      setAttendanceRecords([]);

      // Fetch fresh attendance data if not available
      const companyId = localStorage.getItem('selectedCompanyId');
      await fetchEmployeeAttendance(employee._id, companyId);
    }

    // Fetch shift information
    await fetchEmployeeShiftInfo(employee._id);
  };

  const closeEmployeeModal = () => {
    setIsEmployeeModalOpen(false);
    setSelectedEmployeeForReport(null);
    setAttendanceRecords([]);
    setIsEditingAttendance(false);
    setEditingRecord(null);
    setAttendanceError(null);
    setEmployeeShiftInfo(null);
    setLoadingShiftInfo(false);
  };

  // ✅ï ENHANCED ATTENDANCE EDITING HANDLERS
  const handleEditAttendance = (record = null) => {
    console.log('✅ï EDITING ATTENDANCE RECORD:', record);

    // Extract Employee ID and Company ID from JWT token and selected employee
    const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
    let extractedEmployeeId = selectedEmployeeForReport?._id;
    let extractedCompanyId = localStorage.getItem('selectedCompanyId');

    // Try to decode JWT token for additional ID extraction
    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log('🔍 JWT TOKEN DECODED FOR ATTENDANCE EDIT:', {
          decoded,
          selectedEmployee: selectedEmployeeForReport?._id,
          selectedCompany: localStorage.getItem('selectedCompanyId')
        });

        // Use company ID from token if not available in localStorage
        if (!extractedCompanyId) {
          extractedCompanyId = decoded.companyId || decoded.company?._id || decoded.orgId;
        }

        // Use employee ID from selected employee (priority) or token
        extractedEmployeeId = selectedEmployeeForReport?._id || decoded.employeeId || decoded._id || decoded.id;

      } catch (error) {
        console.warn('⚠️ Failed to decode JWT token:', error);
      }
    }

    console.log('†EXTRACTED IDS FOR ATTENDANCE EDIT:', {
      employeeId: extractedEmployeeId,
      companyId: extractedCompanyId,
      selectedEmployee: selectedEmployeeForReport?.teamMemberName || selectedEmployeeForReport?.name
    });

    if (record && (record.id || record._id)) {
      // Edit existing record
      // Convert date to proper format for HTML5 date input (yyyy-MM-dd)
      let formattedDate = new Date().toISOString().split('T')[0]; // Default to today
      if (record.date) {
        try {
          const dateObj = new Date(record.date);
          if (!isNaN(dateObj.getTime())) {
            formattedDate = dateObj.toISOString().split('T')[0];
          }
        } catch (error) {
          console.warn('⚠️ Invalid date format, using today:', record.date);
        }
      }

      setEditingRecord({
        ...record,
        date: formattedDate,
        inTime: record.inTime ? record.inTime.slice(0, 16) : '',
        outTime: record.outTime ? record.outTime.slice(0, 16) : '',
        inLocation: record.inLocation || '',
        outLocation: record.outLocation || '',
        notes: record.notes || record.remarks || '',
        status: record.status || 'Present',
        // Ensure we have proper ID fields for validation
        employeeId: record.employee?._id || record.employee || record.employeeId || extractedEmployeeId,
        companyId: record.company?._id || record.company || record.companyId || extractedCompanyId
      });
    } else {
      // Create new record
      const today = new Date().toISOString().split('T')[0];
      setEditingRecord({
        id: null,
        employeeId: extractedEmployeeId,
        companyId: extractedCompanyId,
        date: today,
        inTime: '',
        outTime: '',
        inLocation: '',
        outLocation: '',
        notes: '',
        status: 'Present',
        workingTime: 0,
        isNew: true
      });
    }

    setIsEditingAttendance(true);
  };

  const handleSaveAttendance = async () => {
    if (!editingRecord) {
      console.error('❌ SAVE ATTENDANCE ERROR: No record to save');
      showNotification('No record to save', 'error');
      return;
    }


    // Check if this is a synthetic record (no-record-xxx) or a real record
    const isSyntheticRecord = editingRecord.id && editingRecord.id.startsWith('no-record-');
    const isNewRecord = editingRecord.isNew || !editingRecord.id || isSyntheticRecord;


    // Validate required fields and extract IDs with fallbacks
    const validationErrors = [];

    // Extract employee ID from various possible formats with fallbacks
    let employeeId = editingRecord.employeeId ||
      editingRecord.employee?._id ||
      editingRecord.employee ||
      selectedEmployeeForReport?._id ||
      null;

    // Extract company ID from various possible formats with fallbacks
    let companyId = editingRecord.companyId ||
      editingRecord.company?._id ||
      editingRecord.company ||
      localStorage.getItem('selectedCompanyId') ||
      null;

    // If IDs are still missing, try to extract from JWT token
    if (!employeeId || !companyId) {
      const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
      if (token) {
        try {
          const decoded = jwtDecode(token);
          console.log('🔍 JWT TOKEN DECODED FOR SAVE:', {
            decoded,
            currentEmployeeId: employeeId,
            currentCompanyId: companyId
          });

          if (!employeeId) {
            employeeId = selectedEmployeeForReport?._id || decoded.employeeId || decoded._id || decoded.id;
          }

          if (!companyId) {
            companyId = decoded.companyId || decoded.company?._id || decoded.orgId;
          }
        } catch (error) {
          console.warn('⚠️ Failed to decode JWT token for save:', error);
        }
      }
    }

    if (!employeeId) validationErrors.push('Employee ID is missing');
    if (!companyId) validationErrors.push('Company ID is missing');
    if (!editingRecord.date) validationErrors.push('Date is missing');

    console.log('🔍 EXTRACTED IDs WITH FALLBACKS:', {
      employeeId,
      companyId,
      selectedEmployee: selectedEmployeeForReport?._id,
      selectedCompany: localStorage.getItem('selectedCompanyId'),
      originalEmployee: editingRecord.employee,
      originalCompany: editingRecord.company,
      isSyntheticRecord
    });

    if (validationErrors.length > 0) {
      console.error('❌ VALIDATION ERRORS:', validationErrors);
      showNotification(`Validation errors: ${validationErrors.join(', ')}`, 'error');
      return;
    }

    // Prepare data for API using extracted IDs
    const attendanceData = {
      employee: employeeId,
      company: companyId,
      date: editingRecord.date,
      inTime: editingRecord.inTime ? new Date(editingRecord.inTime).toISOString() : null,
      outTime: editingRecord.outTime ? new Date(editingRecord.outTime).toISOString() : null,
      inLocation: editingRecord.inLocation || null,
      outLocation: editingRecord.outLocation || null,
      notes: editingRecord.notes || null,
      status: editingRecord.status,
      workingTime: calculateWorkingMinutes(editingRecord.inTime, editingRecord.outTime)
    };

    console.log('💾 PREPARED ATTENDANCE DATA:');
    console.log('📋 Final Data:', JSON.stringify(attendanceData, null, 2));
    console.log('🕒 Time Calculations:', {
      inTime: editingRecord.inTime,
      outTime: editingRecord.outTime,
      inTimeISO: attendanceData.inTime,
      outTimeISO: attendanceData.outTime,
      workingTimeDisplay: calculateEnhancedWorkingTime(editingRecord.inTime, editingRecord.outTime),
      workingTimeMinutes: attendanceData.workingTime
    });

    let success = false;

    if (isNewRecord) {
      console.log('🚀 CREATING NEW ATTENDANCE RECORD...');
      console.log(' Reason: ' + (isSyntheticRecord ? 'Synthetic record (no existing data)' : 'New record'));
      success = await createAttendance(attendanceData);
    } else {
      console.log('🔄 UPDATING EXISTING ATTENDANCE RECORD...');
      success = await updateAttendance(editingRecord.id, attendanceData);
    }

    console.log('📊 SAVE OPERATION RESULT:', success ? 'SUCCESS' : 'FAILED');

    if (success) {
      console.log('✅ Save successful, cleaning up form...');
      setIsEditingAttendance(false);
      setEditingRecord(null);

      // Refresh attendance records
      console.log('🔄 Refreshing attendance records...');
      await fetchEmployeeAttendance(selectedEmployeeForReport._id, localStorage.getItem('selectedCompanyId'));
      console.log('✅ Attendance records refreshed');
    } else {
      console.error('❌ Save failed, keeping form open for retry');
    }
  };

  const handleCancelEdit = () => {
    setIsEditingAttendance(false);
    setEditingRecord(null);
  };

  // 🎯 COMPREHENSIVE HOLIDAY FETCHING FUNCTIONALITY
  const fetchHolidays = async () => {
    // Get company ID with multiple fallbacks
    let companyId = localStorage.getItem('selectedCompanyId');
    const token = localStorage.getItem('authToken') || localStorage.getItem('accessToken');

    if (!companyId && token) {
      try {
        const decoded = jwtDecode(token);
        companyId = decoded.companyId ||
          decoded.company?._id ||
          decoded.company ||
          (decoded.role === 'company' ? decoded.id : null);
        console.log('🔄 Fallback company ID from token:', companyId);
      } catch (e) {
        console.error('Failed to decode token for fallback company ID');
      }
    }

    if (!companyId) {
      console.log('Company data not available for holiday fetching');
      return;
    }

    if (!token) {
      console.log('🔍No access token found for holiday fetching');
      setHolidaysError('No access token found. Please log in.');
      return;
    }

    setLoadingHolidays(true);
    setHolidaysError(null);

    try {
      console.log('🚀 FETCHING HOLIDAYS FOR COMPANY:', companyId);

      // JWT token validation
      let decoded;
      try {
        decoded = jwtDecode(token);
        console.log('🔍 HOLIDAY FETCH TOKEN DECODED:', {
          id: decoded.id,
          role: decoded.role,
          companyId: decoded.companyId || 'Not in token',
          exp: new Date(decoded.exp * 1000).toLocaleString()
        });
      } catch (tokenError) {
        console.error('❌ Invalid token for holiday fetch:', tokenError);
        localStorage.removeItem('authToken');
        localStorage.removeItem('accessToken');
        setHolidaysError('Invalid token. Please log in again.');
        return;
      }

      const response = await axios.get(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/holidaycreation/company/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          timeout: 15000,
          validateStatus: (status) => status < 500
        }
      );

      console.log('¡ HOLIDAYS API RESPONSE:', {
        status: response.status,
        statusText: response.statusText,
        dataType: typeof response.data,
        dataLength: Array.isArray(response.data) ? response.data.length : 'Not array',
        data: response.data
      });

      // Handle authentication errors
      if (response.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('accessToken');
        setHolidaysError('Session expired. Please log in again.');
        return;
      }

      if (response.status === 403) {
        setHolidaysError('Access denied. Please check your permissions.');
        return;
      }

      if (response.status === 404) {
        console.log('📅 No holidays found for company');
        setHolidays([]);
        return;
      }

      // Handle different response formats
      let holidayRecords = [];
      if (Array.isArray(response.data)) {
        holidayRecords = response.data;
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        holidayRecords = response.data.data;
      } else if (response.data?.holidays && Array.isArray(response.data.holidays)) {
        holidayRecords = response.data.holidays;
      } else if (response.data?.data) {
        holidayRecords = [response.data.data];
      } else if (response.data) {
        holidayRecords = [response.data];
      }

      console.log('🎯 PROCESSED HOLIDAYS:', {
        totalHolidays: holidayRecords.length,
        holidays: holidayRecords.map((holiday, index) => ({
          index: index + 1,
          id: holiday._id || holiday.id,
          name: holiday.name || holiday.holidayName || holiday.title,
          date: holiday.date || holiday.holidayDate,
          description: holiday.description || holiday.details,
          type: holiday.type || holiday.holidayType || 'General',
          isActive: holiday.isActive !== undefined ? holiday.isActive : true,
          company: holiday.company || 'Not specified'
        }))
      });

      // Helper function to format date as YYYY-MM-DD in local time
      const formatDateLocal = (date) => {
        if (!date || isNaN(date.getTime())) return null;
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };

      // Helper function to parse various date formats robustly
      const parseHolidayDate = (dateStr) => {
        if (!dateStr) return null;

        // Try standard parsing first
        let d = new Date(dateStr);
        if (!isNaN(d.getTime()) && d.getFullYear() > 2000) return d;

        // Extract DD/MM/YYYY using regex
        const dateRegex = /(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/;
        const match = String(dateStr).match(dateRegex);

        if (match) {
          const day = parseInt(match[1], 10);
          const month = parseInt(match[2], 10) - 1;
          const year = parseInt(match[3], 10);
          d = new Date(year, month, day);
          if (!isNaN(d.getTime())) return d;
        }

        return null;
      };

      // Process and validate holiday data
      const processedHolidays = holidayRecords
        .filter(holiday => {
          if (!holiday) return false;
          return holiday.date || holiday.holidayDate || holiday.startDate;
        })
        .map(holiday => {
          const holidayDateStr = holiday.date || holiday.holidayDate || holiday.startDate;
          const parsedDate = parseHolidayDate(holidayDateStr);

          if (!parsedDate) return null;

          const startDateStr = holiday.startDate || holidayDateStr;
          const endDateStr = holiday.endDate || startDateStr;

          const startDate = parseHolidayDate(startDateStr) || parsedDate;
          const endDate = parseHolidayDate(endDateStr) || startDate;

          return {
            _id: holiday._id || holiday.id,
            name: holiday.name || holiday.holidayName || holiday.title || 'Holiday',
            date: formatDateLocal(parsedDate),
            startDate: formatDateLocal(startDate),
            endDate: formatDateLocal(endDate),
            description: holiday.description || holiday.details || '',
            type: holiday.type || holiday.holidayType || 'General',
            isActive: holiday.isActive !== undefined ? holiday.isActive : true,
            company: holiday.company,
            originalData: holiday
          };
        })
        .filter(holiday => holiday && holiday.isActive);

      console.log('✅ FINAL PROCESSED HOLIDAYS:', {
        count: processedHolidays.length,
        holidays: processedHolidays
      });

      setHolidays(processedHolidays);

      if (processedHolidays.length > 0) {
        console.log(`✅ Loaded ${processedHolidays.length} company holidays`);
      }

    } catch (error) {
      console.error('❌ HOLIDAY FETCH ERROR:', error);

      if (error.response) {
        const status = error.response.status;
        let errorMessage = 'Failed to load company holidays.';

        switch (status) {
          case 401:
            localStorage.removeItem('authToken');
            localStorage.removeItem('accessToken');
            errorMessage = 'Session expired. Please log in again.';
            break;
          case 403:
            errorMessage = 'Access denied to holiday data.';
            break;
          case 404:
            errorMessage = 'No holidays found for your company.';
            setHolidays([]); // Set empty array for 404
            break;
          case 429:
            errorMessage = 'Too many requests. Please try again later.';
            break;
          case 500:
            errorMessage = 'Server error. Please try again later.';
            break;
          default:
            errorMessage = `Error ${status}: ${error.response.data?.message || 'Unknown error'}`;
        }

        setHolidaysError(errorMessage);
      } else if (error.request) {
        setHolidaysError('Network error. Please check your internet connection.');
      } else {
        setHolidaysError('Unexpected error loading holidays.');
      }
    } finally {
      setLoadingHolidays(false);
    }
  };

  // FETCH COMPANY DATA FOR WEEKLY HOLIDAYS
  const fetchCompanyData = async () => {
    const companyId = localStorage.getItem('selectedCompanyId');
    if (!companyId) {
      console.log('Company ID not available for company data fetching');
      return;
    }

    const token = localStorage.getItem('authToken') || localStorage.getItem('accessToken');
    if (!token) {
      console.log('🔍No access token found for company data fetching');
      return;
    }

    try {
      console.log('🚀 FETCHING COMPANY DATA FOR WEEKLY HOLIDAYS:', companyId);

      const response = await axios.get(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/companies/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          timeout: 10000
        }
      );

      console.log('¡ COMPANY DATA API RESPONSE:', {
        status: response.status,
        data: response.data,
        weeklyHoliday: response.data?.weeklyHoliday || response.data?.data?.weeklyHoliday,
        weeklyHolidays: response.data?.weeklyHolidays || response.data?.data?.weeklyHolidays
      });

      // Handle different response formats
      let company = response.data;
      if (response.data?.data) {
        company = response.data.data;
      }

      setCompanyData(company);
      console.log('✅ COMPANY DATA LOADED:', {
        companyId: company._id || company.id,
        companyName: company.name || company.companyName,
        weeklyHoliday: company.weeklyHoliday,
        weeklyHolidays: company.weeklyHolidays
      });

    } catch (error) {
      console.error('❌ COMPANY DATA FETCH ERROR:', error);

      if (error.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('accessToken');
      }
    }
  };

  const handleEditFieldChange = (field, value) => {
    setEditingRecord(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // —ï DELETE ATTENDANCE
  const deleteAttendance = async (attendanceId) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      showNotification('No access token found. Please log in.', 'error');
      return false;
    }

    try {
      console.log('—ï DELETING ATTENDANCE:', attendanceId);

      const response = await axios.delete(
        `https://greenyellow-nightingale-241896.hostingersite.com/api/attendance/${attendanceId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 15000
        }
      );

      console.log('✅ ATTENDANCE DELETED:', response.data);
      showNotification('Attendance record deleted successfully!', 'success');

      // Refresh attendance records
      if (selectedEmployeeForReport) {
        await fetchEmployeeAttendance(selectedEmployeeForReport._id, localStorage.getItem('selectedCompanyId'));
      }

      return true;
    } catch (err) {
      console.error('❌ Error deleting attendance:', err);
      const errorMessage = err.response?.data?.message || err.message || 'Failed to delete attendance record';
      showNotification(errorMessage, 'error');

      if (err.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        window.location.href = '/login';
      }

      return false;
    }
  };

  const handleDeleteAttendance = async (recordId) => {
    if (window.confirm('Are you sure you want to delete this attendance record?')) {
      await deleteAttendance(recordId);
    }
  };

  const years = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i);

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  // Function to get department name by ID
  const getDepartmentName = (departmentId) => {
    if (departmentId === 'all') return 'All Departments';

    // Check if it's a real department from API
    const department = departments.find(dept => dept._id === departmentId);
    return department ? (department.departmentName || department.name) : 'N/A';
  };

  // Enhanced department filtering function for multiple departments support
  const checkDepartmentMatch = (employee, targetDepartmentId) => {
    if (targetDepartmentId === 'all' || employee.department === 'all') {
      return true;
    }

    // Skip the "All Employees" option
    if (employee._id === 'all') {
      return false;
    }

    // Handle multiple departments using the stored departmentIds array
    if (employee.departmentIds && employee.departmentIds.length > 0) {
      const match = employee.departmentIds.some(deptId =>
        String(deptId) === String(targetDepartmentId)
      );

      if (match) {
        console.log(`✅ EMPLOYEE ${employee.displayName} MATCHES DEPARTMENT ${targetDepartmentId}`, {
          employeeDepartments: employee.departmentIds,
          targetDepartment: targetDepartmentId
        });
      }

      return match;
    }

    // Fallback for single department
    if (employee.departmentId) {
      return String(employee.departmentId) === String(targetDepartmentId);
    }

    // Final fallback
    if (employee.department) {
      const empDeptId = typeof employee.department === 'object'
        ? employee.department._id
        : employee.department;
      return String(empDeptId) === String(targetDepartmentId);
    }

    return false;
  };

  // Get employees filtered by selected department with multiple department support
  const filteredEmployeeData = employees.filter(emp => {
    // Enhanced department filter with multiple department support
    const matchesDepartment = checkDepartmentMatch(emp, selectedDepartment);

    // Handle employee filter
    const matchesEmployee = selectedEmployee === 'all' ||
      emp._id === selectedEmployee;

    // Debug logging for filtering
    if (selectedDepartment !== 'all') {
      console.log(`🔍 FILTERING EMPLOYEE:`, {
        employeeId: emp._id,
        employeeName: emp.teamMemberName || emp.name,
        selectedDepartment,
        isMultipleDepartments: emp.isMultipleDepartments,
        departmentCount: emp.departmentCount,
        allDepartmentIds: emp.allDepartments?.map(d => d._id),
        matchesDepartment,
        finalMatch: matchesDepartment && matchesEmployee
      });
    }

    return matchesDepartment && matchesEmployee;
  });

  const filteredLateAbsentData = attendanceData.lateAbsent.filter(item => {
    // Enhanced department filtering for late/absent data
    let matchesDepartment = selectedDepartment === 'all' || item.department === selectedDepartment;

    // If basic match fails, check if employee has multiple departments
    if (!matchesDepartment && selectedDepartment !== 'all') {
      const employee = employees.find(emp => emp.teamMemberName === item.name || emp.name === item.name);
      if (employee) {
        matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);
      }
    }

    const matchesEmployee = selectedEmployee === 'all' ||
      (typeof item.name === 'string' &&
        employees.some(emp => emp._id === selectedEmployee && emp.teamMemberName === item.name));
    return matchesDepartment && matchesEmployee;
  });

  const filteredWorkSummaryData = attendanceData.workSummary
    .filter(item => {
      // Enhanced department filtering for work summary data
      let matchesDepartment = selectedDepartment === 'all' || item.department === selectedDepartment;

      // If basic match fails, check if employee has multiple departments
      if (!matchesDepartment && selectedDepartment !== 'all') {
        const employee = employees.find(emp => emp.teamMemberName === item.name || emp.name === item.name);
        if (employee) {
          matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);
        }
      }

      const matchesEmployee = selectedEmployee === 'all' ||
        (typeof item.name === 'string' &&
          employees.some(emp => emp._id === selectedEmployee && emp.teamMemberName === item.name));
      return matchesDepartment &&
        matchesEmployee &&
        (new Date(item.date).getFullYear() === selectedYear) &&
        (new Date(item.date).getMonth() === selectedMonth) &&
        (!selectedDate || item.date === selectedDate) &&
        (employeeSearch === '' || item.name.toLowerCase().includes(employeeSearch.toLowerCase()));
    });

  const filteredDailyAttendanceData = attendanceData.dailyAttendance
    .filter(item => {
      // Enhanced department filtering for daily attendance data
      let matchesDepartment = selectedDepartment === 'all' || item.department === selectedDepartment;

      // If basic match fails, check if employee has multiple departments
      if (!matchesDepartment && selectedDepartment !== 'all') {
        const employee = employees.find(emp => emp.teamMemberName === item.name || emp.name === item.name);
        if (employee) {
          matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);
        }
      }

      const matchesEmployee = selectedEmployee === 'all' ||
        (typeof item.name === 'string' &&
          employees.some(emp => emp._id === selectedEmployee && emp.teamMemberName === item.name));
      return matchesDepartment &&
        matchesEmployee &&
        (new Date(item.date).getFullYear() === selectedYear) &&
        (new Date(item.date).getMonth() === selectedMonth) &&
        (!selectedDate || item.date === selectedDate) &&
        (employeeSearch === '' || item.name.toLowerCase().includes(employeeSearch.toLowerCase()));
    });

  const handleViewDetails = (record) => {
    setSelectedRecord(record);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRecord(null);
  };

  const closeDeptModal = () => {
    setIsDeptModalOpen(false);
    setSelectedDeptEmployees([]);
    setSelectedDeptName('');
  };

  const fetchEmployeesByDepartment = async (deptId, deptName) => {
    if (deptId === 'all') return;

    setLoading(true);
    const token = localStorage.getItem('authToken');

    try {
      // Enhanced filtering for employees by department (including multiple departments)
      const deptEmployees = employees.filter(emp =>
        emp._id !== 'all' && checkDepartmentMatch(emp, deptId)
      );

      console.log('DEPARTMENT EMPLOYEES FILTERED:', {
        departmentId: deptId,
        departmentName: deptName,
        totalEmployees: employees.length - 1, // -1 for 'all' option
        matchingEmployees: deptEmployees.length,
        employeesWithMultipleDepts: deptEmployees.filter(emp => emp.isMultipleDepartments).length
      });

      setSelectedDeptEmployees(deptEmployees);
      setSelectedDeptName(deptName);
      setIsDeptModalOpen(true);
    } catch (err) {
      console.error('Error fetching department employees:', err);
      setError(`Failed to fetch department employees: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Report Type Selector */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
          <button
            onClick={() => setActiveReport('employeeCard')}
            className={`p-4 rounded-xl shadow-md transition-all duration-200 flex flex-col items-center ${activeReport === 'employeeCard' ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg transform scale-105' : 'bg-white text-gray-700 hover:shadow-lg'}`}
          >
            <div className="font-semibold text-sm md:text-base">📊 Employee Cards</div>
            <div className="text-xs mt-1 opacity-80">Individual attendance</div>
          </button>
          <button
            onClick={() => setActiveReport('department')}
            className={`p-4 rounded-xl shadow-md transition-all duration-200 flex flex-col items-center ${activeReport === 'department' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg transform scale-105' : 'bg-white text-gray-700 hover:shadow-lg'}`}
          >
            <div className="font-semibold text-sm md:text-base">Department Report</div>
            <div className="text-xs mt-1 opacity-80">Summary by department</div>
          </button>
        </div>

        {/* Report Content Area */}
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6">
          {/* Filters for relevant reports */}
          {(activeReport === 'workSummary' || activeReport === 'dailyAttendance') && (
            <div className="mb-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label htmlFor="company-select" className="block text-sm font-medium text-gray-700 mb-1">Company:</label>
                <select
                  id="company-select"
                  value={selectedCompany}
                  disabled={companies.length <= 1}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 disabled:opacity-75 disabled:cursor-not-allowed"
                >
                  {companies.map(company => (
                    <option key={company.id} value={company.id}>{company.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="department-select" className="block text-sm font-medium text-gray-700 mb-1">
                  Filter by Department:
                  {selectedDepartment !== 'all' && (
                    <span className="ml-2 px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
                      {filteredEmployeeData.length - 1} employees found
                    </span>
                  )}
                </label>
                <select
                  id="department-select"
                  value={selectedDepartment}
                  onChange={(e) => {
                    console.log('🔄 DEPARTMENT FILTER CHANGED:', {
                      from: selectedDepartment,
                      to: e.target.value,
                      departmentName: departments.find(d => d._id === e.target.value)?.name || 'All Departments'
                    });
                    setSelectedDepartment(e.target.value);
                  }}
                  className={`w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${selectedDepartment === 'all'
                    ? 'border-gray-300 bg-gray-50'
                    : 'border-blue-300 bg-blue-50'
                    }`}
                >
                  {loading ? (
                    <option>Loading departments...</option>
                  ) : error ? (
                    <option>Error loading departments</option>
                  ) : (
                    departments.map(dept => {
                      // Count employees in this department (including multiple departments)
                      const employeeCount = employees.filter(emp =>
                        emp._id !== 'all' && checkDepartmentMatch(emp, dept._id || dept.id)
                      ).length;

                      return (
                        <option key={dept._id || dept.id} value={dept._id || dept.id}>
                          {dept.departmentName || dept.name}
                        </option>
                      );
                    })
                  )}
                </select>
                {selectedDepartment !== 'all' && (
                  <div className="mt-1 text-xs text-blue-600">
                    ℹ️ï Includes employees with multiple departments
                  </div>
                )}
              </div>

              {(activeReport === 'workSummary' || activeReport === 'dailyAttendance') && (
                <>
                  <div>
                    <label htmlFor="year-select" className="block text-sm font-medium text-gray-700 mb-1">Select Year:</label>
                    <select
                      id="year-select"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
                    >
                      {years.map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label htmlFor="month-select" className="block text-sm font-medium text-gray-700 mb-1">Select Month:</label>
                    <select
                      id="month-select"
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
                    >
                      {months.map((month, index) => (
                        <option key={index} value={index}>{month}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label htmlFor="date-select" className="block text-sm font-medium text-gray-700 mb-1">Select Date:</label>
                    <input
                      id="date-select"
                      type="date"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
                    />
                  </div>
                  <div>
                    <label htmlFor="employee-search" className="block text-sm font-medium text-gray-700 mb-1">Search Employee:</label>
                    <input
                      id="employee-search"
                      type="text"
                      value={employeeSearch}
                      onChange={(e) => setEmployeeSearch(e.target.value)}
                      placeholder="Search by employee name..."
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
                    />
                  </div>
                </>
              )}
            </div>
          )}


          {/* Department-wise Report */}
          {activeReport === 'department' && (
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold text-gray-800">📊 Department-wise Attendance {deptViewMode === 'card' ? 'Summary' : 'Grid'}</h2>

                {/* View Toggle Buttons for Department */}
                <div className="flex items-center space-x-2 bg-gray-100 rounded-lg p-1">
                  <button
                    onClick={() => setDeptViewMode('card')}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${deptViewMode === 'card'
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                      }`}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14-7H5m14 14H5" />
                    </svg>
                    <span>📋 Card View</span>
                  </button>
                  <button
                    onClick={() => setDeptViewMode('grid')}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${deptViewMode === 'grid'
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                      }`}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                    </svg>
                    <span>📊 Grid View</span>
                  </button>
                </div>
              </div>

              {/* Debug Information */}
              <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                <div className="text-sm text-yellow-800">
                  <strong>🔍 Debug Info:</strong> Departments: {departments.length}, Employees: {employees.length}, Stats: {departmentStats.length}
                </div>
                <div className="text-xs text-yellow-600 mt-1">
                  Selected Date: {new Date(selectedDate).toLocaleDateString('en-GB')} | Active Report: {activeReport}
                </div>
                <div className="flex gap-2 mt-2">
                  {departments.length === 0 && (
                    <button
                      onClick={async () => {
                        console.log('🔄 MANUAL REFRESH DEPARTMENTS');
                        const companyId = localStorage.getItem('selectedCompanyId');
                        if (companyId) {
                          await fetchDepartments(companyId);
                        }
                      }}
                      className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
                    >
                      🔄 Load Departments
                    </button>
                  )}
                  {employees.length === 0 && (
                    <button
                      onClick={async () => {
                        console.log('🔄 MANUAL REFRESH EMPLOYEES');
                        const companyId = localStorage.getItem('selectedCompanyId');
                        if (companyId) {
                          await fetchEmployees(companyId);
                        }
                      }}
                      className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
                    >
                      🔄 Load Employees
                    </button>
                  )}
                  {departmentStats.length === 0 && departments.length > 0 && employees.length > 0 && (
                    <button
                      onClick={() => {
                        console.log('🔄 MANUAL REFRESH DEPARTMENT STATS');
                        fetchDepartmentStats();
                      }}
                      className="bg-yellow-600 text-white px-3 py-1 rounded text-xs hover:bg-yellow-700"
                    >
                      🔄 Refresh Stats
                    </button>
                  )}
                  <button
                    onClick={async () => {
                      console.log('🔄 REFRESH ALL DATA');
                      const companyId = localStorage.getItem('selectedCompanyId');
                      if (companyId) {
                        setLoading(true);
                        try {
                          await Promise.all([
                            fetchEmployees(companyId),
                            fetchDepartments(companyId),
                            fetchEmployeeReportData(companyId)
                          ]);
                        } catch (error) {
                          console.error('❌ Error refreshing data:', error);
                        } finally {
                          setLoading(false);
                        }
                      }
                    }}
                    className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700"
                  >
                    🔄 Refresh All Data
                  </button>
                </div>
              </div>

              {/* Card View for Departments */}
              {deptViewMode === 'card' && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {(() => {
                    // Enhanced display logic with fallback
                    console.log('📊 DEPARTMENT STATS DISPLAY CHECK:', {
                      departmentStatsLength: departmentStats.length,
                      departmentsLength: departments.length,
                      employeesLength: employees.length,
                      departmentStats: departmentStats,
                      departments: departments.map(d => ({ id: d._id, name: d.name || d.departmentName }))
                    });

                    if (departmentStats.length > 0) {
                      // Show actual department stats
                      return departmentStats.map(dept => (
                        <div key={dept._id} className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5 shadow border border-blue-100 hover:shadow-md transition-shadow">
                          <h3 className="font-bold text-lg text-gray-800 mb-3 capitalize">{dept.name}</h3>
                          <div className="space-y-2">
                            <div className="flex justify-between">
                              <span className="text-gray-600">Employees:</span>
                              <span className="font-semibold">{dept.employees}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Present:</span>
                              <span className="font-semibold text-green-600">{dept.present}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Absent:</span>
                              <span className="font-semibold text-red-600">{dept.absent}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Half Day:</span>
                              <span className="font-semibold text-orange-600">{dept.halfDay || 0}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Late Arrivals:</span>
                              <span className="font-semibold text-yellow-600">{dept.late}</span>
                            </div>
                            <button
                              onClick={() => fetchEmployeesByDepartment(dept._id, dept.name)}
                              className="mt-3 w-full bg-blue-50 hover:bg-blue-100 text-blue-600 font-medium py-2 px-4 rounded-lg transition-colors text-sm"
                            >
                              View Employees
                            </button>
                            <div className="pt-2 mt-2 border-t border-blue-200">
                              <div className="flex justify-between items-center">
                                <span className="text-gray-600">Attendance Rate:</span>
                                <span className="font-semibold text-blue-600 text-lg">
                                  {dept.attendanceRate || 0}%
                                </span>
                              </div>
                              <div className="text-xs text-gray-500 mt-1">
                                For {new Date(selectedDate).toLocaleDateString('en-IN', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      ));
                    } else if (departments.length > 0) {
                      // Show departments with basic employee counts as fallback
                      return departments
                        .filter(dept => dept._id !== 'all')
                        .map(dept => {
                          const employeeCount = employees.filter(emp => {
                            if (Array.isArray(emp.department)) {
                              return emp.department.some(d =>
                                (typeof d === 'object' ? d._id : d) === dept._id
                              );
                            } else {
                              const empDeptId = typeof emp.department === 'object'
                                ? emp.department._id
                                : emp.department;
                              return empDeptId === dept._id;
                            }
                          }).length;

                          return (
                            <div key={dept._id} className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl p-5 shadow border border-gray-200 hover:shadow-md transition-shadow">
                              <h3 className="font-bold text-lg text-gray-800 mb-3 capitalize">{dept.name || dept.departmentName}</h3>
                              <div className="space-y-2">
                                <div className="flex justify-between">
                                  <span className="text-gray-600">Employees:</span>
                                  <span className="font-semibold">{employeeCount}</span>
                                </div>
                                <div className="flex justify-between">
                                  <span className="text-gray-600">Present:</span>
                                  <span className="font-semibold text-gray-400">Loading...</span>
                                </div>
                                <div className="flex justify-between">
                                  <span className="text-gray-600">Absent:</span>
                                  <span className="font-semibold text-gray-400">Loading...</span>
                                </div>
                                <div className="flex justify-between">
                                  <span className="text-gray-600">Half Day:</span>
                                  <span className="font-semibold text-gray-400">Loading...</span>
                                </div>
                                <button
                                  onClick={() => {
                                    console.log('🔄 REFRESH STATS FOR DEPARTMENT:', dept.name);
                                    fetchDepartmentStats();
                                  }}
                                  className="mt-3 w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition-colors text-sm"
                                >
                                  🔄 Load Attendance Data
                                </button>
                                <div className="pt-2 mt-2 border-t border-gray-200">
                                  <div className="text-xs text-gray-500">
                                    Click "Load Attendance Data" to fetch statistics
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        });
                    } else {
                      // No departments available
                      return (
                        <div className="col-span-full text-center py-8">
                          <div className="text-gray-400 text-6xl mb-4"></div>
                          <h3 className="text-lg font-medium text-gray-600 mb-2">No Departments Found</h3>
                          <p className="text-gray-500 mb-4">No departments are available to display attendance statistics.</p>
                          <button
                            onClick={() => {
                              console.log('🔄 REFRESH ALL DATA');
                              window.location.reload();
                            }}
                            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
                          >
                            🔄 Refresh Page
                          </button>
                        </div>
                      );
                    }
                  })()
                  }
                </div>
              )}

              {/* Grid View for Departments */}
              {deptViewMode === 'grid' && (
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                  {(() => {
                    const statsToShow = departmentStats.length > 0 ? departmentStats :
                      departments.filter(dept => dept._id !== 'all').map(dept => {
                        const employeeCount = employees.filter(emp => {
                          if (Array.isArray(emp.department)) {
                            return emp.department.some(d =>
                              (typeof d === 'object' ? d._id : d) === dept._id
                            );
                          } else {
                            const empDeptId = typeof emp.department === 'object'
                              ? emp.department._id
                              : emp.department;
                            return empDeptId === dept._id;
                          }
                        }).length;

                        return {
                          _id: dept._id,
                          name: dept.name || dept.departmentName,
                          employees: employeeCount,
                          present: 'Loading...',
                          absent: 'Loading...',
                          halfDay: 'Loading...',
                          late: 'Loading...',
                          attendanceRate: 'Loading...'
                        };
                      });

                    return statsToShow.length > 0 ? (
                      <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          {/* Table Header */}
                          <thead className="bg-gradient-to-r from-blue-50 to-indigo-50">
                            <tr>
                              <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                Department
                              </th>
                              <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                👥 Employees
                              </th>
                              <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                ✅ Present
                              </th>
                              <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                ❌ Absent
                              </th>
                              <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                • Half Day
                              </th>
                              <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                Late
                              </th>
                              <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                📊 Rate
                              </th>
                              <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                                š™ï Actions
                              </th>
                            </tr>
                          </thead>

                          {/* Table Body */}
                          <tbody className="bg-white divide-y divide-gray-200">
                            {statsToShow.map((dept, index) => (
                              <tr key={dept._id} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
                                }`}>
                                {/* Department Name Column */}
                                <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                  <div className="flex items-center">
                                    <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md flex-shrink-0">
                                      {dept.name.charAt(0).toUpperCase()}
                                    </div>
                                    <div className="ml-4">
                                      <div className="text-sm font-medium text-gray-900 capitalize">
                                        {dept.name}
                                      </div>
                                      <div className="text-sm text-gray-500">
                                        {new Date(selectedDate).toLocaleDateString('en-IN', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric'
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                {/* Employees Count Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <span className="text-lg font-bold text-gray-800">{dept.employees}</span>
                                </td>

                                {/* Present Count Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <span className="text-lg font-bold text-green-600">
                                    {typeof dept.present === 'string' ? dept.present : dept.present}
                                  </span>
                                </td>

                                {/* Absent Count Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <span className="text-lg font-bold text-red-600">
                                    {typeof dept.absent === 'string' ? dept.absent : dept.absent}
                                  </span>
                                </td>

                                {/* Half Day Count Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <span className="text-lg font-bold text-orange-600">
                                    {typeof dept.halfDay === 'string' ? dept.halfDay : (dept.halfDay || 0)}
                                  </span>
                                </td>

                                {/* Late Count Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <span className="text-lg font-bold text-yellow-600">
                                    {typeof dept.late === 'string' ? dept.late : dept.late}
                                  </span>
                                </td>

                                {/* Attendance Rate Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <span className={`text-lg font-bold ${typeof dept.attendanceRate === 'string' ? 'text-gray-400' :
                                    (dept.attendanceRate || 0) >= 90 ? 'text-green-600' :
                                      (dept.attendanceRate || 0) >= 75 ? 'text-yellow-600' :
                                        'text-red-600'
                                    }`}>
                                    {typeof dept.attendanceRate === 'string' ? dept.attendanceRate : `${dept.attendanceRate || 0}%`}
                                  </span>
                                </td>

                                {/* Actions Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center">
                                  <div className="flex justify-center space-x-2">
                                    {typeof dept.present === 'string' ? (
                                      <button
                                        onClick={() => {
                                          console.log('🔄 REFRESH STATS FOR DEPARTMENT:', dept.name);
                                          fetchDepartmentStats();
                                        }}
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-lg transition-colors text-sm font-medium"
                                      >
                                        🔄 Load Data
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() => fetchEmployeesByDepartment(dept._id, dept.name)}
                                        className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 text-sm font-medium"
                                      >
                                        👥 View Employees
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="text-center py-12">
                        <div className="text-gray-400 text-6xl mb-4"></div>
                        <h3 className="text-lg font-medium text-gray-600 mb-2">No Departments Found</h3>
                        <p className="text-gray-500 mb-4">No departments are available to display attendance statistics.</p>
                        <button
                          onClick={() => {
                            console.log('🔄 REFRESH ALL DATA');
                            window.location.reload();
                          }}
                          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
                        >
                          🔄 Refresh Page
                        </button>
                      </div>
                    );
                  })()
                  }
                </div>
              )}
            </div>
          )}

          {/* Employee Cards Report */}
          {activeReport === 'employeeCard' && (
            <div>
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center space-x-4">
                  <h2 className="text-xl font-semibold text-gray-800">📊 Employee Attendance {viewMode === 'card' ? 'Cards' : 'Grid'}</h2>
                  {selectedDepartment !== 'all' && (
                    <div className="flex items-center space-x-2">
                      <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                        {departments.find(d => d._id === selectedDepartment)?.name || 'Selected Department'}
                      </span>
                      <span className="px-2 py-1 bg-gray-100 text-gray-600 rounded-full text-xs">
                        {employeeReportData.filter(emp => checkDepartmentMatch(emp, selectedDepartment)).length} employees
                      </span>
                    </div>
                  )}
                </div>

                {/* View Toggle Buttons */}
                <div className="flex items-center space-x-2 bg-gray-100 rounded-lg p-1">
                  <button
                    onClick={() => setViewMode('card')}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${viewMode === 'card'
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                      }`}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14-7H5m14 14H5" />
                    </svg>
                    <span>📋 Card View</span>
                  </button>
                  <button
                    onClick={() => setViewMode('grid')}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${viewMode === 'grid'
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                      }`}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                    </svg>
                    <span>📊 Grid View</span>
                  </button>
                </div>
              </div>
              {/* Card View */}
              {viewMode === 'card' && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {employeeReportData.length > 0 ? (
                    employeeReportData
                      .filter(employee => {
                        // Filter out inactive employees
                        if (employee.isActive === false) {
                          return false;
                        }

                        // Apply department filter to employee cards
                        const matchesDepartment = checkDepartmentMatch(employee, selectedDepartment);

                        // Debug logging for employee card filtering
                        if (selectedDepartment !== 'all') {
                          console.log(`📋 FILTERING EMPLOYEE CARD:`, {
                            employeeId: employee._id,
                            employeeName: employee.displayName,
                            isActive: employee.isActive,
                            selectedDepartment,
                            isMultipleDepartments: employee.isMultipleDepartments,
                            departmentCount: employee.departmentCount,
                            allDepartmentIds: employee.allDepartments?.map(d => d._id),
                            matchesDepartment
                          });
                        }

                        return matchesDepartment;
                      })
                      .map(employee => (
                        <div
                          key={employee._id}
                          className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 shadow-lg border border-green-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                          onClick={() => handleEmployeeSelect(employee)}
                        >
                          <div className="flex items-center mb-4">
                            <div className="w-14 h-14 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-md">
                              {(employee.displayName || employee.teamMemberName || employee.name || 'N').charAt(0).toUpperCase()}
                            </div>
                            <div className="ml-4 flex-1">
                              <h3 className="font-bold text-gray-800 text-base leading-tight">
                                {employee.displayName || employee.teamMemberName || employee.name || 'Unknown Employee'}
                              </h3>
                              <p className="text-sm text-gray-600 mt-1">{employee.email || 'No email provided'}</p>
                            </div>
                          </div>

                          <div className="space-y-3">
                            <div className="bg-white rounded-lg p-3 border border-green-100">
                              <div className="text-sm">
                                <span className="text-gray-600 font-medium flex items-center mb-2">
                                  Department{employee.isMultipleDepartments ? 's' : ''}:
                                  {employee.isMultipleDepartments && (
                                    <span className="ml-2 px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full text-xs">
                                      {employee.departmentCount}
                                    </span>
                                  )}
                                </span>
                                {employee.isMultipleDepartments ? (
                                  <ScrollingDepartments
                                    departments={employee.departmentNames}
                                    employeeId={employee._id}
                                  />
                                ) : (
                                  <div className="font-semibold text-gray-800">
                                    {employee.departmentName || employee.department?.name || 'No Department'}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="bg-white rounded-lg p-3 border border-green-100">
                              <div className="flex justify-between items-center text-sm">
                                <span className="text-gray-600 font-medium">ž Phone:</span>
                                <span className="font-semibold text-gray-800 text-right flex-1 ml-2">
                                  {employee.phone !== 'N/A' ? employee.phone : 'No phone provided'}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="mt-4 pt-4 border-t border-green-200">
                            {/* Current Month Header */}
                            <div className="text-center mb-3">
                              <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                📅 {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                              </div>
                            </div>

                            <div className="grid grid-cols-2 gap-3 text-center">
                              <div className="bg-white rounded-lg p-2 border border-green-100">
                                <div className="text-lg font-bold text-green-600">{employee.presentDays || 0}</div>
                                <div className="text-xs text-gray-600">Present</div>
                                {employee.lateCount > 0 && (
                                  <div className="text-xs text-orange-500 mt-1">+{employee.lateCount} late</div>
                                )}
                              </div>
                              <div className="bg-white rounded-lg p-2 border border-red-100">
                                <div className="text-lg font-bold text-red-600">{employee.absentDays || 0}</div>
                                <div className="text-xs text-gray-600">Absent</div>
                                {employee.halfDayCount > 0 && (
                                  <div className="text-xs text-yellow-600 mt-1">+{employee.halfDayCount} half</div>
                                )}
                              </div>
                            </div>

                            <div className="mt-3 bg-white rounded-lg p-2 text-center border border-blue-100">
                              <div className="text-sm font-medium text-gray-600">Attendance Rate</div>
                              <div className="text-lg font-bold text-blue-600">{employee.attendanceRate || 0}%</div>
                              <div className="text-xs text-gray-500 mt-1">
                                {employee.totalRecords || 0} records this month
                              </div>
                            </div>
                          </div>

                          <div className="mt-4">
                            <button className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-2 px-4 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 text-sm font-medium">
                              📊 View Attendance Details
                            </button>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div className="col-span-full text-center py-12">
                      <div className="text-gray-400 text-6xl mb-4">👥</div>
                      <h3 className="text-lg font-medium text-gray-600 mb-2">No Employees Found</h3>
                      <p className="text-gray-500">No employee data available for this company.</p>
                    </div>
                  )}
                </div>
              )}

              {/* Grid View */}
              {viewMode === 'grid' && (
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                  {employeeReportData.length > 0 ? (
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        {/* Table Header */}
                        <thead className="bg-gradient-to-r from-green-50 to-emerald-50">
                          <tr>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                              👤 Employee
                            </th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                              Department
                            </th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                              ž Contact
                            </th>
                            <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                              ✅ Present
                            </th>
                            <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                              ❌ Absent
                            </th>
                            <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                              📊 Rate
                            </th>
                            <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                              š™ï Actions
                            </th>
                          </tr>
                        </thead>

                        {/* Table Body */}
                        <tbody className="bg-white divide-y divide-gray-200">
                          {employeeReportData
                            .filter(employee => checkDepartmentMatch(employee, selectedDepartment))
                            .map((employee, index) => (
                              <tr key={employee._id} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
                                }`}>
                                {/* Employee Column */}
                                <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                  <div className="flex items-center">
                                    <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md flex-shrink-0">
                                      {(employee.displayName || employee.teamMemberName || employee.name || 'N').charAt(0).toUpperCase()}
                                    </div>
                                    <div className="ml-4">
                                      <div className="text-sm font-medium text-gray-900">
                                        {employee.displayName || employee.teamMemberName || employee.name || 'Unknown Employee'}
                                      </div>
                                      <div className="text-sm text-gray-500">
                                        {employee.email || 'No email provided'}
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                {/* Department Column */}
                                <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                  <div className="text-sm text-gray-900">
                                    {employee.isMultipleDepartments ? (
                                      <div className="space-y-1">
                                        <ScrollingDepartments
                                          departments={employee.departmentNames}
                                          employeeId={employee._id}
                                        />
                                      </div>
                                    ) : (
                                      <div className="font-medium">
                                        {employee.departmentName || employee.department?.name || 'No Department'}
                                      </div>
                                    )}
                                  </div>
                                </td>

                                {/* Contact Column */}
                                <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                  <div className="text-sm text-gray-900">
                                    {employee.phone !== 'N/A' ? (
                                      <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md font-medium">
                                        {employee.phone}
                                      </span>
                                    ) : (
                                      <span className="text-gray-400 italic">No phone</span>
                                    )}
                                  </div>
                                </td>

                                {/* Present Days Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <div className="flex flex-col items-center">
                                    <span className="text-lg font-bold text-green-600">{employee.presentDays || 0}</span>
                                    {employee.lateCount > 0 && (
                                      <span className="text-xs text-orange-500 mt-1">+{employee.lateCount} late</span>
                                    )}
                                  </div>
                                </td>

                                {/* Absent Days Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <div className="flex flex-col items-center">
                                    <span className="text-lg font-bold text-red-600">{employee.absentDays || 0}</span>
                                    {employee.halfDayCount > 0 && (
                                      <span className="text-xs text-yellow-600 mt-1">+{employee.halfDayCount} half</span>
                                    )}
                                  </div>
                                </td>

                                {/* Attendance Rate Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center border-r border-gray-100">
                                  <div className="flex flex-col items-center">
                                    <span className={`text-lg font-bold ${(employee.attendanceRate || 0) >= 90 ? 'text-green-600' :
                                      (employee.attendanceRate || 0) >= 75 ? 'text-yellow-600' :
                                        'text-red-600'
                                      }`}>
                                      {employee.attendanceRate || 0}%
                                    </span>
                                    <span className="text-xs text-gray-500 mt-1">
                                      {employee.totalRecords || 0} records
                                    </span>
                                  </div>
                                </td>

                                {/* Actions Column */}
                                <td className="px-6 py-4 whitespace-nowrap text-center">
                                  <button
                                    onClick={() => handleEmployeeSelect(employee)}
                                    className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 text-sm font-medium"
                                  >
                                    📊 View Details
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-12">
                      <div className="text-gray-400 text-6xl mb-4">👥</div>
                      <h3 className="text-lg font-medium text-gray-600 mb-2">No Employees Found</h3>
                      <p className="text-gray-500">No employee data available for this company.</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}


        </div>

        {/* Department Employees Modal */}
        {isDeptModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[9999]">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
              <div className="p-6 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-xl font-semibold text-gray-800">
                  Employees in {selectedDeptName}
                </h3>
                <button
                  onClick={closeDeptModal}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="p-6 overflow-y-auto flex-1">
                {loading ? (
                  <div className="flex justify-center items-center h-32">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                  </div>
                ) : selectedDeptEmployees.length > 0 ? (
                  <div className="space-y-4">
                    {selectedDeptEmployees.map(emp => (
                      <div key={emp._id} className="bg-gray-50 p-4 rounded-lg flex items-center justify-between">
                        <div>
                          <h4 className="font-medium text-gray-900">{emp.teamMemberName || emp.name}</h4>
                          <p className="text-sm text-gray-500">{emp.email || 'No email provided'}</p>
                        </div>
                        <span className="text-sm px-3 py-1 bg-blue-100 text-blue-800 rounded-full">
                          Employee
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <p className="text-gray-500">No employees found in this department.</p>
                  </div>
                )}
              </div>
              <div className="p-4 border-t border-gray-200 flex justify-end">
                <button
                  onClick={closeDeptModal}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 📊 EMPLOYEE ATTENDANCE MODAL */}
        {isEmployeeModalOpen && selectedEmployeeForReport && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[5000]">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[95vh] flex flex-col">
              {/* Modal Header */}
              <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-t-xl">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="text-2xl font-bold">📊 {selectedEmployeeForReport.displayName || selectedEmployeeForReport.teamMemberName || selectedEmployeeForReport.name}</h3>
                    <p className="text-green-100 mt-1">Attendance Records & Management</p>
                  </div>
                  <button
                    onClick={closeEmployeeModal}
                    className="text-white hover:text-green-200 transition-colors"
                  >
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto flex-1">
                {/* Employee Info */}
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-6 mb-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="bg-white rounded-lg p-4 border border-green-100">
                      <span className="text-sm font-medium text-gray-600 flex items-center">
                        📧 Email:
                      </span>
                      <p className="text-gray-800 font-semibold mt-1">
                        {selectedEmployeeForReport.email || 'No email provided'}
                      </p>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-green-100">
                      <span className="text-sm font-medium text-gray-600 flex items-center">
                        Department:
                      </span>
                      <p className="text-gray-800 font-semibold mt-1">
                        {selectedEmployeeForReport.departmentName ||
                          selectedEmployeeForReport.department?.name ||
                          'No Department'}
                      </p>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-green-100">
                      <span className="text-sm font-medium text-gray-600 flex items-center">
                        ž Phone:
                      </span>
                      <p className="text-gray-800 font-semibold mt-1">
                        {selectedEmployeeForReport.phone !== 'N/A' ?
                          selectedEmployeeForReport.phone :
                          'No phone provided'}
                      </p>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-green-100">
                      <span className="text-sm font-medium text-gray-600 flex items-center">
                        🕒 Shift:
                      </span>
                      <p className="text-gray-800 font-semibold mt-1">
                        {loadingShiftInfo ? (
                          <span className="text-blue-600">Loading...</span>
                        ) : employeeShiftInfo ? (
                          <span className="text-green-700">{employeeShiftInfo.shiftName}</span>
                        ) : (
                          <span className="text-gray-500">No shift assigned</span>
                        )}
                      </p>
                      {employeeShiftInfo && employeeShiftInfo.shiftTiming && (
                        <p className="text-xs text-gray-500 mt-1">
                          {employeeShiftInfo.shiftTiming}
                        </p>
                      )}
                    </div>
                  </div>
                </div>



                {/* 🔍 FILTER CONTROLS */}
                <div className="mb-6 bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-6 border border-gray-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 flex items-center">
                      🔍 Filter Attendance Records
                    </h4>
                    <div className="flex items-center space-x-4">
                      {/* View Toggle Buttons for Attendance Records */}
                      <div className="flex items-center space-x-2 bg-white rounded-lg p-1 shadow-sm">
                        <button
                          onClick={() => setAttendanceViewMode('table')}
                          className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${attendanceViewMode === 'table'
                            ? 'bg-blue-500 text-white shadow-sm'
                            : 'text-gray-600 hover:text-gray-800'
                            }`}
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 6h18m-9 8h9" />
                          </svg>
                          <span>📊 Table</span>
                        </button>
                        <button
                          onClick={() => setAttendanceViewMode('calendar')}
                          className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${attendanceViewMode === 'calendar'
                            ? 'bg-blue-500 text-white shadow-sm'
                            : 'text-gray-600 hover:text-gray-800'
                            }`}
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          <span>📅 Calendar</span>
                        </button>
                      </div>
                      <button
                        onClick={() => {
                          setSelectedFilterMonth(new Date().getMonth());
                          setSelectedFilterYear(new Date().getFullYear());
                          setAttendanceStatusFilter('all');
                        }}
                        className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                      >
                        🔄 Reset Filters
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* Month Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        📅 Month
                      </label>
                      <select
                        value={selectedFilterMonth}
                        onChange={(e) => setSelectedFilterMonth(parseInt(e.target.value))}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        {Array.from({ length: 12 }, (_, i) => (
                          <option key={i} value={i}>
                            {new Date(2024, i, 1).toLocaleDateString('en-US', { month: 'long' })}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Year Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        📅 Year
                      </label>
                      <select
                        value={selectedFilterYear}
                        onChange={(e) => setSelectedFilterYear(parseInt(e.target.value))}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        {Array.from({ length: 5 }, (_, i) => {
                          const year = new Date().getFullYear() - 2 + i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    {/* Status Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        📊 Status
                      </label>
                      <select
                        value={attendanceStatusFilter}
                        onChange={(e) => setAttendanceStatusFilter(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="all">All Status</option>
                        <option value="present">✅ Present</option>
                        <option value="absent">❌ Absent</option>
                        <option value="half-day"> Half Day</option>
                        <option value="holiday">🎉 Holiday</option>
                      </select>
                    </div>

                  </div>
                </div>

                {/* Attendance Records */}
                {loadingAttendance ? (
                  <div className="flex justify-center items-center h-32">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
                    <span className="ml-3 text-gray-600">Loading attendance records...</span>
                  </div>
                ) : attendanceError ? (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
                    <div className="text-red-600 text-lg mb-2">⚠️ Error Loading Attendance</div>
                    <p className="text-red-700">{attendanceError}</p>
                    <button
                      onClick={() => fetchEmployeeAttendance(selectedEmployeeForReport._id)}
                      className="mt-3 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
                    >
                      🔄 Try Again
                    </button>
                  </div>
                ) : (() => {
                  // Generate dates for selected month/year and merge with attendance records
                  const monthDates = generateMonthDates(selectedFilterMonth, selectedFilterYear);
                  const mergedAttendanceData = mergeAttendanceWithMonthDates(attendanceRecords, monthDates, holidays, companyData);

                  // Apply status filtering with enhanced logic
                  let filteredAttendanceData = mergedAttendanceData;

                  // Debug: Log all unique statuses to understand the data
                  const uniqueStatuses = [...new Set(mergedAttendanceData.map(record => record.status))];
                  console.log('🔍 UNIQUE STATUSES IN DATA:', uniqueStatuses);
                  console.log('🎯 CURRENT FILTER:', attendanceStatusFilter);

                  if (attendanceStatusFilter !== 'all') {
                    filteredAttendanceData = mergedAttendanceData.filter(record => {
                      const status = (record.status || '').toLowerCase().trim();

                      // Debug: Log each record being filtered
                      console.log('🔍 FILTERING RECORD:', {
                        date: record.date,
                        originalStatus: record.status,
                        normalizedStatus: status,
                        isHoliday: record.isHoliday,
                        filterType: attendanceStatusFilter
                      });

                      let matches = false;

                      switch (attendanceStatusFilter) {
                        case 'present':
                          matches = status === 'present' ||
                            (record.inTime && record.outTime && !status.includes('absent') && !status.includes('holiday'));
                          break;
                        case 'absent':
                          matches = status === 'absent' ||
                            status === 'future' ||
                            (!record.inTime && !record.isHoliday && !record.isFuture);
                          break;
                        case 'half-day':
                          matches = status === 'half day' ||
                            status === 'half-day' ||
                            status === 'halfday' ||
                            status.includes('half');
                          break;
                        case 'holiday':
                          matches = record.isHoliday ||
                            record.isCompanyHoliday ||
                            record.isWeeklyHoliday ||
                            status === 'company holiday' ||
                            status === 'weekly holiday' ||
                            status.includes('holiday');
                          break;
                        default:
                          matches = true;
                      }

                      console.log('✅ FILTER RESULT:', { matches, reason: `Status: ${status}, Filter: ${attendanceStatusFilter}` });
                      return matches;
                    });
                  }

                  console.log('🔍 FILTERED ATTENDANCE DATA:', {
                    originalCount: mergedAttendanceData.length,
                    filteredCount: filteredAttendanceData.length,
                    filterType: attendanceStatusFilter,
                    month: selectedFilterMonth + 1,
                    year: selectedFilterYear,
                    sampleFilteredRecords: filteredAttendanceData.slice(0, 3).map(r => ({
                      date: r.date,
                      status: r.status,
                      inTime: r.inTime,
                      outTime: r.outTime,
                      isHoliday: r.isHoliday
                    }))
                  });

                  return filteredAttendanceData.length > 0 ? (
                    <div className="space-y-4">
                      {/* Filter Status Indicator */}
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-4">
                            <span className="text-blue-800 font-medium">
                              📊 Showing {filteredAttendanceData.length} records for:
                            </span>
                            <div className="flex items-center space-x-2">
                              <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                                📅 {new Date(selectedFilterYear, selectedFilterMonth, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                              </span>
                              {attendanceStatusFilter !== 'all' && (
                                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                                  📊 {attendanceStatusFilter === 'present' ? '✅ Present' :
                                    attendanceStatusFilter === 'absent' ? '❌ Absent' :
                                      attendanceStatusFilter === 'half-day' ? ' Half Day' :
                                        attendanceStatusFilter === 'holiday' ? '🎉 Holiday' : attendanceStatusFilter}
                                </span>
                              )}
                              <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium">
                                {attendanceViewMode === 'table' ? '📊 Table View' : '📅 Calendar View'}
                              </span>
                            </div>
                          </div>
                          {(selectedFilterMonth !== new Date().getMonth() || selectedFilterYear !== new Date().getFullYear()) && (
                            <button
                              onClick={() => {
                                setSelectedFilterMonth(new Date().getMonth());
                                setSelectedFilterYear(new Date().getFullYear());
                              }}
                              className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                            >
                              🔄 Clear Filters
                            </button>
                          )}
                        </div>
                      </div>

                      {/* 📊 ATTENDANCE TABLE VIEW */}
                      {attendanceViewMode === 'table' && (
                        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                          <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                              {/* Table Header */}
                              <thead className="bg-gradient-to-r from-green-50 to-emerald-50">
                                <tr>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                    📅 Date
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                    •˜ In Time
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                    •• Out Time
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                    ï Working Time
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-r border-gray-200">
                                    📊 Status
                                  </th>
                                  <th className="px-6 py-4 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                                    š™ï Actions
                                  </th>
                                </tr>
                              </thead>

                              {/* Table Body */}
                              <tbody className="bg-white divide-y divide-gray-200">
                                {filteredAttendanceData.map((record, index) => (
                                  <tr key={record.id || record._id || `date-${record.date}`} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
                                    } ${record.hasAttendance ? '' : 'bg-gray-50'
                                    } ${record.isToday ? 'ring-2 ring-blue-200 bg-blue-50' : ''
                                    } ${record.isHoliday ? 'ring-2 ring-purple-200 bg-purple-50' : ''
                                    }`}>
                                    {/* Date Column */}
                                    <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                      <div className="flex flex-col">
                                        <div className={`text-sm font-medium ${record.isToday ? 'text-blue-700 font-bold' :
                                          record.isCompanyHoliday ? 'text-purple-700 font-bold' :
                                            record.isWeeklyHoliday ? 'text-red-600 font-bold' :
                                              record.hasAttendance ? 'text-gray-900' : 'text-gray-500'
                                          }`}>
                                          {record.date ? new Date(record.date).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric'
                                          }) : 'N/A'}
                                        </div>
                                        {record.isToday && (
                                          <div className="text-xs text-blue-600 font-medium mt-1">
                                            📅 Today
                                          </div>
                                        )}
                                        {record.isCompanyHoliday && (
                                          <div className="text-xs text-purple-600 font-medium mt-1">
                                            🎉 {record.holidayName}
                                          </div>
                                        )}
                                        {record.isWeeklyHoliday && !record.isCompanyHoliday && (
                                          <div className="text-xs text-red-600 font-medium mt-1">
                                            📅 {record.weeklyHolidayName}
                                          </div>
                                        )}
                                        {!record.hasAttendance && !record.isFuture && !record.isHoliday && (
                                          <div className="text-xs text-red-500 mt-1">
                                            ❌ No Record
                                          </div>
                                        )}
                                        {record.isFuture && (
                                          <div className="text-xs text-gray-400 mt-1">
                                            Future
                                          </div>
                                        )}
                                      </div>
                                    </td>

                                    {/* In Time Column */}
                                    <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                      <div className="text-sm text-gray-900">
                                        {(() => {
                                          if (!record.hasAttendance) {
                                            return (
                                              <span className={`px-2 py-1 rounded-md text-xs font-medium ${record.isFuture ? 'bg-gray-100 text-gray-500' : 'bg-red-100 text-red-600'
                                                }`}>
                                                {record.isFuture ? ' Future' : '❌ No Punch In'}
                                              </span>
                                            );
                                          }

                                          // Use the same formatting logic as edit modal
                                          let displayTime = '-';

                                          if (record.inTime) {
                                            // If it's a datetime-local format (from edit), format it
                                            if (record.inTime.includes('T') && !record.inTime.includes('Z')) {
                                              displayTime = formatDateTimeForDisplay(record.inTime);
                                            } else {
                                              // Use existing display time or format UTC time
                                              displayTime = record.displayInTime || formatTimeUTC(record.inTime);
                                            }
                                          }

                                          return displayTime && displayTime !== '-' ? (
                                            <span className="bg-green-100 text-green-800 px-2 py-1 rounded-md font-medium">
                                              {displayTime}
                                            </span>
                                          ) : (
                                            <span className="text-gray-400 italic">-</span>
                                          );
                                        })()}
                                      </div>
                                    </td>

                                    {/* Out Time Column */}
                                    <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                      <div className="text-sm text-gray-900">
                                        {(() => {
                                          if (!record.hasAttendance) {
                                            return (
                                              <span className={`px-2 py-1 rounded-md text-xs font-medium ${record.isFuture ? 'bg-gray-100 text-gray-500' : 'bg-red-100 text-red-600'
                                                }`}>
                                                {record.isFuture ? ' Future' : '❌ No Punch Out'}
                                              </span>
                                            );
                                          }

                                          // Use the same formatting logic as edit modal
                                          let displayTime = '-';

                                          if (record.outTime) {
                                            // If it's a datetime-local format (from edit), format it
                                            if (record.outTime.includes('T') && !record.outTime.includes('Z')) {
                                              displayTime = formatDateTimeForDisplay(record.outTime);
                                            } else {
                                              // Use existing display time or format UTC time
                                              displayTime = record.displayOutTime || formatTimeUTC(record.outTime);
                                            }
                                          }

                                          return displayTime && displayTime !== '-' ? (
                                            <span className="bg-red-100 text-red-800 px-2 py-1 rounded-md font-medium">
                                              {displayTime}
                                            </span>
                                          ) : (
                                            <span className="text-gray-400 italic">-</span>
                                          );
                                        })()}
                                      </div>
                                    </td>

                                    {/* Working Time Column */}
                                    <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                      <div className="text-sm font-semibold text-gray-900">
                                        {record.inTime && record.outTime ? (
                                          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md font-medium">
                                            {calculateEnhancedWorkingTime(record.inTime, record.outTime)}
                                          </span>
                                        ) : record.workingTime && record.workingTime !== '--:--' ? (
                                          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md font-medium">
                                            {record.workingTime}
                                          </span>
                                        ) : (
                                          <span className="text-gray-400 italic">--:--</span>
                                        )}
                                      </div>
                                    </td>

                                    {/* Status Column - Shift-Based Calculation */}
                                    <td className="px-6 py-4 whitespace-nowrap border-r border-gray-100">
                                      {(() => {
                                        // Check if it's a holiday first
                                        if (record.isHoliday) {
                                          return (
                                            <div className="space-y-1">
                                              <span className="inline-flex px-3 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                                                🎉 Holiday
                                              </span>
                                              <div className="text-xs text-orange-600">
                                                {record.holidayName}
                                              </div>
                                              {record.holidayType && (
                                                <div className="text-xs text-gray-500">
                                                  {record.holidayType}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }

                                        // Calculate shift-based status for non-holiday dates
                                        // If it's a synthetic record (no inTime), use its pre-defined status
                                        const shiftStatus = (record.hasAttendance || record.inTime)
                                          ? calculateShiftBasedStatus(record, employeeShiftInfo)
                                          : { status: record.status || 'Absent' };
                                        const statusText = shiftStatus.status;
                                        const completionPercentage = shiftStatus.completionPercentage;

                                        // Determine badge color based on calculated status
                                        const badgeClass =
                                          statusText === 'Present' ? 'bg-green-100 text-green-800' :
                                            statusText === 'Absent' ? 'bg-red-100 text-red-800' :
                                              statusText === 'Late' ? 'bg-yellow-100 text-yellow-800' :
                                                statusText === 'Half Day' ? 'bg-orange-100 text-orange-800' :
                                                  statusText === 'Incomplete' ? 'bg-blue-100 text-blue-800' :
                                                    statusText === 'Future' ? 'bg-gray-100 text-gray-800' :
                                                      'bg-gray-100 text-gray-800';

                                        return (
                                          <div className="space-y-1">
                                            <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${badgeClass}`}>
                                              {statusText}
                                            </span>
                                            {employeeShiftInfo && completionPercentage > 0 && (
                                              <div className="text-xs text-gray-500">
                                                {completionPercentage}% of shift
                                              </div>
                                            )}
                                            {employeeShiftInfo && shiftStatus.workingHours && shiftStatus.shiftHours && (
                                              <div className="text-xs text-gray-400">
                                                {shiftStatus.workingHours}h / {shiftStatus.shiftHours}h
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })()}
                                    </td>

                                    {/* Actions Column */}
                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                      <div className="flex justify-center space-x-2">
                                        {/* View Button */}
                                        <button
                                          onClick={() => {
                                            const formattedDate = record.date ? new Date(record.date).toLocaleDateString('en-US', {
                                              weekday: 'long',
                                              year: 'numeric',
                                              month: 'long',
                                              day: 'numeric'
                                            }) : 'N/A';

                                            // Use the same formatting logic as table display
                                            let displayInTime = '-';
                                            let displayOutTime = '-';

                                            if (record.inTime) {
                                              if (record.inTime.includes('T') && !record.inTime.includes('Z')) {
                                                displayInTime = formatDateTimeForDisplay(record.inTime);
                                              } else {
                                                displayInTime = record.displayInTime || formatTimeUTC(record.inTime);
                                              }
                                            }

                                            if (record.outTime) {
                                              if (record.outTime.includes('T') && !record.outTime.includes('Z')) {
                                                displayOutTime = formatDateTimeForDisplay(record.outTime);
                                              } else {
                                                displayOutTime = record.displayOutTime || formatTimeUTC(record.outTime);
                                              }
                                            }

                                            const calculatedWorkingTime = record.inTime && record.outTime ?
                                              calculateEnhancedWorkingTime(record.inTime, record.outTime) :
                                              (record.workingTime || '--:--');

                                            // Calculate shift-based status for popup
                                            const shiftStatus = calculateShiftBasedStatus(record, employeeShiftInfo);

                                            let shiftInfo = '';
                                            if (employeeShiftInfo) {
                                              shiftInfo = `\n\n🕒 Shift Analysis:\nShift Hours: ${shiftStatus.shiftHours}h\nWorked Hours: ${shiftStatus.workingHours}h\nCompletion: ${shiftStatus.completionPercentage}%\nCalculated Status: ${shiftStatus.status}\nReason: ${shiftStatus.reason}`;
                                            }

                                            setShowAlert(`📋 Attendance Details:\n\nDate: ${formattedDate}\nIn Time: ${displayInTime}\nOut Time: ${displayOutTime}\nWorking Hours: ${calculatedWorkingTime}\nOriginal Status: ${record.status || 'Unknown'}\nIn Location: ${record.inLocation || '-'}\nOut Location: ${record.outLocation || '-'}\nNotes: ${record.notes || 'No notes'}${shiftInfo}`);
                                          }}
                                          className="text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded-md text-sm font-medium transition-colors"
                                          title="View Details"
                                        >
                                          ï View
                                        </button>

                                        {/* Edit Button */}
                                        <button
                                          onClick={() => {
                                            if (record.isFuture) {
                                              setShowAlert(' Cannot edit future dates.\n\nYou can only edit attendance records for past and current dates.');
                                              return;
                                            }
                                            handleEditAttendance(record);
                                          }}
                                          className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${record.isFuture
                                            ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
                                            : 'text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100'
                                            }`}
                                          title={record.isFuture ? 'Cannot edit future dates' : 'Edit Record'}
                                          disabled={record.isFuture}
                                        >
                                          ✅ï Edit
                                        </button>

                                        {/* Delete Button */}
                                        <button
                                          onClick={() => {
                                            if (!record.hasAttendance || record.isSynthetic) {
                                              setShowAlert('❌ Cannot delete this record.\n\nThis date has no actual attendance record to delete.');
                                              return;
                                            }
                                            handleDeleteAttendance(record.id || record._id);
                                          }}
                                          className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${!record.hasAttendance || record.isSynthetic
                                            ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
                                            : 'text-red-600 hover:text-red-800 bg-red-50 hover:bg-red-100'
                                            }`}
                                          title={!record.hasAttendance || record.isSynthetic ? 'No record to delete' : 'Delete Record'}
                                          disabled={!record.hasAttendance || record.isSynthetic}
                                        >
                                          —ï Delete
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Table Footer with Summary */}
                          <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
                              {/* Attendance Summary */}
                              <div>
                                <span className="font-medium">📊 Attendance Summary:</span>
                                <div className="mt-1">
                                  {(() => {
                                    // Calculate attendance statistics with unified logic to ensure mutual exclusivity
                                    let presentCount = 0;
                                    let halfDayCount = 0;
                                    let holidayCount = 0;
                                    let absentCount = 0;
                                    let futureCount = 0;
                                    let incompleteCount = 0;
                                    let lateCount = 0;

                                    filteredAttendanceData.forEach(r => {
                                      if (r.isFuture) {
                                        futureCount++;
                                      } else if (r.hasAttendance || r.inTime) {
                                        // Priority 1: Attendance record exists
                                        const shiftStatus = calculateShiftBasedStatus(r, employeeShiftInfo);
                                        const statusText = shiftStatus.status;

                                        if (statusText === 'Present' || statusText === 'Late' || statusText === 'Incomplete') {
                                          presentCount++;
                                        } else if (statusText === 'Half Day') {
                                          halfDayCount++;
                                        } else {
                                          absentCount++;
                                        }
                                      } else if (r.isHoliday) {
                                        // Priority 2: No attendance but is a holiday
                                        holidayCount++;
                                      } else {
                                        // Priority 3: No attendance and not a holiday
                                        absentCount++;
                                      }
                                    });

                                    const totalDays = filteredAttendanceData.length;

                                    return (
                                      <>
                                        Total Days: <strong>{totalDays}</strong> |
                                        Present: <strong className="text-green-600 ml-2">{presentCount}</strong> |
                                        Half Day: <strong className="text-orange-600 ml-2">{halfDayCount}</strong> |
                                        Holidays: <strong className="text-orange-600 ml-2">{holidayCount}</strong> |
                                        Absent: <strong className="text-red-600 ml-2">{absentCount}</strong> |
                                        Future: <strong className="text-gray-600 ml-2">{futureCount}</strong>
                                      </>
                                    );
                                  })()}
                                </div>
                              </div>

                              {/* Working Hours Summary */}
                              <div>
                                <span className="font-medium">ï Working Hours Summary:</span>
                                <div className="mt-1">
                                  {(() => {
                                    // Enhanced working hours calculation
                                    const validRecords = filteredAttendanceData.filter(r => {
                                      return r.hasAttendance && r.inTime && r.outTime && !r.isHoliday && !r.isFuture;
                                    });

                                    console.log('ï WORKING HOURS CALCULATION:', {
                                      totalRecords: filteredAttendanceData.length,
                                      validRecords: validRecords.length,
                                      sampleRecords: validRecords.slice(0, 3).map(r => ({
                                        date: r.date,
                                        inTime: r.inTime,
                                        outTime: r.outTime,
                                        workingTime: r.workingTime
                                      }))
                                    });

                                    const totalMinutes = validRecords.reduce((total, record) => {
                                      const workingMinutes = calculateWorkingMinutes(record.inTime, record.outTime);
                                      return total + workingMinutes;
                                    }, 0);

                                    const totalHours = Math.floor(totalMinutes / 60);
                                    const remainingMinutes = totalMinutes % 60;
                                    const avgMinutes = validRecords.length > 0 ? Math.floor(totalMinutes / validRecords.length) : 0;
                                    const avgHours = Math.floor(avgMinutes / 60);
                                    const avgMins = avgMinutes % 60;

                                    // Calculate attendance rate
                                    const workingDays = filteredAttendanceData.filter(r => !r.isHoliday && !r.isFuture).length;
                                    const attendanceRate = workingDays > 0 ? Math.round((validRecords.length / workingDays) * 100) : 0;

                                    return (
                                      <>
                                        Total: <strong className="text-blue-600">{totalHours}h {remainingMinutes}m</strong> |
                                        Average: <strong className="text-indigo-600 ml-2">{avgHours}h {avgMins}m</strong> |
                                        Days Worked: <strong className="text-green-600 ml-2">{validRecords.length}</strong> |
                                        Rate: <strong className="text-purple-600 ml-2">{attendanceRate}%</strong>
                                      </>
                                    );
                                  })()}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 📅 ATTENDANCE CALENDAR VIEW */}
                      {attendanceViewMode === 'calendar' && (
                        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                          {(() => {
                            // Create calendar grid for the selected month
                            const year = selectedFilterYear;
                            const month = selectedFilterMonth;
                            const firstDay = new Date(year, month, 1);
                            const lastDay = new Date(year, month + 1, 0);
                            const startDate = new Date(firstDay);
                            startDate.setDate(startDate.getDate() - firstDay.getDay()); // Start from Sunday

                            const endDate = new Date(lastDay);
                            endDate.setDate(endDate.getDate() + (6 - lastDay.getDay())); // End on Saturday

                            const calendarDates = [];
                            const currentDate = new Date(startDate);

                            while (currentDate <= endDate) {
                              const dateString = currentDate.toISOString().split('T')[0];
                              const attendanceRecord = filteredAttendanceData.find(record => record.date === dateString);
                              const isCurrentMonth = currentDate.getMonth() === month;
                              const isToday = dateString === new Date().toISOString().split('T')[0];

                              calendarDates.push({
                                date: dateString,
                                dateObj: new Date(currentDate),
                                dayNumber: currentDate.getDate(),
                                isCurrentMonth,
                                isToday,
                                attendanceRecord
                              });

                              currentDate.setDate(currentDate.getDate() + 1);
                            }

                            // Group dates into weeks
                            const weeks = [];
                            for (let i = 0; i < calendarDates.length; i += 7) {
                              weeks.push(calendarDates.slice(i, i + 7));
                            }

                            return (
                              <div className="p-6">
                                {/* Calendar Header */}
                                <div className="mb-6">
                                  <h3 className="text-2xl font-bold text-gray-800 text-center mb-4">
                                    📅 {new Date(year, month, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                                  </h3>

                                  {/* Days of Week Header */}
                                  <div className="grid grid-cols-7 gap-1 mb-2">
                                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                                      <div key={day} className="p-3 text-center font-semibold text-gray-600 bg-gray-50 rounded-lg">
                                        {day}
                                      </div>
                                    ))}
                                  </div>
                                </div>

                                {/* Calendar Grid */}
                                <div className="space-y-1">
                                  {weeks.map((week, weekIndex) => (
                                    <div key={weekIndex} className="grid grid-cols-7 gap-1">
                                      {week.map((dateInfo, dayIndex) => {
                                        const { date, dateObj, dayNumber, isCurrentMonth, isToday, attendanceRecord } = dateInfo;

                                        // Determine cell styling based on attendance status
                                        let cellClass = 'min-h-[120px] p-2 border border-gray-200 rounded-lg transition-all hover:shadow-md cursor-pointer ';
                                        let statusColor = 'bg-gray-50';
                                        let statusIcon = '';
                                        let statusText = '';

                                        if (!isCurrentMonth) {
                                          cellClass += 'opacity-30 ';
                                          statusColor = 'bg-gray-100';
                                        } else if (isToday) {
                                          cellClass += 'ring-2 ring-blue-500 ';
                                        }

                                        if (attendanceRecord) {
                                          if (attendanceRecord.isHoliday) {
                                            statusColor = 'bg-orange-100 border-orange-300';
                                            statusIcon = '🎉';
                                            statusText = 'Holiday';
                                          } else if (attendanceRecord.status === 'Present' || (attendanceRecord.inTime && attendanceRecord.outTime)) {
                                            statusColor = 'bg-green-100 border-green-300';
                                            statusIcon = '✅';
                                            statusText = 'Present';
                                          } else if (attendanceRecord.status === 'Absent' || (!attendanceRecord.inTime && !attendanceRecord.isHoliday)) {
                                            statusColor = 'bg-red-100 border-red-300';
                                            statusIcon = '❌';
                                            statusText = 'Absent';
                                          } else if (attendanceRecord.status?.toLowerCase().includes('half')) {
                                            statusColor = 'bg-yellow-100 border-yellow-300';
                                            statusIcon = '';
                                            statusText = 'Half Day';
                                          } else if (attendanceRecord.status === 'Incomplete' || (attendanceRecord.inTime && !attendanceRecord.outTime)) {
                                            statusColor = 'bg-blue-100 border-blue-300';
                                            statusIcon = '⚠️';
                                            statusText = 'Incomplete';
                                          } else {
                                            statusColor = 'bg-gray-100 border-gray-300';
                                            statusIcon = '';
                                            statusText = 'Unknown';
                                          }
                                        } else if (isCurrentMonth) {
                                          const isFuture = dateObj > new Date();
                                          if (isFuture) {
                                            statusColor = 'bg-gray-50 border-gray-200';
                                            statusIcon = '';
                                            statusText = 'Future';
                                          } else {
                                            statusColor = 'bg-red-50 border-red-200';
                                            statusIcon = '❌';
                                            statusText = 'No Record';
                                          }
                                        }

                                        return (
                                          <div
                                            key={`${weekIndex}-${dayIndex}`}
                                            className={`${cellClass} ${statusColor}`}
                                            onClick={() => {
                                              if (attendanceRecord && isCurrentMonth) {
                                                // Show attendance details in popup
                                                const formattedDate = dateObj.toLocaleDateString('en-US', {
                                                  weekday: 'long',
                                                  year: 'numeric',
                                                  month: 'long',
                                                  day: 'numeric'
                                                });

                                                const displayInTime = attendanceRecord.inTime ?
                                                  (attendanceRecord.displayInTime || formatTimeUTC(attendanceRecord.inTime)) : '-';
                                                const displayOutTime = attendanceRecord.outTime ?
                                                  (attendanceRecord.displayOutTime || formatTimeUTC(attendanceRecord.outTime)) : '-';
                                                const workingTime = attendanceRecord.inTime && attendanceRecord.outTime ?
                                                  calculateEnhancedWorkingTime(attendanceRecord.inTime, attendanceRecord.outTime) : '--:--';

                                                setShowAlert(`📋 Attendance Details:\n\nDate: ${formattedDate}\nStatus: ${attendanceRecord.status || 'Unknown'}\nIn Time: ${displayInTime}\nOut Time: ${displayOutTime}\nWorking Hours: ${workingTime}\nIn Location: ${attendanceRecord.inLocation || '-'}\nOut Location: ${attendanceRecord.outLocation || '-'}\nNotes: ${attendanceRecord.notes || 'No notes'}`);
                                              }
                                            }}
                                          >
                                            {/* Date Number */}
                                            <div className={`text-lg font-bold mb-2 ${isToday ? 'text-blue-600' :
                                              isCurrentMonth ? 'text-gray-800' : 'text-gray-400'
                                              }`}>
                                              {dayNumber}
                                            </div>

                                            {/* Status Info */}
                                            {isCurrentMonth && (
                                              <div className="space-y-1">
                                                <div className="flex items-center justify-center">
                                                  <span className="text-2xl">{statusIcon}</span>
                                                </div>
                                                <div className={`text-xs font-medium text-center ${attendanceRecord?.isHoliday ? 'text-orange-700' :
                                                  attendanceRecord?.status === 'Present' || (attendanceRecord?.inTime && attendanceRecord?.outTime) ? 'text-green-700' :
                                                    attendanceRecord?.status === 'Absent' || (!attendanceRecord?.inTime && !attendanceRecord?.isHoliday) ? 'text-red-700' :
                                                      attendanceRecord?.status?.toLowerCase().includes('half') ? 'text-yellow-700' :
                                                        attendanceRecord?.status === 'Incomplete' ? 'text-blue-700' :
                                                          'text-gray-600'
                                                  }`}>
                                                  {statusText}
                                                </div>

                                                {/* Working Hours */}
                                                {attendanceRecord?.inTime && attendanceRecord?.outTime && (
                                                  <div className="text-xs text-gray-600 text-center mt-1">
                                                    {calculateEnhancedWorkingTime(attendanceRecord.inTime, attendanceRecord.outTime)}
                                                  </div>
                                                )}

                                                {/* Holiday Name */}
                                                {attendanceRecord?.isHoliday && attendanceRecord?.holidayName && (
                                                  <div className="text-xs text-orange-600 text-center mt-1 truncate" title={attendanceRecord.holidayName}>
                                                    {attendanceRecord.holidayName.length > 12 ?
                                                      attendanceRecord.holidayName.substring(0, 12) + '...' :
                                                      attendanceRecord.holidayName}
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  ))}
                                </div>

                                {/* Calendar Legend */}
                                <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                                  <h4 className="text-sm font-semibold text-gray-700 mb-3">📋 Legend:</h4>
                                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 text-xs">
                                    <div className="flex items-center space-x-2">
                                      <div className="w-4 h-4 bg-green-100 border border-green-300 rounded"></div>
                                      <span>✅ Present</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                      <div className="w-4 h-4 bg-red-100 border border-red-300 rounded"></div>
                                      <span>❌ Absent</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                      <div className="w-4 h-4 bg-yellow-100 border border-yellow-300 rounded"></div>
                                      <span> Half Day</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                      <div className="w-4 h-4 bg-orange-100 border border-orange-300 rounded"></div>
                                      <span>🎉 Holiday</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                      <div className="w-4 h-4 bg-blue-100 border border-blue-300 rounded"></div>
                                      <span>⚠️ Incomplete</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                      <div className="w-4 h-4 bg-gray-50 border border-gray-200 rounded"></div>
                                      <span> Future/No Record</span>
                                    </div>
                                  </div>
                                  <div className="mt-3 text-xs text-gray-600">
                                    💡 Click on any date with attendance data to view detailed information
                                  </div>
                                </div>
                              </div>
                            );
                          })()
                          }
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="text-center py-12">
                      <div className="text-gray-400 text-6xl mb-4">📅</div>
                      <h3 className="text-lg font-medium text-gray-600 mb-2">
                        {attendanceStatusFilter !== 'all' ? 'No Records Match Filter' : 'No Attendance Records'}
                      </h3>
                      <p className="text-gray-500">
                        {attendanceStatusFilter !== 'all'
                          ? `No attendance records found with status "${attendanceStatusFilter}" for the selected period.`
                          : 'No attendance records found for this employee.'}
                      </p>
                      {attendanceStatusFilter !== 'all' && (
                        <button
                          onClick={() => setAttendanceStatusFilter('all')}
                          className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
                        >
                          🔄 Show All Records
                        </button>
                      )}
                    </div>
                  );
                })()}
              </div>

              {/* Modal Footer */}
              <div className="p-4 border-t border-gray-200 flex justify-end">
                <button
                  onClick={closeEmployeeModal}
                  className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ✅ï ATTENDANCE EDIT MODAL */}
        {isEditingAttendance && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[50000]">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl">
              <div className="p-6 border-b border-gray-200">
                <h3 className="text-xl font-semibold text-gray-800">
                  {editingRecord?.id || editingRecord?._id ? '✅ï Edit Attendance Record' : 'ž• Add New Attendance Record'}
                </h3>
              </div>

              {/* Validation Status Display */}
              <div className="px-6 pt-4">
                {(() => {
                  const employeeId = editingRecord?.employeeId || editingRecord?.employee?._id || editingRecord?.employee;
                  const companyId = editingRecord?.companyId || editingRecord?.company?._id || editingRecord?.company;
                  const hasValidationErrors = !employeeId || !companyId;

                  if (hasValidationErrors) {
                    return (
                      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                        <div className="flex items-center">
                          <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div className="ml-3">
                            <h3 className="text-sm font-medium text-red-800">Validation Errors</h3>
                            <div className="mt-2 text-sm text-red-700">
                              <ul className="list-disc pl-5 space-y-1">
                                {!employeeId && <li>Employee ID is missing</li>}
                                {!companyId && <li>Company ID is missing</li>}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                        <div className="flex items-center">
                          <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div className="ml-3">
                            <p className="text-sm font-medium text-green-800">
                              ✅ Employee: {selectedEmployeeForReport?.teamMemberName || selectedEmployeeForReport?.name} |
                              Company: {localStorage.getItem('selectedCompanyName') || 'Selected Company'}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })()}
              </div>

              <div className="p-6 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date *</label>
                    <input
                      type="date"
                      value={editingRecord?.date || ''}
                      onChange={(e) => setEditingRecord({ ...editingRecord, date: e.target.value })}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">In Time *</label>
                    <input
                      type="datetime-local"
                      value={editingRecord?.inTime || ''}
                      onChange={(e) => setEditingRecord({ ...editingRecord, inTime: e.target.value })}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Out Time</label>
                    <input
                      type="datetime-local"
                      value={editingRecord?.outTime || ''}
                      onChange={(e) => setEditingRecord({ ...editingRecord, outTime: e.target.value })}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">In Location</label>
                    <input
                      type="text"
                      value={editingRecord?.inLocation || ''}
                      onChange={(e) => setEditingRecord({ ...editingRecord, inLocation: e.target.value })}
                      placeholder="Enter check-in location"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Out Location</label>
                    <input
                      type="text"
                      value={editingRecord?.outLocation || ''}
                      onChange={(e) => setEditingRecord({ ...editingRecord, outLocation: e.target.value })}
                      placeholder="Enter check-out location"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Working Time (Auto-calculated)</label>
                    <input
                      type="text"
                      value={editingRecord?.inTime && editingRecord?.outTime ?
                        calculateEnhancedWorkingTime(editingRecord.inTime, editingRecord.outTime) :
                        '--:--'}
                      readOnly
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-50 text-gray-600"
                      placeholder="Auto-calculated from in/out times"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                    <select
                      value={editingRecord?.status || 'Present'}
                      onChange={(e) => setEditingRecord({ ...editingRecord, status: e.target.value })}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="Present">✅ Present</option>
                      <option value="Absent">❌ Absent</option>
                      <option value="Late"> Late</option>
                      <option value="Half-day">• Half-day</option>
                      <option value="Incomplete">⚠️ Incomplete</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Notes & Remarks</label>
                  <textarea
                    value={editingRecord?.notes || ''}
                    onChange={(e) => setEditingRecord({ ...editingRecord, notes: e.target.value })}
                    placeholder="Add any additional notes, remarks, or comments about this attendance record..."
                    rows={3}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>

              <div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
                <button
                  onClick={() => {
                    setIsEditingAttendance(false);
                    setEditingRecord(null);
                  }}
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveAttendance}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  💾 Save Attendance
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 📢 NOTIFICATION SYSTEM */}
        {notification.show && (
          <div className={`fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg max-w-md ${notification.type === 'success' ? 'bg-green-500 text-white' :
            notification.type === 'error' ? 'bg-red-500 text-white' :
              'bg-blue-500 text-white'
            }`}>
            <div className="flex items-center">
              <span className="mr-2">
                {notification.type === 'success' ? '✅' : notification.type === 'error' ? '❌' : 'ℹ️ï'}
              </span>
              <p>{notification.message}</p>
            </div>
          </div>
        )}

        {/* 📋 ALERT MODAL FOR VIEW DETAILS */}
        {showAlert && (
          <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
            onClick={() => setShowAlert('')}
          >
            <div
              className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 bg-gradient-to-r from-indigo-600 to-blue-600 text-white">
                <h3 className="text-xl font-semibold flex items-center">
                  <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Attendance Details
                </h3>
                <button
                  onClick={() => setShowAlert('')}
                  className="p-2 hover:bg-white hover:bg-opacity-20 rounded-full transition-all duration-200"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 max-h-[70vh] overflow-y-auto">
                <pre className="whitespace-pre-wrap text-sm text-gray-700 font-mono bg-gray-50 p-4 rounded-lg border border-gray-200">
                  {showAlert}
                </pre>
              </div>

              {/* Modal Footer */}
              <div className="p-6 border-t border-gray-200 flex justify-end">
                <button
                  onClick={() => setShowAlert('')}
                  className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AttendanceReports;

